export default {
  common: {
    noFace: 'Sin cara',
    noPermissionTip: 'No tienes permiso para usar esta función. Por favor, compra o renueva para continuar.',
    selected: 'Seleccione',
    open1: 'Abrir',
    doubleClick: 'Haga doble clic',
    inputKeywordSearch: 'Ingrese la búsqueda por palabra clave',
    inputKeywordStartSearch: 'Ingrese la palabra clave para iniciar la búsqueda',
    searchHistory: 'Historial de búsqueda',
    clearHistory: 'Borrar historial',
    notFoundRelatedResults: 'No se encontraron resultados relevantes',
    switch: 'Cambiar',
    searchProductionLine: 'Línea de producción de equipos',
    selectProductionLine: 'Seleccionar línea de producción',
    rotateAngleTip: 'Girar {angle}',
    plankText: 'Panel',
    sendToEzSort: 'Enviar a etiqueta de color',
    downloadEzSort: 'Descargar Zhihui Color Label',
    notDownloadTip: 'Si Zhihua Color Label no se abre normalmente, puede deberse a que no lo ha descargado. Haga clic en el botón a continuación para descargar Zhihui Color Label',
    updateTip: 'Se detectó una actualización de software. ¡Reinicie el gabinete!',
    betaTest: 'Gratis para pruebas internas',
    ersortSpecail: 'Exclusivo para etiqueta de color',
    exclusiveFeature: 'Función exclusiva',
    elementCanBeDragTip: 'Los elementos se pueden arrastrar',
    checkPlankIsConflict: 'Detección del estado del tablero',
    preferenceSaveErr: 'Excepción al guardar preferencias',
    guimen: 'Puerta del gabinete',
    preferenceLoadTip: 'Cargando su configuración de preferencias',
    preferenceLoadErrTip: 'La configuración de preferencias no se pudo cargar, actualice e intente nuevamente para evitar causar errores en su configuración de preferencias.',
    localFileIsBeingWrite: 'Escritura de archivos locales',
    unnamedFile: 'Archivo sin nombre',
    taskMonitor: 'Monitoreo de tareas',
    downloadByType: 'Descargar {type}',
    slotKnifeErr: 'Falta la herramienta de procesamiento especificada en la ranura, verifique la configuración de la línea de producción. 【{msg}】',
    anewChooseCatalog: 'Vuelva a seleccionar el directorio',
    downloadSetting: 'Descargar configuración',
    attention: 'Nota',
    unit: 'Bloquear',
    defaultUse: 'Usar de forma predeterminada',
    defaultChooseUse: 'Seleccionar de forma predeterminada',
    requestFail: 'Solicitud fallida',
    downloadDoneByType: '{type} Descarga completada',
    sysTip: 'Aviso del sistema',
    pleaseChoose: 'Seleccione',
    confirmDelete: 'Confirmar eliminación',
    notDataTipByType: 'Aún no hay datos, comience con {msg}',
    paginationTotalTip: '{current}-{page} elementos/Total {total} elementos',
    chooseAmountData: 'Datos seleccionados {number}',
    moreOperate: 'Más',
    transferByType: 'Transferir {type}',
    clickCopy: 'Haga clic para copiar {type}',
    currentLine: 'Línea actual',
    remark: 'Comentarios',
    customFunction: 'Función personalizada',
    limitedTimeTrial: 'Exención limitada',
    startDate: 'Fecha de inicio',
    endDate: 'Fecha de finalización',
    startTime: 'Hora de inicio',
    endTime: 'Hora de finalización',
    lastMonth: 'Último mes',
    lastSixMonth: 'Último medio año',
    lastYear: 'El año pasado',
    searchByType: 'Ingrese {type} para consultar',
    addTime: 'Agregar hora',
    startArrange: 'Iniciar composición',
    select: 'Seleccionar',
    search: 'Buscar',
    name: 'Nombre',
    plankNo: 'Número de tablero',
    plankName: 'Nombre de tablero',
    orderNo: 'Número de pedido',
    order: 'Orden',
    partNameWithoutRoomCabinet: 'Nombre de tablero (sin sala/gabinete)',
    plankRemark: 'Comentarios del panel',
    room: 'Sala',
    orderAddress: 'Dirección del proyecto',
    matCode: 'Material',
    matCode2: 'Material',
    plankMatCode: 'Material del tablero',
    count: 'Cantidad',
    customer: 'Cliente',
    customerInfo: 'Información del cliente',
    factoryOrderNo: 'Número de pedido de fábrica',
    roomName: 'Nombre de la habitación',
    color: 'Color',
    plankColor: 'Color del tablero',
    plankThick: 'Grosor del tablero',
    plankHighGloss: 'Atributo resaltado',
    thick: 'Grosor',
    front: 'Frente',
    back: 'Reverso',
    slot: 'Ranura',
    hole: 'Orificio',
    hsInfo: '{hole} Orificio {slot} Ranura',
    diameter: 'Diámetro',
    finishedWidth: 'Ancho del producto terminado',
    finishedHeight: 'Largo del producto terminado',
    finishedArea: 'Área del producto terminado (㎡)',
    remarks: 'Comentario',
    remark1: 'Comentario 1',
    remark2: 'Comentario 2',
    remark3: 'Comentario 3',
    remark4: 'Comentario 4',
    remark5: 'Comentario 5',
    remark6: 'Comentario 6',
    remark7: 'Comentario 7',
    remark8: 'Comentario 8',
    remark9: 'Comentario 9',
    remark10: 'Comentario 10',
    remark11: 'Comentario 11',
    remark12: 'Comentario 12',
    remark13: 'Comentario 13',
    remark14: 'Comentario 14',
    remark15: 'Comentario 15',
    remark16: 'Comentario 16',
    texture: 'Textura',
    normal: 'Veta vertical',
    reverse: 'Veta horizontal',
    notCare: 'Sin textura',
    holeSlotsStastic: 'Número de orificios y ranuras',
    edge: {
      title: 'Sellado de bordes',
      info: 'Información sobre sellado de bordes',
      front: 'Borde delantero',
      back: 'Borde trasero',
      left: 'Borde izquierdo',
      right: 'Borde derecho',
      up: 'Borde superior',
      down: 'Borde inferior'
      },
    isSpecial: 'Forma especial',
    notSpecial: 'Forma no especial',
    textOfDoorPlank: 'Panel de puerta',
    textOfNotDoorPlank: 'Panel que no es de puerta',
    isDoorPlank: 'Panel de puerta',
    notDoorPlank: 'Panel sin puerta',
    width: 'Ancho',
    long: 'Largo',
    plankWidth: 'Ancho de tablero',
    plankHeight: 'Largo de tablero',
    shortLong: 'Corto largo del lado',
    shortWidth: 'Ancho del lado corto',
    plankShape: 'Forma de la placa',
    detail: 'Detalles',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    alreadyKnow: 'Lo sé',
    Noprompts: 'No volver a preguntar',
    deep: 'Profundidad',
    other: 'Otros',
    heighGloss: 'Resaltado',
    heighGlossPlank: 'Placa resaltada',
    heighGlossSide: 'Placa resaltada',
    notHeighGloss: 'Sin resaltado',
    notHeighGlossPlank: 'Placa sin alto brillo',
    saveSuccess: 'Guardado exitosamente',
    deleteSuccess: 'Eliminar con éxito',
    addSuccess: 'Agregar con éxito',
    editSuccess: 'Modificar con éxito',
    engraving: 'Máquina de grabado',
    electronicSaw: 'Sierra electrónica',
    glassEquip: 'Máquina cortadora de vidrio',
    labelingMachine: 'Máquina etiquetadora',
    copy: 'Copiar',
    paste: 'Pegar',
    undo: 'Deshacer',
    move: 'Mover',
    PTP: 'PTP',
    dock56FDrill: 'Taladro de cinco y seis caras',
    sideHoleDrill: 'Máquina perforadora lateral',
    combination: 'Equipo combinado',
    integration: 'Máquina todo en uno',
    standardPlank: 'Tablero grande estándar',
    standardMaterial: 'Tablero estándar',
    standardMaterialTip: 'Nota: Después de completar el ajuste de la información del tablero grande, los usuarios en la producción del diseño del gabinete deben reiniciar el cliente del gabinete para aplicar los últimos cambios.',
    specialMaterial: 'Tablero especial',
    specialPlank: 'Tablero especial grande',
    singlePlank: 'Panel único',
    previous: 'Anterior',
    plankInfo: 'Detalles del tablero grande',
    moreResult: 'Más planos de distribución',
    moreResultTip: 'En el tablero grande hay ranuras para el procesamiento de ribetes. El tablero grande no participará en el rediseño',
    ok: 'OK',
    dispersePaibanTip: 'Se detecta que algunos tableros grandes no se pueden distribuir ni componer. ¡Puedes ajustar o cambiar manualmente el plano de diseño para evitar estribos!',
    next: 'Siguiente',
    rate: 'Tasa de utilización',
    paibanBatch: 'Lote de composición tipográfica',
    return: 'Devolver',
    FGNo: 'Número de contrato',
    refresh: 'Actualizar',
    inde: 'Número de serie',
    productionLine: 'Línea de producción',
    operation: 'Operación',
    colorPlaceHolder: 'Presione Enter para crear automáticamente una tarjeta de color',
    saveAndContinue: 'Guardar y continuar',
    reset: 'Restablecer',
    check: 'Consulta',
    inputPlaceholder: 'Por favor ingrese',
    filter: 'Filtrar',
    all: 'Todo',
    exportPDF: 'Exportar PDF',
    exportPic: 'Exportar imagen',
    add: 'Agregar',
    edit: 'Editar',
    delete: 'Eliminar',
    restore: 'Restaurar',
    save: 'Guardar',
    saveSetting: 'Guarde la configuración',
    isHeightGloss: 'Seleccione si es una placa resaltada',
    noSync: 'No sincronizado',
    sync: 'Sincronizado',
    formatSuccess: '{type} Exitoso',
    dataLoading: 'Los datos se están cargando...',
    warmTip: 'Recordatorio',
    importantTip: 'Consejo importante',
    wellcome: 'Bienvenido a la composición tipográfica en la nube',
    timeOut: 'Tiempo de espera de composición tipográfica, si se debe volver a escribir la composición tipográfica',
    notSawKnifeTip: 'Nota: La máquina de sierra y grabado no tiene una "Hoja de sierra transversal" configurada, por lo que no se puede realizar la composición tipográfica. ¡Por favor ve y agrégalo!',
    doorFrameKnifeRadiusErr: 'Ha activado la función "Máquina de grabado de sierra-Corte de marco de puerta". El radio del cuchillo de corte es mayor que el grosor de la hoja de sierra, ¡no se puede realizar la composición tipográfica!',
    doorFrameIrregularPlankErr: 'Ha activado la función "Máquina de grabado de sierra-Corte de marco de puerta". ¡Esta función no admite actualmente la composición tipográfica de paneles irregulares!',
    warning: 'Advertencia',
    export: 'Exportar',
    mark: 'Marcar',
    noMark: 'Desmarcar',
    sawArrange: 'Diseño de corte de sierra',
    directArrange: 'Diseño de corte recto',
    area: 'Área',
    plankNum: 'Código de barras del panel',
    loc: 'Gabinete',
    cutHeight: 'Longitud de corte',
    cutWidth: 'Ancho de corte',
    defaultProduction: 'Línea de producción predeterminada',
    surplusNum: 'Código de barras de material restante',
    tip: 'Consejos',
    history: 'Historia',
    hinge: 'Orificio para bisagra',
    hingeScrew: 'Orificio guía de puerta con bisagra',
    CCPXHole: 'Orificio excéntrico tres en uno',
    stretchHinge: 'Ranura para enderezador y orificio para copa de bisagra',
    stretch: 'Enderezador',
    stretcher: 'Ranura para enderezador',
    eccHole: 'Orificio excéntrico',
    preHole: 'Orificio integrado',
    clothole: 'Orificio pasante para ropa',
    backPlank: 'Ranura en el panel posterior',
    ALS: 'Ranura para manija oculta',
    doorSlot: 'Ranura metálica del panel de la puerta',
    drawerSlot: 'Ranura metálica del cajón',
    lkSlot: 'Ranura para cerradura',
    KC: 'Orificio para pantalones',
    stealth: 'Partes ocultas',
    lightSlot: 'Ranura para luz',
    ConventionalHole: 'Orificio normal',
    Keyhole: 'Orificio para cerradura',
    allHole: 'Todos los orificios en tableros con formas especiales',
    allSlot: 'Todas las ranuras en tableros con formas especiales',
    freedomAllHoleSlot: 'Todos los orificios y ranuras en tableros con formas especiales',
    freedomAllHoleSlotTip: 'Tablero especial: tablero con un ángulo que no es recto',
    millInfo: 'Manija de bocina',
    haiTang: 'Cuerno de begonia',
    FSDrill: 'Taladro de cinco/seis caras',
    engraving2: 'Máquina cortadora',
    xyReverse: 'XYIntercambio de ejes',
    autoXYReverse: 'Adaptación e intercambio automático del equipo de procesamiento de agujeros',
    autoXYReverseTip: 'Al habilitar los datos de procesamiento de la máquina perforadora lateral trasera y el taladro de cinco y seis lados se adaptará automáticamente al intercambio de ejes XY de la máquina de grabado',
    autoXYReverseTip2: 'Nota: PTP aún no es compatible',
    xyReverseTip: 'XY La función de intercambio de ejes aún no es compatible con el material residual tipo L brecha. Úselo con precaución',
    rect: 'Rectángulo',
    Ltype: 'L Forma',
    archive: 'Archive',
    tellPlaceholder: 'Ingrese su número de teléfono móvil',
    knivesStore: 'Almacén de herramientas',
    roll: 'Placa giratoria',
    pause: 'Pausa',
    editTrans: 'Editar traducción',
    translateManager: 'Gestión de traducción',
    grating: 'Rejilla',
    addressEditErr: 'Múltiples pedidos no admiten la modificación de la dirección del proyecto',
    customerEditErr: 'Múltiples pedidos no Soporte para modificar la información del cliente.',
    factoryEditErr: 'Actualmente, los pedidos múltiples no admiten la modificación del número de pedido de fábrica.',
    roomNameEditErr: 'Actualmente no se admite la modificación del nombre de la sala para pedidos múltiples',
    remarkEditErr: 'Actualmente no se admite la modificación de notas de pedido para pedidos múltiples',
    toMaterialList: 'Ir a la lista de materiales',
    deleteFail: 'La eliminación falló, ¡inténtelo nuevamente más tarde!',
    batchRestore: 'Restauración por lotes',
    batchDelete: 'Eliminación de lote',
    workShop: 'Producción del taller',
    FGAdrress: 'Dirección del proyecto/número de contrato',
    cuttingSize: 'Tamaño de corte',
    finishedSize: 'Tamaño del producto terminado',
    labelImg: 'Imagen de etiquetado',
    layoutImg: 'Dibujo de diseño',
    file: 'Archivo',
    folder: 'Carpeta',
    reName: 'Cambiar nombre',
    to: 'a',
    plankUnit: 'Hoja',
    tagTemp: 'Plantilla de etiqueta',
    roomRemark: 'Comentarios de la habitación',
    noModificationPermission: 'Sin permiso de modificación',
    modificationRecord: 'Registro de modificación',
    page: 'Página',
    strip: 'Artículo',
    jump: 'Saltar',
    freeAgreement: 'Descargo de responsabilidad del software',
    preStep: 'Paso anterior',
    nextStep: 'Siguiente paso',
    upload: 'Cargando',
    uploading: 'Cargando',
    iAgree: 'Acepto',
    pleaseSelectPlank: 'Seleccione al menos un panel',
    saveToStoreTip: 'Seleccione al menos un panel sin cortar',
    fileIsNotExist: 'El archivo no existe',
    selectAll: 'Seleccione todo',
    pdfTag: 'PDF Etiqueta',
    tagImage: 'Imagen de etiqueta',
    guigui: 'Guigui',
    gratingSlot: 'Ranura de rejilla',
    deleteTip: 'Estos datos no se pueden restaurar después de eliminarlos. ¿Confirmas eliminar estos datos?',
    deleteError: 'Se produjo un error desconocido y la eliminación falló',
    cancelDelete: 'La eliminación se canceló',
    confirmDeleteTip: 'Después de la eliminación, el panel ingresará la "Placa que se va a componer en la biblioteca, no almacenada en la biblioteca" en la esquina inferior derecha de la página. ¿Estás seguro de eliminar los datos?',
    confirmDeleteBujianTip: 'Después de eliminar, la pieza se ingresará en la esquina inferior derecha de la página en la "Biblioteca de Piezas", ¿está seguro de eliminar los datos?',
    confirmSureDeleteTip: 'Se detecta que existen pequeños paneles del mismo material en la biblioteca actual para ser tipografiados. Después de la eliminación, los paneles pequeños correspondientes en la biblioteca que se van a componer no se mostrarán. Confirme si desea continuar eliminando el panel grande.',
    deleteEmptyTip: 'Si se debe eliminar este tablero grande',
    notCanDelete: 'El material restante que se corta no admite el almacenamiento.',
    new: 'New',
    innerBluneFailure: 'La composición tipográfica en la nube integrada no tiene efecto.',
    deleteBigPlankTip: '¡Hay un tablero pequeño en el último tablero grande y no se puede eliminar!',
    continueExport: 'Ignorar y continuar generando el archivo',
    toCheck: 'Verificar',
    pleaseCheck: 'El resultado del diseño actual tiene conflictos de orificios/salidos del tablero pequeño/profundidad anormal, ¡compruébelo!',
    clampHandCheck: 'Se detecta que los orificios de algunos de sus paneles no pueden evitar la posición de sujeción, ajuste manualmente',
    conflictPartDetail: 'Detalles de los paneles en conflicto',
    colorNotUndefined: 'El color no puede estar vacío',
    materialNotUndefined: 'El material no puede estar vacío',
    newSetting: 'Nueva función',
    downImageErrTip: 'No se pudo exportar la imagen, debido a que la imagen de etiquetado está dividida en diferentes carpetas según la placa grande, debe verificar la etiqueta de la placa pequeña para exportar juntas',
    downNcErrTip: 'La descarga NC falló porque las imágenes etiquetadas están divididas en diferentes carpetas según el tablero grande. Debes verificar la etiqueta del tablero pequeño para exportar juntos.',
    downNcErrTipForSurFolder: 'La descarga NC falló, las imágenes de etiquetado se dividen en diferentes carpetas según el tablero grande y la configuración del archivo del tablero grande del material restante no se puede abrir al mismo tiempo',
    yes: 'Sí',
    no: 'No',
    checkColorPrint: 'Las etiquetas de color están habilitadas actualmente, utilice una impresora a color para imprimir ~',
    colorRules: 'Después de activar la generación de etiquetas de color, los pedidos/habitaciones/gabinetes/paneles de puertas se distinguirán por color. Actualmente, la etiqueta de color admite un máximo de 12 datos del mismo tipo. Las reglas específicas son las siguientes:',
    greyPart: 'La parte gris de la etiqueta a la derecha es el área',
    region: 'Area',
    notSame: 'Diferentes áreas {regionName} tienen diferentes colores',
    doorTip: 'El gris es el panel de la puerta, el blanco es el panel que no es la puerta',
    exist: 'Existe',
    limitNotEffect: 'Más de 12 datos, la etiqueta de color no es válida',
    hoverTip: 'La imagen actual es un sufijo bmp, el formato de codificación es blanco y negro y la etiqueta de color la imagen no se puede emitir',
    lock: 'Bloquear',
    unlock: 'Desbloquear',
    batchLock: 'Bloqueo/desbloqueo de lotes',
    surplusLock: 'Bloqueo de material restante',
    surplusUnlock: 'Desbloqueo de material restante',
    is: 'Sí',
    not: 'No',
    savingHistory: 'Guardado del archivo de historial',
    saveHistorySuccess: 'Guardado exitoso del archivo de historial',
    saveHistoryFail: 'No se pudo guardar el archivo de historial',
    bw: 'Si se exportan etiquetas en blanco y negro',
    modular: 'Gabinete de la unidad',
    autoAdjust: 'Ajuste automático',
    cutOrderTip: '¡Se ha detectado un error en su orden de corte 【第{errorCutOrdersString}张大板】! Realice ajustes antes de descargar el archivo NC',
    lockedCutOrderTip: '【第{errorCutOrdersString}张大板】 está bloqueado, vaya a modificación manual',
    paibanImgCutOrderTip1: '¡Se ha detectado un error en su orden de corte',
    paibanImgCutOrderTip: '! Vaya a la página de diseño para ajustar y luego exporte el archivo de diseño',
    goAdjust: 'para ajustar',
    autoAdjustWarning: 'El resultado del diseño actual no admite el ajuste automático',
    checkNetwork: 'Consulte la red',
    moreInfo: 'para obtener más información',
    continueLayout: 'Continuar con el diseño',
    adjustPosition: 'Ajustar la configuración',
    specialAndFiveSix: 'Al procesar paneles de formas especiales con perforación de cinco o seis lados, activar el anidamiento de formas especiales puede causar que el panel se corte. Por favor, confirme si desea continuar con la composición tipográfica.',
    plankPathErr: 'Los datos internos de forma especial de la placa son incorrectos, verifique si cumple con las especificaciones de la herramienta. Número de placa 【{plankIDList}】',
    edgeCheck: 'El sistema ha detectado que se ha modificado el recorte de la placa grande; vuelva a diseñarlo para garantizar una producción precisa',
    iKnow: 'Entiendo',
    versionErrTip: '¡Actualice el gabinete a la última versión!',
    annualFeeExpired: 'Su cuota anual ha caducado, ¡renuévela!',
    holeEquipment: 'Equipo de perforación {num}',
    customizedService: 'Servicios personalizados de soporte para crear su plan de producción exclusivo',
    exampleCombination1: 'Máquina de grabado + combinación de taladro de cinco/seis lados + máquina perforadora lateral',
    exampleCombination2: 'Sierra electrónica + combinación de taladro de cinco/seis lados + máquina perforadora lateral',
    exampleCombination3: 'Línea de producción integrada completamente automática + combinación de taladro de cinco/seis lados',
    feedback: 'Puede informar directamente sus necesidades al personal de ventas o posventa del software de su gabinete',
    markModifiedBoards: 'Mark el tablero pequeño modificado',
    showMoveStep: 'Establecer paso de movimiento del teclado',
    moveStep: 'Paso de movimiento del teclado',
    existChangeBoards: 'Placas pequeñas cambiadas',
    crossMaterialBoard: 'Tablero cruzado material-color',
    skipCrossMaterialTip: 'No mostrar de nuevo en este diseño',
    crossMaterialConfirmTip: 'Está moviendo una tabla pequeña entre diferentes materiales o colores. {highlight} ¿Continuar?',
    crossMaterialConfirmTipHighlight: 'La tabla producida puede ser inconsistente con el pedido dividido',
    exportHoleSlotPDF: 'Exportar diagrama de ranura de orificios',
    pdfFormat: 'Formato PDF',
    dxfFormat: 'Formato DXF',
    specialShapeKnivesInfo: 'Consejos de selección de herramientas con formas especiales',
    specialShapeKnivesInfoTips: '{stockNum} parte de la placa:',
    specialShapeKnivesInfoTips2: 'La selección automática de herramientas con formas especiales está activada, los datos de diseño son anormales, vuelva a diseñar desde la lista de materiales o desactive la función de selección automática de herramientas con formas especiales',
    default: 'Predeterminado',
    exportLanguage: 'Idioma de exportación',
    exportLanguageTip: 'Nota: Parte de la información de texto no se puede traducir cuando se exporta a pdf',
    highGlossNameTip: 'El tablero de resaltado sincronizado desde el gabinete se puede describir como otra escritura, lo que no afecta sus atributos de resaltado',
    mixPaibanPlanSetting: 'Configuración del plan de mezcla',
    mixPaibanPlanSettingTip: 'El sistema detecta que la configuración del plan de mezcla ha cambiado, ¡vuelva a seleccionar este plan de mezcla!',
    mixPaibanPlanSettingOk: 'Establecer el esquema de disposición mixta',
    mixPaibanPlanSettingCancel: 'No es necesario, composición tipográfica directamente',
    noMixPaibanPlan: 'Actualmente no hay ningún esquema de disposición mixta disponible',
    mixColors: 'Color de disposición mixta',
    mixPai: 'Disposición mixta',
    plan: 'Esquema',
    mixPaibanTitle: 'Organice tableros pequeños de diferentes colores juntos',
    mixColorsTip: 'Puede definir qué colores de paneles se pueden organizar en un panel grande del mismo color para producción sin cambiar la información de color original de los paneles.',
    mixColorsTip2: 'Después de agregar el esquema, es necesario activarlo en la lista de materiales para que surta efecto',
    mixColorsTip3: 'Hay un conflicto entre las funciones de borde de diferentes colores y la función no puede ser efectiva al mismo tiempo',
    mixErrTip: 'Al esquema de disposición mixta le faltan elementos requeridos, verifique',
    addPlan: 'Agregar esquema',
    chooseMatcode: 'Seleccionar material',
    chooseColor: 'Seleccionar color',
    defineColor: 'Defina el color seleccionado como',
    confirmDeletePlan: '¿Está seguro de que desea eliminar el esquema?',
    trimmingMethod: 'Método de recorte',
    followStandardTrim: 'Siga el valor de recorte de la placa estándar en la película original',
    trimToast: 'Nota: Ha utilizado la función de recorte personalizado del material restante, que solo es opcional para aserrado y diseño',
    individualTrimValue: 'Establezca el valor de recorte de forma independiente',
    topTrimEmptyToast: '¡El recorte superior no puede estar vacío!',
    bottomTrimEmptyToast: '¡El recorte inferior no puede estar vacío!',
    leftTrimEmptyToast: '¡El recorte izquierdo no puede estar vacío!',
    rightTrimEmptyToast: '¡El recorte correcto no puede estar vacío!',
    topTrimBlurToast: 'Ingrese el valor de recorte superior',
    bottomTrimBlurToast: 'Ingrese el valor de recorte inferior',
    leftTrimBlurToast: 'Ingrese el valor de recorte izquierdo',
    rightTrimBlurToast: 'Ingrese el valor de recorte derecho',
    effectToast: '1. La función de recorte personalizado solo es efectiva para placas soldadas',
    defaultTrimSetting: 'Configuración de recorte predeterminada para los materiales restantes',
    enterHere: 'Ingrese aquí',
    permissionTipExportDxf: 'Exportar diagrama de agujeros y ranuras DXF',
    permissionTipSurplusRecycleBin: 'Estación de reciclaje de sobras',
    permissionTipAdvancedNesting: 'Anidación irregular avanzada',
    permissionTipPanelGrainAlign: 'Alineación de grano del panel',
    permissionSeparator: ', ',
    missingPermissionTip: 'Faltan los siguientes permisos: {permissions}'
    },
  home: {
    head: {
      production: 'Introducción del producto',
      resolve: 'Solución',
      about: 'Acerca de nosotros',
      equipment: 'Maquinaria y equipo',
      tell: 'Línea directa de quejas',
      enter: 'Ingrese a la composición tipográfica en la nube'
      },
    swiper: {
      case1: {
        tag: 'Nueva versión mejorada',
        subTitle: 'El cerebro inteligente de la máquina',
        description: 'Software de optimización de la composición tipográfica en línea en la nube que revoluciona la industria'
        },
      case2: {
        title: 'Producción de gabinetes',
        subTitle: 'Innovación técnica',
        description: 'Admite una variedad de máquinas etiquetadoras, cortadoras, máquinas perforadoras laterales, de cinco lados PTP, taladros de cinco/seis lados acoplamiento'
        },
      case3: {
        title: 'Cerebro industrial',
        subTitle: 'Solución',
        description: 'El algoritmo de composición tipográfica inteligente obtiene una mayor tasa de utilización de los tableros'
        }
      },
    statistics: {
      today: 'Volumen de turno de hoy',
      toMounth: 'Volumen de composición tipográfica mensual',
      outturn: 'Rendimiento del material',
      cumulative: 'Usuarios acumulativos'
      },
    intro: {
      title: 'Big data a nivel empresarial Software de composición tipográfica en línea en la nube',
      subTitle: 'Información sobre las tendencias de la industria, centrándose en las necesidades de los clientes, potenciando la transformación y actualización digital de las empresas y promoviendo la transformación de la industria de automatización de la producción de muebles en Internet En respuesta a los escenarios de producción existentes de los muebles con paneles industria, se lanzan algoritmos auxiliares AI para continuar contribuyendo con un nuevo crecimiento a la empresa',
      menue: {
        case1: {
          title: 'Composición tipográfica en línea',
          subTitle: 'La composición tipográfica se puede realizar en cualquier momento',
          description: 'No es necesario descargar software, la composición tipográfica se puede realizar en cualquier momento, el control remoto no necesita depender de una computadora'
          },
        case2: {
          title: 'Producción de múltiples líneas',
          subTitle: 'Cambio rápido de líneas de producción',
          description: 'Admite el procesamiento rápido de múltiples líneas de producción al mismo tiempo y puede rápidamente cambiar entre líneas de producción'
          },
        case3: {
          title: 'Producción fina',
          subTitle: 'Composición tipográfica fina, configuración de parámetros fina',
          description: 'La composición tipográfica fina y la configuración precisa de los parámetros hacen que la producción de paneles sea más precisa'
          },
        case4: {
          title: 'Producción personalizada',
          subTitle: 'Etiquetas personalizadas, taladros de cinco y seis lados personalizados y formas de material residual',
          description: 'Etiquetas personalizadas, taladros de cinco y seis lados personalizados, formas de material residual personalizado y procesamiento de equipos combinados'
          }
        }
      },
    fangan: {
      title: 'Soluciones profesionales de la industria',
      subTitle: 'Bajo costo, alto valor de producción, algoritmos inteligentes mejoran la utilización del panel y son compatibles con múltiples software de diseño para brindar a los usuarios soluciones de producción óptimas',
      menue: {
        case1: {
          title: 'En línea toma de pedidos e integración de producción',
          description: 'Operación remota en línea, superación de obstáculos de espacio, emisión de pedidos en cualquier momento para sincronizar la fábrica y finalización del diseño y la producción simultáneamente'
          },
        case2: {
          title: 'Cambio de líneas de producción con un solo clic',
          description: 'Líneas de producción personalizadas, que admiten múltiples líneas de producción y acoplamiento de equipos de varios tipos'
          },
        case3: {
          title: 'El algoritmo inteligente mejora la utilización de las planchas',
          description: 'El algoritmo tradicional tiene una baja utilización de las planchas, un algoritmo inteligente de configuración fina de parámetros y un plan de producción personalizado'
          },
        case4: {
          title: 'Solución de corte profesional',
          description: 'Optimice la secuencia de corte y el punto de corte para hacer que la ruta de corte sea más corta y estable'
          }
        }
      },
    aboutUs: {
      title1: 'Xinger Habitat Technology',
      subTitle: 'Líder en la transformación de la industria de producción de muebles',
      description: 'Xinger Enterprise, que se centra en realizar la transformación de Internet de la industria de producción de muebles tradicional',
      culture: {
        case1: {
          title: 'Propósito corporativo',
          subTitle: 'Ayudar a las fábricas a triplicarse'
          },
        case2: {
          title: 'Valores culturales',
          subTitle: 'Centrado en el cliente, orientado al esfuerzo, trabajo duro y beneficio de las personas'
          },
        case3: {
          title: 'Ideología rectora',
          subTitle: 'Línea de masas, construya un equipo de élite con poder de ventas, poder de producto y poder organizacional'
          }
        },
      feature: {
        case1: 'Mantenimiento del equipo profesional',
        case2: 'Actualizaciones e iteraciones continuas',
        case3: 'Servicio posventa personalizado',
        case4: 'Servicio de personalización de funciones'
        }
      },
    cooperation: {
      title: 'Cooperación sincera para crear el futuro',
      subTitle: 'La marca de equipos de acoplamiento cubre el 90% de los equipos de uso común del Partido Comunista nacional, y 107,554 comerciantes están con nosotros'
      },
    footer: {
      contact: {
        title: 'Contáctanos',
        adrres: 'Dirección: Piso 16, Edificio 1, No. 50, Xiuxi, Distrito de Binhu, Ciudad de Wuxi, Provincia de Jiangsu',
        subAdrres: 'K-park Centro de servicio Edificio 1',
        tell: 'Teléfono'
        },
      business: {
        title: 'Negocio principal de Xinger',
        department1: 'División de software para puertas y ventanas',
        department2: 'División de software para muebles',
        department3: 'División de construcción de ensamblaje',
        department4: 'Sitio web oficial de la sede de Xinger'
        },
      brand: {
        title: 'Marcas de Xinger',
        brand1: 'Caishen Financial Services',
        brand2: 'Mentu.com',
        brand3: 'Dingxin Investment',
        brand4: 'Sanzhangtu Technology',
        brand5: 'Shanghai Fenmo Technology'
        },
      organization: {
        title: 'Xingeer Global Branches',
        organization1: 'Xingeer-South China Bureau (Foshan Branch)',
        organization2: 'Xingeer-Northern Bureau (Linyi Branch)',
        organization3: 'Xingeer-Southwest Bureau (Chengdu Branch)',
        organization4: 'Xingeer - Centro de servicio Cabinet West',
        organization5: 'Xingeer - Centro de servicio Cabinet East',
        organization6: 'Xinger - Grupo de agentes',
        organization7: 'Xinger - Departamento de marketing internacional'
        },
      follow: {
        title: 'Escanear "Seguir gabinetes"'
        },
      friendLink: {
        link1: 'Software Xinger',
        link2: 'K Mostrar software de guía de compras',
        link3: 'Mentu.com',
        link4: 'Software para gabinetes totalmente de aluminio',
        link5: 'ZOL Descarga de software',
        link6: 'Huajun Software Park',
        link7: 'Inicio de descargas',
        link8: 'ZOL Descarga de software',
        link9: 'Green Resource Network',
        link10: 'Franquicia de vestuario',
        link11: 'Inicio Franquicia de mobiliario',
        link12: 'Franquicia de baño American Standard'
        }
      }
    },
  login: {
    title: 'Iniciar sesión',
    tell: 'Número de teléfono móvil',
    password: 'Contraseña',
    passwordPlaceholder: 'Por favor ingrese la contraseña',
    forget: 'Olvidé mi contraseña',
    registerAccount: 'Registrar cuenta',
    backLog: 'Volver a iniciar sesión',
    verifyCode: 'Código de verificación',
    getVerifyCode: 'Obtener código de verificación',
    verifyCodeErr: 'Error de código de verificación',
    confimPassword: 'Confirmar contraseña',
    confimPasswordPlaceholder: 'Por favor confirme la contraseña',
    editPassword: 'Cambiar contraseña',
    register: 'Registrarse',
    reSend: 'y volver a obtener',
    loginLoadText: 'Inicie sesión, espere...',
    loadingPageTextL: 'Inicie sesión correctamente, cargando estructura de página...',
    loginSuccess: 'Inicie sesión correctamente',
    tellErr: 'El formato del número de teléfono móvil es incorrecto',
    passwordErr: 'Por favor ingrese la contraseña'
    },
  main: {
    head: {
      title: 'Bluen',
      subTitle: 'Ahorre tiempo, material y esfuerzo',
      task: 'Aceptar tareas',
      arrange: 'Composición tipográfica',
      surplus: 'Materiales restantes',
      setting: 'Configuración',
      find: 'Descubrir',
      upgrade: 'Actualizar ahora',
      editNickName: 'Modificar apodo',
      editPassword: 'Cambiar contraseña',
      logout: 'Cerrar sesión',
      notice: 'Anuncio',
      enterOfficial: 'Ir al sitio web oficial',
      equipment: 'Maquinaria y equipo',
      help: 'Ayuda',
      importFunc: 'Ver funciones exclusivas',
      enterThinkerOfficial: 'Ingresar al sitio web oficial de Xinger',
      history: 'Guardar historial',
      plankManager: 'Gestión de películas originales',
      tagManager: 'Gestión de etiquetas',
      suplumentManager: 'Piezas complementarias y biblioteca para componer',
      fileManager: 'Gestión de archivos',
      productionLine: 'Acoplamiento de equipos',
      workeShop: 'Producción en la nube',
      useLesson: 'Tutorial de uso',
      videoLesson: 'Videotutorial',
      prolineManager: 'Gestión de línea de producción',
      materialManager: 'Gestión de paneles',
      productManual: 'Manual del producto',
      medialRelated: 'Liberación de gradiente'
      },
    sideBar: {
      title: 'Optimización de producción',
      materialList: 'Lista de corte de materiales',
      paibanResult: 'Plan de composición tipográfica',
      printTag: 'Impresión de etiquetas',
      history: 'Guardar historial',
      limitDate: 'Exención limitada',
      surplusManager: 'Gestión de materiales restantes',
      translateManager: 'Gestión de traducción',
      moreSettings: 'Más configuraciones',
      deepSeekTitle: 'Consultores',
      paibanCommune: 'Grupo de intercambio de composición tipográfica'
      },
    allRead: 'Todo leído',
    learnMore: 'Más información',
    noticeEmpty: 'Ningún anuncio aún....',
    noticeErr: 'Obtener anuncio detallado Error de contenido',
    feedBack: {
      tab1: 'Enviar comentarios',
      tab2: 'Registro de comentarios',
      type: 'Tipo de comentario',
      typePlaceholder: 'Seleccione la función',
      description: 'Descripción',
      descriptionPlaceholder: 'Hola ~ Complete una descripción detallada del escenario de uso de no menos de 15 palabras para que podamos ayudarlo mejor. ¡Gracias por su cooperación!',
      uploadPic: 'Agregar imágenes, se pueden agregar hasta 6, el tamaño de una sola imagen no excede los 10 M)',
      tell: 'Número de contacto',
      submit: 'Enviar',
      admin: 'Administrador de composición tipográfica en la nube:',
      picTip: 'Imagen: (Haga clic para ampliar para ver los detalles de la imagen)',
      empty: 'Sin datos de comentarios',
      picErr: 'El tamaño de una sola imagen no excede los 10 M',
      contentErr: 'El número de palabras debe estar entre 15 y 300',
      necessary: 'Esta opción es obligatoria'
      }
    },
  taskPage: {
    tab1: 'Tarea de producción',
    tab2: 'Cola de producción en masa',
    filter: {
      title: 'Filtrar',
      unArrange: 'Sin composición tipográfica',
      arranged: 'Composición tipográfica',
      allArranged: 'Toda composición tipográfica',
      preLayout: 'Composición previa'
      },
    search: {
      placeholder: 'Ingrese el contenido de la búsqueda',
      orderName: 'Nombre del pedido',
      sender: 'Remitente'
      },
    importTask: 'Tarea de importación',
    refuseTask: 'Tarea de rechazo',
    refreshList: 'Actualizar lista',
    refuseRecord: 'Registro de rechazo',
    taskCard: {
      sender: 'Lista de materiales importada',
      delivery: 'Fecha de entrega',
      delete: 'Eliminar',
      addToBatch: 'Agregar al lote',
      save: 'Archivo',
      arrange: 'Composición tipográfica directa',
      deleteTitle: 'Eliminar tarea',
      checkDetail: 'Haga clic para ver detalles',
      refuse: 'Rechazar',
      refuseTime: 'Hora de rechazo',
      refuseReason: 'Motivo de rechazo',
      refuseTask: 'Rechazar tarea',
      refuseTaskPlaceholder: 'Ingrese el motivo del rechazo',
      addErr: 'Error al agregar, ¡inténtelo nuevamente más tarde!'
      },
    batchNo: 'Número de lote',
    batchArrange: 'Diseño de lote',
    clearBatch: 'Borrar cola',
    taskCount: 'Número actual de tareas:',
    checkAllTask: 'Ver toda la lista de materiales',
    clearSuccess: 'Borrar exitosamente',
    record: {
      batchNo: 'Lote',
      saveDate: 'Ahorre tiempo',
      materialList: 'Lista de materiales',
      arrangedRecord: 'Plan de composición tipográfica',
      searchPlaceholder: 'Por favor ingrese el número de lote',
      tipText: '¿Quiere eliminar este archivo?'
      },
    errTip: 'No hay datos de tareas para procesar, ¡vaya a la lista de tareas para agregarlos!',
    emptyErr: '¡Esta orden de tarea no tiene datos de panel y no se puede escribir ni producir!',
    operationSuccess: 'Operación exitosa',
    operationFail: 'Operación fallida, ¡inténtelo nuevamente más tarde!',
    saveSuccess: 'Archivado exitoso',
    plankMaxLimit: 'El número de tableros pequeños excede el límite máximo de composición tipográfica',
    batchWorning: 'Produzca en lotes',
    batchEmptyErr: 'La lista de pedidos no tiene datos de tableros y no se puede realizar la producción en masa.',
    noRoomTip: '¡Sin una habitación, la producción en masa es imposible!',
    refuseHistory: 'Historial de rechazos'
    },
  materialPage: {
    specialProcess: 'Proceso especial',
    distanceFromTop: 'Desde arriba',
    distanceFromRight: 'Desde la derecha',
    hingeData: 'Datos de bisagra',
    labelBackProcTip: 'Esta actualización ha optimizado el método de etiquetado en la parte posterior del tablero grande. Ahora siga la información de la etiqueta para sellar directamente el borde y perforar agujeros y tirar de las ranuras. ¡Espero que lo sepas!',
    openDir: 'Dirección de apertura de la puerta',
    edgeEmptyTip: 'El valor de recorte no puede estar vacío',
    edgeNumberLimit: 'El valor de recorte solo se puede ingresar como números',
    chooseSurplusQuantity: 'Hay {total} tipos de materiales restantes disponibles, se han seleccionado {quantity} tipos',
    noCanSaveInfo: 'No hay información que se pueda guardar',
    chooseBujianStoreQuantity: 'Un total de {total} piezas de patchwork, un total de {quantity} piezas de paneles que se pueden parchar por cierto, {chooseQuantity} piezas han sido seleccionadas',
    isConfirmPushToAwaitStore: '¿Está seguro de agregar los paneles seleccionados a la biblioteca para componerlos?',
    enterAutoCreateMatCode: 'Presione Enter para crear material automáticamente',
    chooseAwaitStoreQuantity: 'Un total de {total} paneles pequeños en la biblioteca para componer, un total de {quantity} paneles que se pueden componer, bloques {chooseQuantity} seleccionados',
    defaultFold: 'Los datos del panel se contraen de forma predeterminada',
    startArrange: 'Iniciar composición',
    importMaterial: 'Importar la lista de corte',
    saveToHistory: 'Guardar en el historial',
    addPlank: 'Agregar paneles',
    addBujian: 'Agregar parche',
    deletePlank: 'Eliminar paneles',
    batchEdit: 'Modificación por lotes',
    moreSetting: 'Más configuraciones',
    plankSize: 'Tamaño del panel',
    plankSize2: 'Dimensiones (largo*ancho*grosor)',
    searchPlaceholder: 'Buscar nombre de placa/número de placa',
    checkArranged: 'Ver composición tipográfica',
    checkErr: '¡Sin composición tipográfica, no se puede ver!',
    downloadSheet: 'Descargar tabla de muestra',
    downloadSheetShowScientific: 'Descargar tabla de muestra (que muestra notación científica)',
    exportHoleSlotPDF: 'Exportar diagrama de orificios y ranuras de la placa',
    style1: 'Estilo uno',
    style2: 'Estilo dos',
    style2PDF: 'Estilo 2 (PDF)',
    style2DXF: 'Estilo 2 (DXF)',
    style3: 'Estilo tres',
    importNoCover: 'La importación de la lista de materiales no está cubierta',
    openBujianPlankRecommend: 'Habilitar la recomendación de paneles pequeños para piezas suplementarias',
    openAwaitStorePlankRecommend: 'Habilitar la recomendación de paneles pequeños en la biblioteca para ser tipografiados',
    openSurplusPlankRecommend: 'Habilitar la recomendación de paneles grandes paneles con material restante',
    pushToAwaitStore: 'Guardar en la biblioteca para componer',
    setTableHead: 'Establecer el encabezado de la lista de corte',
    syncConfirm: '¡Los datos del gabinete y la pieza original de composición tipográfica en la nube son inconsistentes! ¿Está sincronizado con los datos de la película original del gabinete?',
    handleSync: 'Nota: La sincronización manual se puede realizar en la gestión de la película original',
    noMoreTip: 'No volver a preguntar',
    checkMore: 'Ver más',
    noHistory: 'Aún no hay historial de guardado...',
    sameOrder: 'Hay pedidos con archivos de producción exportados, ¡preste atención a problemas de producción duplicados!',
    markOrder: '¿Quieres marcar la producción en la página del pedido?',
    editErrTip: 'Actualmente, varios pedidos no admiten la modificación de información',
    autoSaveSuccess: '¡Se guarda automáticamente en el historial!',
    goAdd: 'Ir a agregar',
    noProductionLine: 'La línea de producción de este disco ha sido eliminada, vaya a la lista de materiales para volver a diseñarlo',
    fileErr: 'No se pudo analizar el contenido del archivo, ¡confirme el contenido del archivo!',
    noCheckData: '¡No se consultaron datos!',
    noArrangeTip: 'No se puede ver directamente el plano de diseño, ¡haga clic para iniciar el diseño!',
    tooOld: 'Las configuraciones de perforación de cinco o seis lados son demasiado antiguas',
    contactUs: 'Comuníquese con el personal de posventa para volver a conectarse',
    pathErr: 'Hay datos anormales dentro de la placa (número de placa: {errorPathPlankID}), ¡compruébelo!',
    sizeErr: '¡Existe un panel de gran tamaño! Tamaño de placa pequeña: {width}-{height}',
    noKnife: 'El diámetro de la cuchilla de corte no está configurado, ¡vaya a la máquina de grabado para configurar la cuchilla!',
    noKnifeDiameter: 'El diámetro de la cuchilla de corte ({name}) de la línea de producción está vacío, vaya a agregar el diámetro de herramienta correspondiente',
    openDifferentMaterialCuttingKnives: 'Se habilitan diferentes cuchillas de corte de material',
    sendFactorySuccess: 'Enviado exitosamente al taller',
    sendFactoryErr: 'No se pudo enviar al taller, comuníquese con el personal de posventa para obtener ayuda',
    createTaskCard: '¿Quiere crear la tarjeta de tarea correspondiente?',
    surplusStatistics: 'Se han seleccionado un total de',
    surplusStatistics2: 'materiales restantes disponibles',
    suplementStatistic: '. Se puede parchear un total de [[6]] piezas de mosaico y se puede parchear un total de',
    expand: '. Expandir',
    packUp: 'Contraer',
    importErr: '¡Seleccione el archivo correcto!',
    sendLoadingText: 'Procesando y enviando archivos NC...',
    arrangeLoading: 'Total',
    arrangeLoading2: 'Se están optimizando tableros pequeños para la composición tipográfica...',
    dealing: 'Procesando...',
    deleteConfirm: 'Después de eliminarlo, el material sobrante se moverá a la papelera de reciclaje. ¿Estás seguro de que quieres eliminar este material sobrante?',
    copyTip: 'Los materiales restantes seleccionados se copiarán pronto',
    copyTip2: 'Confirme la cantidad a copiar',
    surplusHead: {
      shape: 'Forma',
      type: 'Tipo',
      remark: 'Comentarios',
      area: 'Área (m²)',
      area1: 'Área'
      },
    surplusTip: 'No hay material restante disponible, puede ir a',
    creatSurplus: 'Crear un nuevo material restante',
    orderInfo: 'Información del pedido',
    suplement: {
      statistic: 'Un total de {total} piezas de patchwork, se pueden parchar un total de {useable} piezas de paneles, {selected} piezas han sido seleccionadas',
      exportSuplement: 'Exportar la lista de patchwork',
      suplementLoading: 'Cargando datos de parches',
      exportSuplementIng: 'La lista de parches se está exportando',
      noMatchSup: 'No se pudieron coincidir los datos de parche utilizables',
      exportTip: 'Seleccione al menos un parche antes de exportar'
      },
    empty: 'Aún no hay datos de placa',
    paibanSetting: {
      title: 'Configuración de diseño',
      selectProduction: 'Selección de línea de producción',
      arrangeWay: 'Selección de esquema de diseño',
      suitText: 'Aplicable a：',
      surplusTrimTip: 'Nota: Ha utilizado la función de recorte personalizado de material residual, solo se puede seleccionar el diseño de aserrado',
      suitEquipmentNormal: 'Máquina de grabado convencional',
      suitEquipmentSpecial: 'Vidrio máquina cortadora, máquina cortadora de hojas de sierra',
      lessRoll: 'Menos copias',
      computedSpecial: 'Cálculo de formas especiales',
      specialTip: 'Afecta la velocidad de composición',
      irregularNesting: 'Anidamiento de formas especiales',
      primaryNesting: 'Anidamiento normal',
      specialShapedPanel: 'Forma especial incrustado en tablero ordinario',
      limitedTimeTrial: 'Exención limitada',
      seniorShape: 'Anidamiento avanzado',
      heteromorphicInlay: 'Forma especial incrustado en forma especial',
      autoCutSurplus: 'Recorte automático del material restante',
      cutWay: 'Método de recorte',
      maxRect: 'Recortar al rectángulo más grande',
      fixedRect: 'Recortar a un tamaño fijo',
      minRectSetting: 'Recortar al mínimo tamaño',
      firstCutL: 'El corte da prioridad a la generación de L restos en forma',
      firstCutLTip: '. Cuando se activa, las combinaciones de placas rectangulares que cumplan las condiciones se cortarán en restos con forma de L',
      shortLine: 'El lado corto es mayor que',
      longLine: 'El lado largo es mayor que',
      setDifferentThickness: 'Establezca el tamaño mínimo de corte de placas con diferentes espesores',
      defaultRuleTip: 'Cuando el espesor de la placa no coincida con la regla, se cortará de acuerdo con las reglas predeterminadas',
      panelThickness: 'Espesor de placa grande',
      duplicateMinCutSize: 'Ya existe el mismo tamaño mínimo de recorte para la espesor actual',
      templateEmpty: '¡Los datos de la plantilla de "Establecer el tamaño mínimo de corte de placas con diferentes espesores" no pueden estar vacíos!',
      duplicateThicknessData: '¡Hay datos de espesor duplicados en los datos de la plantilla de "Establecer el tamaño mínimo de corte de placas con diferentes espesores"!',
      atLeastOne: '¡Conserva al menos un artículo!',
      maxAddFive: '¡Suma hasta cinco!',
      surplusTemplate: 'Plantillas comunes para los materiales restantes',
      add: 'Agregar',
      templateErr: 'Seleccione el corte a tamaños comunes, debe seleccionar al menos una plantilla de datos',
      cutLong: 'Longitud de corte',
      cutWidth: 'Ancho de corte',
      baseInfo: 'Información básica',
      continue: 'Confirmar y continuar',
      standardSelect: 'Selección de tableros grandes estándar',
      customPlankOrder: 'Orden de diseño de tableros grandes personalizado',
      customPlankOrderDetail: 'Lista de tableros pequeños sin organizar',
      customPlankOrderTip: 'La composición tipográfica en la nube integrada no tiene efecto.',
      customPlankOrderBrandTip: 'Los pedidos pendientes de diseño contienen tableros de tarjeta de color de marca, esta función se usa de forma predeterminada',
      surplusPlank: 'Lista de tableros pequeños restantes',
      overSizePlank: 'Lista de tableros de gran tamaño',
      plankOrder: 'Secuencia de diseño',
      plankType: 'Tipo de tablero',
      plankSize: 'Tamaño del tablero',
      plankEdgeOff: 'Valor de corte',
      amount: 'Cantidad de corte',
      amountMax: 'El número máximo de espacios en blanco',
      numAndOverSizeTip: 'Hay placas pequeñas que son de gran tamaño y la cantidad de placas grandes es insuficiente para la composición tipográfica',
      numErrorTip: 'No hay placas grandes suficientes para la composición tipográfica',
      overSizeTip: 'Hay placas pequeñas que son de gran tamaño y no se pueden componer',
      restPartList: 'Lista de tableros pequeños sin organizar',
      layoutOrder: 'Secuencia de diseño',
      arrangeAmount: 'Cantidad de corte',
      specialShapeTip: 'Los restos de formas especiales no se pueden componer mediante aserrado',
      surplusConflictTip: 'Los restos recortados entran en conflicto con el contorno del panel, vuelva a cortar',
      stackingMethod: {
        title: 'Método de apilamiento',
        long: 'Apilar por el lado largo',
        short: 'Apilar por el lado corto'
        },
      seniorShapeTip: '【Anidamiento avanzado】El periodo de prueba gratuito ha expirado, puede previsualizar el resultado del diseño de anidamiento avanzado (también puede cambiar al anidamiento normal para la producción normal); si necesita exportar el archivo de producción de anidamiento avanzado, póngase en contacto con el personal de ventas para comprar~'
      },
    filter: {
      title: 'Filtro de panel',
      search: 'Buscar',
      all: 'Seleccione todo',
      diskSize: 'El espacio utilizado por los datos de historial de diseño ya ha sido utilizado',
      resetFilter: 'Cancelar filtro'
      },
    edit: {
      title: 'Modificación por lotes',
      target: 'Modificar objetos',
      onlineSelectRow: 'Seleccionar solo filas',
      allRow: 'Todas las filas',
      editKey: 'Necesita modificar el contenido',
      editValue: 'Modificar a',
      warningTip: 'Nota: Después de la modificación, los agujeros y las formas especiales se borrarán automáticamente',
      allEdge: 'Todas las bandas de borde'
      },
    add: {
      title: 'Agregar paneles',
      continue: 'Confirmar y continuar',
      matCodeErr: 'El material no puede estar vacío',
      thickErr: 'El espesor no puede estar vacío',
      colorErr: 'El color no puede estar vacío',
      longErr: 'La longitud del producto terminado no puede estar vacía',
      widthErr: 'El ancho del producto terminado no puede estar vacío',
      countErr: 'La cantidad debe ser al menos 1'
      },
    delete: {
      tip: 'Estos datos no se pueden restaurar después de eliminarlos. ¿Confirmas eliminar estos datos?',
      errTip: '¡Seleccione al menos un panel antes de realizar esta operación!',
      errTip1: 'Seleccione al menos una placa antes de componer',
      confirm: 'Confirmar eliminación'
      },
    restore: {
      confirm: 'Confirmar restauración'
      },
    restoreConfirm: 'Después de la restauración, el material sobrante se moverá de nuevo a la lista o almacén de sobrantes. ¿Estás seguro de que quieres restaurar este material sobrante?',
    restoreBatchConfirm: '¿Estás seguro de que quieres restaurar los materiales sobrantes seleccionados?',
    save: {
      errTip: '¡No hay información que se pueda guardar!',
      title: 'Guardar plan',
      subTitle: '(Nota: El historial solo se guarda durante un año)',
      name: 'Nombre del plan',
      historyName: 'Plan histórico',
      successTip: '¡Guardado exitosamente!',
      fieldTip: '¡Error al guardar!'
      },
    exportErr: 'No hay placa, no se puede exportar',
    exportPicErr: 'Se encontró un error desconocido al exportar el diagrama de orificios y ranuras de la placa; contáctenos para solucionarlo',
    plankNotFound: '¡No se encontraron paneles relevantes! ¡Por favor confirme si desea dibujar los paneles!',
    noPlankName: 'Nombre del panel no encontrado',
    plankDataErr: 'Los datos del panel son incorrectos, verifique cuidadosamente para evitar pérdidas de producción',
    exportThreeViewErr: 'No se pudieron exportar tres vistas de orificios y ranuras, comuníquese con el servicio posventa',
    heighGlossWarning: 'Nota: Cuando el material es un tablero de alto brillo, el tablero no se restaurará a un tablero de alto brillo después de modificar el material.',
    reset: 'Restaurar valor predeterminado',
    settingHead: {
      title: 'Establecer el encabezado de la lista de corte',
      head: 'Encabezado',
      customHeadName: 'Personalizar nombre del encabezado',
      example: 'Ejemplo',
      tip: 'Consejos de operación: Puede arrastrar la etiqueta de datos del encabezado hacia la izquierda y hacia la derecha. Posición',
      headerNameEmpty: 'El encabezado no puede estar vacío',
      duplicateHeader: 'Hay un encabezado duplicado'
      },
    copyLine: 'Haga clic para copiar la fila actual debajo',
    copySuccess: 'Copie los datos de {name} correctamente',
    arranging: 'Un total de {count} tableros pequeños se están optimizando para la composición tipográfica...',
    overSize: {
      title: 'Panel sobredimensionado',
      subTitle: 'Lista de tableros de gran tamaño',
      overSizeTip: 'Aviso sobre tamaño del panel',
      nonWorkInfo: 'Detalles de los paneles que no se pueden procesar',
      mergeFrameDoorWholeTip: 'Nota: Este componente es una puerta esqueleto completa que procesado en combinación',
      conflictWorkInfo: 'Detalles de los paneles en conflicto',
      warning: '¡Se detectó un pequeño panel que era demasiado largo, lo que hacía imposible la composición tipográfica! Ajuste el tamaño del tablero pequeño o agregue la pieza original del tamaño correspondiente',
      checkInfo: 'para ver los detalles del tablero.',
      tipContent: 'El sistema detecta que hay paneles de gran tamaño en la tabla de composición. Las siguientes son sugerencias para agregar paneles especiales. Puede modificar manualmente la longitud y el ancho de los paneles y hacer clic en el botón <span class="bold color-0"> "Agregar con un clic" </span> debajo de la tabla para agregar y continuar con la composición rápidamente. También puede agregar paneles manualmente en <span class="bold color-0"> Configuración original - Paneles especiales </span>',
      add: 'Agregar con un clic',
      addPlank: 'Agregar original',
      error: 'El tablero excede el tamaño y la tipografía falla',
      successTip: '¡El tablero se agregó exitosamente! Reformateo',
      warningTip: '¡Rellene el largo y el ancho del tablero!'
      },
    arrangeErr: 'Hay una anomalía en los datos internos del panel y no se puede realizar la producción tipográfica',
    nonDelete: 'No se puede eliminar',
    addOverSizeTip: 'Hay un tamaño excesivo, agréguelo nuevamente',
    addPlankSuccess: 'Se agregó con éxito un tablero grande especial',
    addPlankFail: 'No se pudo agregar un tablero grande especial',
    paibanFeedback: 'Comentarios de composición',
    cuttingAndPaoban: 'Cortar el estribo',
    lowUtilizationRate: 'Baja utilización',
    unreasonableLayout: 'Composición tipográfica irrazonable',
    feedbackSuccessTip: '¡Comentarios exitosos!',
    feedbackFailTip: '¡Error en la retroalimentación!',
    mixedLayoutScheme: 'Este plano de disposición mixta'
    },
  arrangedPage: {
    subtleDownloadCheckTip: 'Los datos del panel han cambiado, pero el plano no se ha guardado. Haga clic en Aceptar para guardar el plan antes de continuar con operaciones posteriores',
    paibanRequestFailed: 'La solicitud de composición falló, inténtalo de nuevo',
    accordingPlankCountOrder: 'Ordenar por el número de tableros grandes de mayor a menor',
    editOrder: 'Editar número de serie',
    dragOrder: 'Arrastrar para ordenar',
    inputOrder: 'Orden de entrada',
    editOrderTip: 'Ajuste de secuencia',
    range: 'Rango',
    unsupportRotateTip: 'Algunos tableros grandes se han rotado y no se admite el cambio de diseño por el momento. El número de serie del tablero rotado es:',
    slotErrTip: '¡El tablero actual tiene ranuras para el procesamiento de ribetes y no se admite el rediseño!',
    lockedPaibanTip: 'El tablero grande está bloqueado y no se puede volver a diseñar',
    batchBujianErrTip: 'El tablero actual no existe en los datos originales de la lista de materiales. Puede optar por volver a diseñar en la biblioteca de suplementos/diseños futuros.',
    useFolderIsNot: '¡Se ha detectado que la ubicación de descarga y guardado de su archivo "{type}" no existe! Compruebe si la carpeta se ha eliminado. Si está utilizando un disco móvil U, verifique si el disco U está conectado correctamente',
    useFolderIsNot1: 'Se detecta que no ha configurado la ubicación de descarga del archivo, seleccione primero el directorio',
    downloadNC: 'Descargue NC',
    downloadNC1: 'Descargue el archivo NC',
    reArrange: 'Recomponga',
    reArrangeSpecifiedMaterialGroup: 'Reorganizar grupos de paneles especificados',
    specifiedMaterialRelayoutMoreResultTip: 'Después de reorganizar los grupos de paneles especificados, ya no se proporcionarán más resultados de diseño',
    searchMaterialGroup: 'Buscar grupos de paneles',
    saveToHistory: 'Guardar en el historial',
    moreSetting: 'Más',
    cutIndexRe: 'Use el atajo de teclado ctrl+z para deshacer el paso anterior',
    followExportTag: 'Descargue NC y exporte el archivo de etiqueta',
    followExportPaibanImg: 'Descargue NC y exporte el archivo de dibujo de diseño',
    followExportWorkerShop: 'Descargar NC y exportar la orden de compra',
    tagTemplateSelect: 'Selección de plantilla de etiqueta',
    showCuttingSequence: 'Mostrar orden de corte',
    showPlankSize: 'Mostrar tamaño de placa pequeña',
    sendToFactory: {
      title: 'Enviar al taller',
      fileType: 'Tipo de archivo de etiqueta'
      },
    checkData: 'Verificar la integridad de los datos...',
    dataLoading: 'Cargando...',
    addToBujianStore: 'Agregando almacén de piezas...',
    updateTaskStatus: 'Actualizando estado de la tarea...',
    sending: 'Enviando al taller',
    waitLoadding: 'Esperando',
    loadding: 'Actualmente',
    finish: 'Completando',
    loadSetting: 'Cargando configuraciones',
    loadPreference: 'Cargando preferencias',
    dealTemplate: 'Procesando plantillas',
    initTagData: 'Inicializando datos de etiquetas',
    prepareDrawData: 'Preparando datos de dibujo de etiquetas',
    drawDataText: 'Datos de dibujo de etiquetas',
    genPdfTagFile: 'Generando PDF archivo de etiquetas',
    genPicTagFile: 'Generar archivo de imagen de etiqueta',
    uploadFile: 'Cargar archivo',
    dealNCFile: 'Procesar archivo NC',
    zipFile: 'Generar archivo comprimido local',
    plankCount: 'Número de tableros grandes',
    rollCount: 'Número de copias',
    totalRate: 'Tasa de optimización general',
    rate: 'Tasa de optimización',
    useArea: 'Área optimizada',
    materialList: 'Lista de materiales',
    saveSurplus: 'Materiales restantes almacenados',
    workeShop: 'Orden de compra',
    batchTagging: 'Reetiquetado por lotes',
    batchTaggingTip: 'Seleccione los paneles que deben reetiquetarse a continuación',
    holeSlotErr: '¡Se detecta que el panel tiene un orificio y una profundidad de ranura anormales!',
    knivesErr: '¡Se detecta que el panel no puede encontrar la herramienta de procesamiento!',
    checkDetail: 'Ver detalles',
    deepErr: {
      title: 'Profundidad anormal del orificio del panel',
      errStatistic: 'La placa secundaria tiene {count} anormalidad',
      errText: 'Parte anormal',
      markErrPart: 'Enmarque la parte anormal'
      },
    warningTip: 'Tablero procesado de alto brillo de doble cara: procese <span class="font-style">superficie de alto brillo</span> primero, luego procese <span class="font-style">superficie mate</span>; tablero de alto brillo procesado por una sola cara: procese directamente <span class="font-style">superficie mate</span>',
    showDetail: {
      tip1: 'Haga clic para seleccionar un solo tablero',
      tip2: 'Ver etiquetas del tablero'
      },
    arrangeTip: '(se admite diseño anidado con formas especiales)',
    plankOpration: 'Operación del panel',
    rotate: 'Girar 90 grados',
    notCare: 'El panel no tiene textura',
    editRemark: 'Editar notas',
    clearRemark: 'Borrar notas',
    recalcIndex: 'Recalcular el punto de corte y la secuencia de corte',
    recalcIndexSuccess: 'Recalcular el punto de corte y la secuencia de corte exitosamente',
    storageArea: {
      title: 'Área de almacenamiento temporal de la placa',
      empty: 'Sin almacenamiento temporal de la placa',
      storageTip: 'Puede arrastrar la placa aquí para guardarla temporalmente'
      },
    subtleArrange: 'Composición tipográfica fina',
    addPlank: 'Agregar placa grande',
    deletePlank: 'Eliminar placa grande',
    deletePlankErr: 'Hay tablas pequeñas en la tabla grande actual y en la tabla grande ¡No se puede eliminar!',
    useSurplus: {
      title: 'Utilice el material restante'
      },
    dragWarning: '¡Por favor arrastre el tablero al tablero grande!',
    areaWarning: 'No se puede colocar la tabla, preste atención al tamaño del espacio libre',
    subtlePage: {
      cut: 'Corte de material restante',
      lineTip: 'Corte de material restante',
      cancelCut: 'Corte final',
      cutPoint: 'Punto de succión de corte de material restante',
      storageArea: 'Área de espera de la tabla',
      cutErr: 'Solo se puede cortar en la tabla grande. ¡No toques el tablero pequeño!',
      saveErr: 'Primero seleccione un material recortado',
      cutErr2: '¡El corte solo se puede realizar en el tablero grande, no más allá del tablero grande!',
      selectTip: 'Seleccione un panel remanente cortado',
      noCutPath: 'Las piezas con formas especiales no se pueden cortar en rectángulos',
      cutOperate: 'Operación de corte del material restante',
      line: 'Trazo manual',
      cutErrtip: 'Hay un problema de corte transversal en el punto de corte, vuelva a recortar',
      cutErrtip2: 'El punto de corte excederá el límite de puntos: 9, vuelva a recortar'
      },
    shortCut: 'Teclas de acceso directo',
    updownRoll: 'Deslizar hacia arriba y hacia abajo',
    leftRightRoll: 'Deslizar hacia la izquierda y hacia la derecha',
    zoomScale: 'Acercar y alejar',
    dragCanvas: 'Arrastrar página',
    mouseRoll: 'Rueda del mouse',
    mouseRight: 'Botón derecho del mouse',
    mouseMultiSelect: 'Seleccionar varias hojas a la vez',
    mouseLeft: 'Botón izquierdo del mouse',
    doublePlank: 'Haga doble clic en el tablero',
    keyboard: 'Teclado',
    picSymble: 'Leyenda',
    funished: 'Producto terminado',
    holeSlotConflict1: 'Conflicto entre orificios y ranuras',
    plankErr: 'Conflicto entre paneles',
    frontSlot: 'Ranura frontal',
    backSlot: 'Ranura inversa',
    frontHole: 'Posición frontal',
    backHole: 'Posición de cara negativa',
    resetScale: 'Restablecer escala',
    maxLong: 'Más larga',
    tempErr: 'Error al agregar, la posición de la plantilla es incorrecta o la plantilla es demasiado grande.',
    sendErr: 'No se pudo enviar al taller, verifique si la plantilla de etiqueta y los datos del panel son correctos antes de enviar nuevamente',
    someTips: 'Está probando la función de anidamiento de formas especiales/remanentes de formas especiales de composición tipográfica en la nube por un tiempo limitado, ¡preste atención para evitar problemas de producción!',
    nestingTips: 'La prueba gratuita por tiempo limitado de [Diseño de anidamiento de formas especiales avanzado] ha expirado. Para seguir usándola, contacte con ventas para comprarla.',
    frameDoorTip: 'Se detecta que el tablero tiene conflictos de orificios y ranuras/el tablero pequeño sale volando',
    cutOrderErr: 'La secuencia de corte es incorrecta, haga clic para volver a calcular el punto de corte y la secuencia de corte.',
    holeSlotConflict: 'Se detecta que el tablero tiene conflictos de orificios y ranuras/el tablero pequeño sale volando',
    exportSetting: 'Configuración de exportación',
    currentTagTemp: 'Plantilla de etiqueta actual',
    specialPaibanErr: 'Algunos tableros tienen procesos especiales o ranuras de procesamiento de ribetes, ¡y el re-diseño no es compatible por el momento!',
    moreResult: 'Más resultados',
    moreResultTip: 'En el tablero grande hay ranuras para el procesamiento de ribetes. El tablero grande no participará en el rediseño',
    batchBujian: 'Parche por lotes',
    batchOperation: 'Operación por lotes',
    batchEditPlankSize: 'Modificación por lotes de tamaño de tablero grande',
    editPlankSize: 'Modificar tamaño',
    editWay: 'Método de modificación',
    editByType: 'Modificar por tipo',
    editByPlankNumber: 'Modificar por número de placa',
    editContent: 'Modificar contenido',
    editContentTip: 'Seleccione el tipo de placa que necesita modificarse',
    editContentTip1: 'Seleccione el número de placa que necesita modificarse',
    editStart: 'Inicio',
    editEnd: 'Final',
    bigPlank: 'Placa grande',
    editSize: 'Modifique el tamaño a',
    bigPlankWidth: 'Ancho de placa grande',
    bigPlankHeight: 'Longitud de placa grande',
    bigPlankLengthMarking: 'Identificación de longitud de placa grande',
    markedAs: 'Identificado como',
    maxAddTen: 'Agregar hasta 10',
    minValue: 'Valor mínimo',
    differentKnifeErr: 'Se seleccionan placas grandes con diferentes cuchillas de corte y el tamaño no se puede modificar',
    noEditablePlank: 'No hay placas grandes elegibles para modificar',
    skipBrandPlankTip: 'Hay {count} placas grandes de marca en el rango seleccionado que no admiten la modificación de tamaño y se han omitido',
    nonBrandToBrandTip: '¡Esta placa pequeña no se puede arrastrar a la placa grande de tarjeta de color de marca!',
    brandToNonBrandTip: '¡Esta placa pequeña no se puede arrastrar a la placa grande de tarjeta de color sin marca!',
    brandToOtherBrandTip: '¡Esta placa pequeña no se puede arrastrar a la placa grande de tarjeta de color de otra marca!',
    editNo: 'No.',
    editAllPlank: 'Todas las placas grandes',
    editBigPartSize: 'Modificación del tamaño de la placa grande',
    disPlaySetting: 'Configuración de visualización',
    stored: 'Ya almacenado',
    onlySurplus: 'Ver solo el material restante',
    UnuseSurplus: 'El material restante no participa en el cálculo de utilización',
    usePlankAdsorption: 'Adsorción del panel función',
    dataDefaultCollapsed: 'Los datos están contraídos de forma predeterminada',
    unit: 'Bloquear',
    cutSurplus: 'Resto',
    frontWarningTip: 'Tablero procesado de alto brillo de doble cara: procese primero <span class="font-style">superficie mate</span> y luego procese <span class="font-style">superficie de alto brillo</span><span>; Tablero de alto brillo procesado por una cara: procese directamente </span <span class="font-style">superficie de alto brillo</span>',
    selectTip: '¡Seleccione el tablero pequeño que necesita suplementos a continuación!',
    plankKeyWordPlaceholder: 'Por favor ingrese el nombre o número de placa de la placa',
    surplusStoreSuccess: 'Almacenamiento exitoso',
    editCutOrder: 'Modifique la secuencia de corte',
    setCutPoint: 'Establezca el punto de corte',
    specialPaibanChangeErr: 'Hay placas con procesos o ranuras especiales para el procesamiento de ribetes. ¡No se admite cambiar el esquema de diseño en este momento!',
    storedSuccess: '¡Reemplazo exitoso! ¡El panel seleccionado ha sido puesto en la gestión de repuestos!',
    noSurplus: 'No se consultaron materiales restantes disponibles',
    selectErrTip: 'Los materiales restantes no se pueden reparar, seleccione primero el tablero pequeño normal',
    noRoomIDTip: 'Este panel no tiene espacio ID y las piezas de reparación no se pueden colocar en el almacén. Seleccione primero otras tablas pequeñas',
    noPlank: 'Placa no encontrada',
    noPaibanData: 'No hay datos de composición, no se puede continuar',
    historyNameErr: 'Ingrese el nombre del plan',
    tempErrTip: 'Se detecta que no ha agregado la plantilla para brocas de cinco/seis lados, por lo que los archivos de procesamiento de brocas de cinco/seis lados no se pueden exportar. Nota: Debe volver a diseñar después de completar la adición',
    changeDataTip: 'Nota: Se detecta que sus datos han cambiado. ¿Quieres crear un nuevo archivo de historial para guardar este cambio?',
    upgrade: 'Actualización',
    upgradeTip: ', puede hacer clic en el botón a continuación para actualizar la versión',
    plankOverEdge: '¡La descarga NC falló! Verifique si hay paneles superpuestos o paneles fuera del panel grande',
    useSurplusTip: 'Si se debe deducir el material restante',
    noDataExport: 'No hay datos de composición tipográfica que se puedan exportar',
    noPlankExport: 'No hay datos de paneles pequeños que se puedan exportar',
    lockTip1: 'Haga clic para desbloquear. Después de desbloquear, puede',
    lockTip2: 'editar la ubicación y los atributos del panel pequeño',
    unlockTip1: 'Haga clic para bloquear. Después de bloquear, no puede editar la ubicación ni los atributos del panel pequeño',
    unlockTip2: 'edit the position and attributes of the small board',
    plankLockErr: 'El panel grande se ha bloqueado y no se puede colocar',
    lockPartEditTip: 'El panel está bloqueado y no se puede editar',
    glassEquipmentTip: 'Cuando la línea de producción es una máquina cortadora de vidrio, el panel no se puede mover',
    expandedTip: '¡El panel tiene un proceso de ranura especial y no admite operaciones de edición!',
    sameWidthPlankTip: 'Cuando el diseño de la hoja de sierra está activado, la tabla no se puede mover.',
    expandedArrangeTip: '¡El tablero tiene un proceso de ranurado especial y es necesario volver a diseñarlo!',
    dragErrTip: 'No se puede colocar, verifique las propiedades del material, el color y el grosor de la placa.',
    subtleSaveTip: 'La placa ha sido operada pero no guardada. ¿Quieres salir?',
    rollTip: 'Hay orificios pasantes/ranuras pasantes en la placa grande, por lo que no se recomienda copiar.',
    glossRollErr: 'Está prohibido voltear la placa resaltada',
    lockDeleteErr: 'La placa está bloqueada y no se puede eliminar',
    deleteConfirmTip: 'La operación de eliminación no se puede recuperar',
    deleteContinueTip: '¿Quieres continuar?',
    deleteConfirm: 'Confirme si desea eliminar',
    selectPlankTip: 'Seleccione la placa antes de realizar esta operación',
    storeFailTip: '¡Falló el almacenamiento del material restante! Compruebe si hay paneles superpuestos o paneles fuera del panel grande',
    repeatStoreErr: 'Los paneles de material restante actualmente cortados se han almacenado',
    surplusStoreFail: '¡Falló el almacenamiento, verifique si los paneles son rectangulares o con forma L!',
    plankConfilictErr: 'No se admite la colocación de puntos aquí y entrará en conflicto con otros paneles',
    surplusErrTip: 'No se admite la colocación de puntos aquí y se producirá un material remanente incorrecto',
    changeArrageSuccess: 'Se cambió con éxito el esquema de diseño',
    trialProduction: {
      trialProductionSample: 'Gabinete de muestras de producción de prueba',
      trialProduced: 'He probado la producción',
      trialWarning: '{fontStyleStart}Si {fontStyleEnd} no realiza la verificación de producción del gabinete de muestras, será el único responsable de todas las pérdidas y consecuencias adversas para usted, otros y el software de publicación en la nube',
      trialSlotTip: 'Durante la producción de prueba, verifique cuidadosamente si el tamaño, la profundidad, la superficie y la ubicación de las ranuras frontal y posterior son correctos',
      trialSlotTip1: 'para evitar la duplicación del gabinete',
      trialSlotTip2: 'pregunta',
      pleaseUploadTrial: 'Cargue fotos del gabinete de muestra de producción de prueba ensamblado',
      uploadTrial: 'Cargue gabinete de muestra'
      },
    awaitPlankStore: {
      store: 'Biblioteca de paneles para diseño',
      notTip: 'No más mensajes por no estar en stock',
      justLookCurrent: 'Solo vea los paneles pequeños del pedido actual',
      notInPushStorage: 'No disponible',
      beInStorage: 'Ya almacenado',
      searchPlaceholder: 'Ingrese el orden para buscar paneles pequeños de la biblioteca para escribir',
      plankUploading: 'Los paneles se están guardando',
      oneClickStorage: 'Almacenamiento con un solo clic en la biblioteca para diseño',
      notUsePlank: 'No hay paneles pequeños disponibles',
      notPlank: 'Sin almacenamiento temporal de la placa',
      dragPlankInHere: 'Puede arrastrar la placa aquí para guardarla temporalmente',
      surplusCannotBeStorage: 'Los materiales restantes no se pueden poner en el almacén',
      plankHasBeenDeduction: 'Los paneles pequeños han sido deducidos o no hay datos originales y no se pueden poner en el almacén',
      plankLoadErr: 'Error al cargar la información del panel',
      taskTitle: 'Cargar los paneles en la biblioteca para mecanografiarlos',
      dataGenErr: 'Error de generación de datos',
      pushSuccess: 'Almacenamiento exitoso',
      pushErr: 'Ocurrió un error desconocido y el almacén falló',
      awaitBoxExistPlank: 'El stock a componer no está en el almacén. Se recomienda operar después de ingresar al almacén',
      mergeFrameDoorWholeTip: 'Este componente es un componente integral de la puerta esquelética. Después del almacenamiento, el sistema lo desmontará automáticamente en paneles individuales para su gestión.',
      checkPlankStatus: 'Verificando el estado de la placa...'
      },
    batchSetCut: 'Configuración por lotes de puntos de corte',
    applyTo: 'Aplicable a:',
    ncDownloadLifeText: {
      checkData: 'Detectando datos',
      checkDone: 'Detección de datos completada',
      checkDataText: 'Detección de datos',
      loadSetting: 'Cargando configuraciones',
      settingLoadDone: 'Carga de configuraciones completada',
      loadSettingText: 'Carga de configuraciones',
      downloadNc: 'Descarga NC',
      ncDownloadDone: 'NC Descarga completa',
      downloadText: 'Descargue NC',
      loadPreferenceSetting: 'Carga de configuraciones de preferencias',
      PreferenceSettingLoadDone: 'Carga de preferencias completada',
      loadPreferenceText: 'Cargando preferencias',
      dealTemp: 'Procesamiento de plantillas',
      TempDealDone: 'Procesamiento de plantilla completado',
      dealTempText: 'Procesando plantillas',
      beBeingGenTagFile: 'Generación de archivos {fileType}',
      genTagFileDone: 'Generación de archivos {fileType} completado',
      genTagFileText: 'Generación de archivos {fileType}',
      zip: 'Generación de archivos comprimidos locales',
      zipDone: 'Generación de archivos comprimidos locales completada',
      genZipText: 'Generación de archivos comprimidos',
      fileTypeText: 'Imagen'
      },
    surplusCommonTemp: 'Plantillas comunes para los materiales restantes',
    plankErrTip: '¡Hay placas pequeñas en el plan de materiales actual y no hay placas grandes disponibles para la composición tipográfica!',
    brandPlankErrTip: 'El plan de materiales actual tiene piezas de marca sin placas de marca disponibles para el diseño!',
    overSizeTip: 'El número de planchas grandes es insuficiente o está sobredimensionado',
    uselessPart: 'Actualmente no hay planchas pequeñas disponibles en la plancha grande',
    splitArranged: 'Número de planchas pequeñas demasiado grande, por favor, reformate o compóngalas en lotes',
    arrangedErrTip: 'Falló la tipografía, no hay número suficiente de planchas grandes o las planchas pequeñas están sobredimensionadas',
    knivesModalTitle: 'Hay agujeros y no se puede encontrar la herramienta',
    cannotDownloadByKnivesErr: 'No se puede descargar NC, el sistema detecta que no se pueden encontrar los siguientes orificios y ranuras y no se puede encontrar la herramienta',
    viewPart: 'Vea el tablero pequeño problemático',
    deductionModalTitle: 'Seleccione el objeto de deducción',
    bujianDeduction: 'Deducción de tablero pequeño de piezas suplementarias',
    paibanDeduction: 'Deducción del tablero pequeño del área de almacenamiento temporal',
    surplusDeduction: 'Deducción del tablero de material restante',
    unlockPaiban: 'Desbloquee el material restante que participa en la composición tipográfica',
    maintain: 'Mantenga el bloqueo del material restante que participa en la composición tipográfica',
    lockModalText: 'Hay un material restante tablero ocupado por otros pedidos, si se debe volver a diseñar',
    lockNewSModalText: 'El tablero de material restante actualmente utilizado está ocupado por otros pedidos. Quieres continuar descargando NC',
    rePaibanWarn: 'Los tableros grandes restantes están ocupados por otros pedidos y no hay suficientes tableros grandes disponibles. Vaya a la lista de cortes para volver a diseñar',
    sawRePaiban: 'Nota: está utilizando una hoja de sierra para cortar y se ha agregado un diseño de tabla con una forma especial. Debe volver a diseñar antes de poder generar el archivo NC',
    togglePlankTip: '. Los paneles tienen un proceso de ranura especial y las operaciones de cambio frontal y posterior no son compatibles.',
    stepCuttingMsg: 'La profundidad del corte en capas debe ser menor que el espesor de la placa',
    stepCuttingMsg2: 'La profundidad del corte en capas solo se puede ingresar como un número mayor que 0',
    flipPlankTip: '¡La máquina de corte por ranura se ha encendido para procesar un solo panel y no se permite la operación de giro de la placa!',
    genNoCutTagNotSupportExportPic: 'Se ha habilitado la generación de etiquetas para piezas de placa sin cortar. Por el momento no se admite la exportación de imágenes.',
    allSmallPlanksAreNoCutNotInLayout: 'Las planchas pequeñas actuales son todas planchas sin cortar y no participan en la composición tipográfica.',
    canStillExportHoleSlotOrPrintTag: 'Aún puedes continuar exportando archivos de procesamiento de agujeros o imprimiendo etiquetas.',
    desMaterialNoCutNotSupportSwitchLine: 'La línea de producción actual ha sido encendida. El material de placa pequeña especificado no se corta. Por el momento no se admite el cambio directo de la línea de producción.',
    desMaterialNoCutSettingChanged: 'El sistema ha detectado que se ha modificado la configuración de no cortar el material de placa pequeña especificado. Vuelva a diseñar para garantizar una producción precisa',
    continueDownload: 'Continuar descargando',
    desMaterialNoCutErrorTip: 'Hay agujeros/formas especiales asignadas a la máquina de grabado en los paneles especificados para no cortar el material de la placa pequeña. Todos los agujeros/formas especiales de esta descarga están asignados a perforaciones de cinco o seis lados. ¿Desea continuar descargando el archivo?',
    clearReuseRelation: 'Haga clic para borrar la relación de reutilización',
    layoutReuseTip: 'Replique rápidamente el diseño del panel grande; los cambios en el panel eliminan automáticamente la relación de reutilización',
    hasBeenReused: 'Ya reutilizado',
    layoutReuse: 'Reutilización de diseño',
    specialProcessNotSupported: 'El panel tiene procesos especiales, esta operación no es compatible',
    conflictNotSupported: 'Conflicto de panel detectado, esta operación no es compatible',
    noAvailablePlankForReuse: 'No hay paneles disponibles para reutilizar',
    noMatchingPlankFound: 'No se encontró un panel coincidente',
    reuseBoard: 'Reutilizar panel {number}',
    influenceTip: {
      title: 'Funciones que afectan la tasa de optimización',
      empty: 'Ninguno',
      groupParams: 'Parámetros de disposición',
      surplusNoRoll: 'Sin volteo de material sobrante',
      surplusCustomTrim: 'Valor de recorte individual',
      otherPlateCustomTrim: 'Valor de recorte individual para panel especial',
      knifeDiameter: 'Diámetro de la sierra',
      surplusNoFlip: 'Sin volteo de material sobrante',
      surplusNotLayout: 'Panel sobrante no se dispone en placas especificadas',
      plankEdgeOff: 'Recorte',
      surplusCustomTrim2: 'Ajuste de corte de sobras personalizado',
      other: 'Otras funciones que pueden verse afectadas',
      enabled: 'Activado',
      plankThicknessStacking: 'Apilamiento de grosor de tablero',
      edgePreMilling: 'Apilamiento de grosor de tablero',
      multiMaterialCuttingBlade: 'Apilamiento de grosor de tablero',
      sawSpecialShapePart: 'Tableros con muescas de forma especial para sierras y grabadoras',
      longPlankCutting: 'Procesamiento secundario de tableros largos'
      }
    },
  paibanImg: {
    title: 'Gestión de diseño',
    exportCustomPaibanImg: 'Exportar diseño personalizado',
    customPaibanImg: 'Diseño personalizado',
    isCustomName: 'Nombre de diseño personalizado',
    template: 'Plantilla de diseño',
    addTem: 'Agregar plantilla',
    canvasIndexSearch: 'Búsqueda de número de serie de placa grande',
    symbol: 'Identificación de diseño',
    frontSlot: 'Ranura frontal',
    backSlot: 'Ranura posterior',
    frontHole: 'Cara frontal',
    backHole: 'Cara posterior',
    printNum: 'Imprimir una hoja de papel para mostrar como máximo',
    printUnit: 'dibujos de diseño',
    edit: 'Edición de plantilla de diseño',
    temName: 'Nombre de plantilla',
    rotate: 'Rotación de diseño',
    showOverflow: 'Cuando el texto desborda el tablero, la línea de identificación muestra los datos del tablero pequeño',
    showHoleSlot: 'Muestra la información de orificios y ranuras',
    bigPartCss: 'Ajusta el estilo del diagrama de diseño del tablero grande',
    partCss: 'Ajusta el estilo del diagrama de diseño del tablero pequeño',
    addTemTip: '¡Solo se pueden agregar 10 plantillas de diagrama de diseño como máximo!',
    exportTip: '¡Marque al menos una plantilla de diseño para exportar!',
    editSaveTip: '¡Confirme que todos los campos obligatorios estén completos antes de guardar!',
    exportDXF: 'Exportar DXF',
    exportDxfGeneral: 'DXF general 2D',
    exportDxf3d: 'DXF especializado 3D',
    exportDxfGeneralTip: 'Adecuado para el procesamiento manual, cortar consultando el dibujo o comprobar el resultado de la distribución',
    exportDxf3dTip: 'Adecuado para importar a sistemas de terceros para la producción; compatible con máquinas integradas de corte láser Huiya'
    },
  historyPage: {
    matchErrBySpecialTip1: 'No se puede encontrar ninguna coincidencia para los siguientes tableros especiales y habrá problemas al volver a diseñar la página de diseño. Si se utiliza un esquema de diseño mixto en este historial, ignore este mensaje',
    specialPlankInfoErrTip2: 'Se produjo un error al obtener información especial del tablero, lo que afectará la función de re-diseño en la página de diseño',
    download: 'Descargar local',
    allType: 'Guardar todo',
    handleSave: 'Guardar manualmente',
    specialPlank: 'Especial',
    surplusPlank: 'Excedente',
    autoSave: 'Guardar automáticamente',
    allArrange: 'Todo el diseño',
    searchPlaceholder: 'Buscar nombre de pedido / lote de maquetación / número de pedido',
    saveHistoryName: 'Nombre del historial guardado',
    trailProduction: {
      title: 'Gabinete de muestras de producción de prueba',
      lastTime: 'Última fecha de producción de prueba',
      recordList: 'Registro de producción de prueba',
      start: 'Iniciar producción de prueba',
      date: 'Hora',
      outputFrom: 'Posición de salida',
      empty: 'Aún no hay datos',
      record: 'Registro de imagen de gabinete de muestra de producción de prueba cargado',
      tip1: 'Nota: La orden de producción de prueba actual utiliza los datos de producción predeterminados',
      tip2: 'Nota: La orden de producción de prueba actual no utiliza los últimos parámetros de configuración del proceso. ¡Puedes ir a la sala de producción de prueba para guardarlo nuevamente!',
      download: 'Descargar archivos de procesamiento'
      },
    deleteTip: '¿Está seguro de eliminar los siguientes registros del historial?',
    startDate: 'Fecha de inicio',
    endDate: 'Fecha de finalización',
    lastWeek: 'La semana pasada',
    lastMonth: 'El mes pasado',
    lastSeason: 'Los últimos tres meses',
    toArrangePage: 'Dirigiéndose a la página de composición tipográfica',
    notArrangedTip: 'Este registro no ha sido compuesto, ¡vaya primero a la lista de materiales!',
    toMaterialPage: 'Dirigiéndose a la página de lista de materiales',
    lessSelectTip: 'Seleccione al menos un registro antes de realizar esta operación',
    downloadNc: 'Descargar archivos de procesamiento'
    },
  workShopPage: {
    warningTip: 'Esta función es una prueba por tiempo limitado, ¡organice la producción de su pedido de manera razonable!',
    fileManager: 'Gestión de archivos de producción',
    selected: 'Seleccionado',
    suplement: 'Piezas de reposición',
    size: 'Tamaño',
    saveToStore: 'Agregar almacén de piezas de reposición',
    enterArrange: 'Ingresando tipografía...',
    deleteTip: 'Estos datos no se pueden restaurar después de eliminarlos. ¿Confirmas eliminar estos datos?',
    arrangeTip: 'Analizando datos de reposición, espere...',
    store: 'Almacén de piezas de reposición',
    downloadFile: 'Descargar archivos de producción',
    notBujianFile: 'Archivos de reposición no encontrados',
    productLineDelete: 'La línea de producción ha sido eliminada y el archivo NC ¡No se puede descargar!'
    },
  basePlankManager: {
    saveTip: 'Nota: Presione Enter para guardar',
    offsetSize: 'Tamaño de recorte',
    overSizeTip: 'Cuando el tamaño es demasiado grande, se seleccionará automáticamente una placa de mayor tamaño para la composición tipográfica',
    addTip: 'Si la placa es demasiado grande durante la composición tipográfica, aparecerá una ventana emergente para agregar automáticamente una placa grande especial',
    defaultOversizePlankValue: 'Establecer el tamaño predeterminado de las placas grandes especiales',
    onlyLayoutTooBig: 'Las placas grandes de gran tamaño solo organizarán placas pequeñas de gran tamaño',
    settingRemark: 'Nota: La función original aquí se ajusta a la configuración de la derecha',
    searchPlaceholder: 'Buscar material/color de placa',
    syncData: 'Sincronizar datos del gabinete',
    syncDataM: 'Sincronizar datos de la puerta del gabinete',
    deletePlank: 'Eliminar placa grande especial',
    addPlank: 'Crear nueva placa especial',
    matCodePlaceholder: 'Seleccione la placa',
    thickPlaceHolder: 'Seleccione el grosor',
    widthErr: 'El ancho de la placa no puede estar vacío',
    heightErr: 'La longitud de la placa no puede estar vacía',
    matCodeErr: 'El material de la placa no puede estar vacío',
    colorErr: 'El color de la placa no puede estar vacío',
    editPlank: 'Editar placa',
    deleteTip: 'Estos datos no se pueden restaurar después de eliminarlos. ¿Confirmas eliminar estos datos?',
    plankKnifeSelect: 'Selección de cuchilla de corte original',
    plankKnifeSelectTip: 'Cuando una placa cumple con varias reglas, el grosor de la placa tiene prioridad sobre el material de la placa',
    knifeSelectTip: 'Nota: La composición tipográfica en línea actualmente no admite esta función',
    knife: 'Herramienta de corte',
    matcodeInput: 'Ingrese el material de la placa',
    thickInput: 'Ingrese el espesor de la placa',
    default: 'Predeterminado del sistema',
    unessential: 'Esta columna es: opcional',
    emptyTip: 'Nota: Si este elemento no se completa, estos datos no se distinguirán cuando coincidan con la pieza original.',
    defaultUse: 'Seleccionar de forma predeterminada',
    editMatcode: 'Editar material',
    syncTip: 'Los datos en {fromMc} se adquirirán y sobrescribirán con los datos de gestión de la película originales en el diseño de nube existente. ¿Está sincronizado?',
    sameErr: 'Los mismos datos ya existen',
    cancelDelete: 'La eliminación se canceló',
    syncErr: 'Sincronización fallida',
    syncSuccess: 'Sincronización exitosa',
    syncDataTip: 'Sincronizar {fromMc} datos',
    editErrTip: 'Hay información sin completar, ¡verifíquela!',
    numberCheck: '{type} ¡Solo se pueden ingresar números!',
    deleteStandardPlate: 'Eliminar placa estándar',
    createStandardPlate: 'Crear nueva placa estándar',
    editStandardPlate: 'Editar placa estándar',
    trimmingDimension: 'Tamaño de recorte',
    front: 'Anterior',
    back: 'Siguiente',
    left: 'Izquierda',
    right: 'Derecha',
    frontTrim: 'Recorte superior',
    backTrim: 'Recorte inferior',
    leftTrim: 'Recorte izquierdo',
    rightTrim: 'Recorte derecho',
    customTrim: 'El valor de recorte personalizado',
    trimValue: 'Valor de corte',
    notEmpty: '{type} no puede estar vacío.',
    edgeDir: 'Recorte ({type})',
    brandPlank: 'Placa de marca',
    brandPlankTip: 'Nota: La eliminación y modificación de placas de marca se realizan en la biblioteca de recursos de placas del cliente Cabinet',
    brand: 'Marca',
    supplier: 'Proveedor',
    brandPlaceholder: 'Seleccione marca',
    supplierPlaceholder: 'Seleccione proveedor',
    brandInput: 'Ingrese marca',
    supplierInput: 'Ingrese proveedor',
    addBrandPlank: 'Agregar placa de marca',
    deleteBrandPlank: 'Eliminar placa de marca',
    editBrandPlank: 'Editar placa de marca',
    searchBrandPlaceholder: 'Buscar marca/proveedor/material/color'
    },
  bujianAndStore: {
    bujianStore: 'Almacén de piezas de reposición',
    awaitStore: 'Biblioteca de diseño de paneles',
    depositAwaitStore: 'Guardar en la biblioteca para componer',
    pushToAwaitStore: 'Colóquelo en la biblioteca para componer',
    useTwoTableArrange: 'Utilice dos formularios para componer',
    confirmUseTwoTableTip: 'La pequeña pizarra actualmente seleccionada contiene la biblioteca de parches y la biblioteca para componer. ¿Quieres seguir escribiendo la pizarra?',
    confirmAddPlankToAwaitStore: '¿Está seguro de agregar el panel seleccionado a la biblioteca de diseños?',
    pushStoreSuccess: 'Almacenamiento exitoso',
    dataGenErr: 'Error de generación de datos',
    unknownErr: 'Ocurrió un error desconocido y el almacén falló'
    },
  surplusPage: {
    surplusMaterial: 'Lista de materiales restantes',
    surplusStore: 'Biblioteca de materiales restantes',
    recycleBin: 'Biblioteca de materiales restantes',
    recycleBinTip: 'Los datos de materiales sobrantes se eliminarán automáticamente después de estar más de 90 días en la papelera de reciclaje',
    "deleteReason-0": 'Eliminación manual',
    "deleteReason-1": 'Deducción por composición',
    "deleteReason-2": 'Salida mediante operación móvil de Guigui',
    surplusShape: 'Forma del material restante',
    batchTransfer: 'Transferencia por lotes',
    createNewSurplusStore: 'Crear una nueva biblioteca de materiales restantes',
    pushStoreSetting: 'Configuración de almacenamiento de materiales restantes',
    surplusStoreName: 'Nombre de la biblioteca de materiales restantes',
    surplusStoreName2: 'Nombre de la biblioteca de materiales restantes',
    addSurplusStore: 'Agregar biblioteca de materiales restantes',
    inventoryCeiling: 'Límite de existencias',
    autoTransferTip: 'Después de la eliminación, los materiales restantes en el El almacén se transferirá automáticamente a la lista de materiales restantes',
    asIndexPushStore: 'y se almacenará en orden de acuerdo con la situación de almacenamiento del almacén',
    pushToSurplusMaterial: 'Almacene los materiales restantes en la lista',
    surplusStoreTable: {
      number: 'Número',
      name: 'Nombre de la biblioteca de materiales restantes',
      quantity: 'Cantidad de materiales restantes almacenados (unidades)',
      capacity: 'Límite de inventario de material restante (unidades)',
      rules: 'Reglas de almacenamiento de material restante',
      remark: 'Comentarios',
      operation: 'Operación'
      },
    editSurplusStore: 'Editar la biblioteca de materiales restantes',
    addSurplus: 'Agregar el material restante',
    importSurplus: 'Importar el material restante',
    downloadSurplusTemplate: 'Descargar la plantilla de importación de material restante',
    batchExportSurplus: 'Exportar la lista actual de materiales restantes',
    surplusBatchImportExport: 'Importar y exportar por lotes el material restante',
    surplusMaterialStorageCode: 'Código de almacenamiento de material restante',
    generateQRCodeSuccess: 'Generar exitosamente el código QR',
    generateQRCodeFailed: 'No se pudo generar el código QR',
    refreshQRCode: 'Actualizar el código QR',
    refreshQRCodeFailed: 'No se pudo actualizar el código QR',
    cancelRefresh: 'Actualización cancelada',
    refreshQRCodeTip: 'Si se actualiza el código QR. Después de actualizar, el código QR actual dejará de ser válido.',
    refreshQRCodeConfirm: 'OK',
    refreshQRCodeCancel: 'Cancelar',
    wechatScanTip: 'Abra WeChat y escanee el código QR para agregar manualmente el material restante al almacén para su uso',
    deletSurplus: 'Eliminar el material restante',
    editSurplus: 'Modificar el material restante',
    surplusNoRoll: 'Habilitar el material restante sin copiar',
    type: {
      all: 'Todas las formas'
      },
    allMatcode: 'Todos los materiales',
    allThick: 'Todos los espesores',
    surplusName: 'Nombre del material restante',
    rectSurplus: 'Material restante rectangular',
    LTypeSurplus: 'L material remanente con forma',
    noMatchSup: 'No se encontraron datos relevantes',
    jumpTo: 'Saltar a',
    page: 'Página',
    newMatcode: 'Nuevo material',
    newColor: 'Nuevo color',
    autoCreateColor: 'Presione Enter para crear automáticamente una tarjeta de color',
    nameLimit: 'Ingrese hasta 10 caracteres para el nombre del material remanente',
    nameLimitNameErr: 'El nombre del material remanente no puede estar vacío',
    tempLongTip: 'Solo se pueden ingresar números para la longitud de la placa',
    minLongLimit: 'Solo números se puede ingresar para la longitud del lado corto',
    minLongEmptyTip: 'La longitud del lado corto no puede estar vacía',
    minLongLimitMax: 'La longitud del lado corto no puede exceder la longitud de la placa',
    widthLimit: 'El ancho de la placa solo puede ingresar números',
    minWidthLimit: 'El ancho del lado corto solo puede ingresar números',
    minWidthEmptyLimit: 'El ancho del lado corto no puede estar vacío',
    minWidthLimitMax: 'El ancho del lado corto no puede exceder el ancho de la placa',
    thickLimit: 'El espesor de la placa solo puede ingresar números',
    thickEmptyLimit: 'El espesor de la placa no puede estar vacío',
    countInputLimit: 'La cantidad solo puede ser un número entero positivo',
    countEmptyLimit: 'La cantidad no puede estar vacía',
    remarkMaxlimit: 'Se pueden ingresar comentarios de hasta 50 caracteres',
    orderAddressMaxlimit: 'La dirección del pedido de origen se puede ingresar de hasta 100 caracteres',
    orderIdMaxlimit: 'El número de pedido de origen se puede ingresar de hasta 100 caracteres',
    createTime: 'Agregar hora',
    deleteTime: 'Tiempo de eliminación',
    deleteReason: 'Razón de eliminación',
    branchName: 'Almacén de material residual',
    orderAddress: 'Dirección del pedido de origen',
    orderId: 'Número de pedido de origen',
    lockStatus: 'Estado de bloqueo',
    lockOrder: 'Orden de bloqueo',
    enableSurplusLock: 'Habilitar la función de bloqueo de material restante',
    isCloseSurplusLock: 'Después de desactivar la función, todos los materiales restantes se desbloqueado. ¿Quieres continuar?',
    confirm: 'Confirmar para cerrar',
    surplusTransfer: 'Transferencia de material restante',
    targetSurplusStore: 'Biblioteca de material restante de destino',
    enableSurLockTip: 'Después de abrir, los materiales restantes utilizados se bloquearán para cada composición tipográfica para evitar que otros pedidos ocupen',
    addMainRule: 'Agregar regla principal',
    surplusRules: 'Reglas de almacenamiento de material restante',
    mainRulesTip: 'Existe una relación OR entre las reglas principales, es decir, siempre que se cumpla una regla principal, el material restante se colocará en el almacén',
    mainRulesTip1: 'Después de agregar una regla, los materiales restantes que cumplan la regla se almacenarán primero en este almacén. Cuando el almacén esté lleno se almacenará en otros almacenes libres de materiales restantes.',
    rule: 'Regla',
    addSubRule: 'Agregar subregla',
    subRuleTip: 'La relación entre las subreglas es y, es decir, todas las subreglas bajo la regla principal deben cumplirse al mismo tiempo antes de poder colocarse en el almacén',
    bigPlankMatCode: 'Material de tablero grande',
    bigPlankThick: 'Espesor de placa grande',
    bigPlankColor: 'Color de tablero grande',
    greaterEqual: 'Mayor o igual a',
    lessEqual: 'Menor o igual a',
    capNumberCheck: '¡El límite superior del inventario solo se puede ingresar como un número entero!',
    capEmptyCheck: '¡El límite superior del inventario no puede estar vacío!',
    surNameEmptyCheck: '¡El nombre de la biblioteca de materiales restante no puede estar vacío!',
    mainRuleLimit: 'La regla principal ha alcanzado el límite superior',
    delMainRuleTip: '¿Quieres eliminar esta regla principal?',
    matCodeEmptyCheck: '¡El material del plato grande no puede estar vacío!',
    thickEmptyCheck: '¡El grosor del plato grande no puede estar vacío!',
    textureEmptyCheck: '¡El color del plato grande no puede estar vacío!',
    enableWarehouseSecondCon: 'Habilitar confirmación secundaria del almacenamiento de material restante',
    surplusWarehouseConfirm: 'Confirmación de almacenamiento de material restante',
    surplusWarehouseConfirm1: 'Confirmación de almacenamiento',
    closeSurplusConfirm: 'Desactivar la confirmación de almacenamiento (se puede volver a habilitar en la configuración de la página de administración de material restante)',
    position: 'Ubicación de almacenamiento',
    nameRepeatTip: 'El nombre del material remanente actual ya existe, modifíquelo y vuelva a ingresar al almacén',
    surLimitTip: 'La biblioteca de material remanente actual ha alcanzado el límite superior o no cumple con las reglas de almacenamiento',
    surFailTip: 'El almacenamiento falló, hay un nombre duplicado del material restante o el almacenamiento del silo de material restante ha alcanzado el límite superior o no cumple con las reglas de almacenamiento',
    surplusExistTip: 'Algunos paneles de material restante ya están en la biblioteca, esta operación falló',
    surplusExistTip2: 'Los paneles de material restante actuales ya están en la biblioteca y no se pueden almacenar',
    currentPage: 'Página actual',
    totalPage: 'Seleccionar todo'
    },
  printPage: {
    goto: 'Ir ahora',
    surplusSizeTittle: 'Recuerde que el tamaño del material restante es demasiado pequeño',
    surplusSizeErrTip: 'El tamaño del material restante es demasiado pequeño, vaya a la línea de producción correspondiente para establecer el tamaño mínimo del material restante.',
    opacityTip: 'Soporte técnico proporcionado por Zhihui Color Label',
    opacityTip2: 'La cuenta actual no ha comprado Zhihui Color Label; si lo compró, vincule la cuenta del gabinete en el software de etiquetas de color',
    loadFontTip: 'Cargando el archivo de recursos de fuente requerido, espere',
    leftAlign: 'Alineación izquierda',
    rightAlign: 'Alineación derecha',
    topAlign: 'Alineación superior',
    bottomAlign: 'Alineación inferior',
    horizontalAlign: 'Alineación central horizontal',
    verticalAlign: 'Alineación central vertical',
    horizontalSplit: 'División horizontal',
    verticalSplit: 'División vertical',
    norTag: 'Etiqueta original normal',
    surTag: 'Etiqueta de material restante',
    genTag: 'Generar etiqueta',
    all: 'Seleccione todo',
    deleteWarning: 'Recordatorio',
    print: 'Imprimir',
    defaultTemplate: 'Plantilla predeterminada (60 x 40)',
    editTemplate: 'Editar plantilla',
    deleteTip: 'No se puede restaurar la eliminación de esta plantilla. ¿Estás seguro de eliminar esta plantilla?',
    tagSetting: 'Configuración de etiquetas',
    rememberSetting: 'La configuración se recordará después de la modificación',
    genCutingTag: 'Generar etiquetas para paneles recortados',
    genSurplusTag: 'Generar etiquetas para paneles restantes',
    genPlankTag: 'Generar etiquetas para paneles grandes',
    genPartTag: 'Generar etiquetas para paneles pequeños',
    genNoCutTag: 'Generar etiquetas para paneles sin cortar',
    tagPosition: 'Posición de etiquetado',
    tagPositionTip: '(Solo para máquinas etiquetadoras, debe completar el X/Y coordenadas a continuación.)',
    Xposition: 'XCoordenadas',
    Yposition: 'YCoordenadas',
    genPlankSuffix: 'Sufijo del nombre del archivo de borrado de generación de etiquetas de placa grande',
    arrangeMirror: 'Espejo de imagen de etiqueta',
    drillPlankBase: 'Referencia de colocación y perforación de cinco o seis lados',
    drillPlankBaseTip: 'Error al obtener los datos de referencia de colocación de la placa, ¡inténtelo de nuevo más tarde!',
    suitAuto: 'La clasificación de etiquetas se adapta a la carga y descarga automática:',
    colorLabel: 'Generar etiquetas de color',
    colorRevert: 'Generar etiquetas de color inverso para paneles pequeños',
    displayEnAndZh: 'Visualización del nombre de habitación/gabinete/panel en chino e inglés',
    displayEnAndZhTip: 'Solo admite el nombre predeterminado de habitación/gabinete/panel. Esta función no tiene efecto después de cambiar a un nombre personalizado',
    up: 'Arriba',
    down: 'Abajo',
    default: 'Predeterminado',
    printSetting: 'Configuración de impresión',
    oneToMore: 'Varias páginas por página',
    perPage: 'por hoja',
    coloumn: 'columnas',
    tagMargin: 'espacio entre etiquetas',
    coloumnMargin: 'espacio entre columnas',
    specialMark: 'marca especial',
    opacity: 'transparencia',
    opacityTip3: 'Las imágenes en el formato BMP deben seleccionar un color verdadero para admitir la transparencia',
    suite: 'Adaptable',
    svgListTip: 'La generación de etiquetas de tablero pequeño no está habilitada, verifique',
    size: 'Tamaño',
    lightSide: 'Borde visible',
    locFrontSide: 'Frente del gabinete',
    openSide: 'Dirección de apertura de la puerta',
    extraTip: 'Consejo: cuando utilice la impresión directa por primera vez, agregue un papel nuevo de este tamaño con longitud y ancho intercambiados en la configuración de la impresora y luego use el papel nuevo para imprimir (por ejemplo: tamaño de papel original). 60×40, nuevo tamaño de papel 40×60)',
    noMore: 'No más',
    prepareData: 'Preparando datos...',
    genTagFile: 'Se están generando etiquetas. ¡No cambie de página, minimice el navegador, no se desplace hacia arriba o hacia abajo por las etiquetas, etc.!',
    waitGen: 'Espere a que se complete la carga de la etiqueta antes de descargarla',
    tempLoading: 'La plantilla de etiqueta se está cargando, espere',
    front: 'Anterior',
    open: 'Abrir',
    toEdit: 'Ir a editar',
    simplifyOneCodeTip: 'Nota: Los atributos de código de barras establecidos en esta plantilla de etiqueta no admiten la función "Código de barras simple". Modifique los atributos del código de barras (atributos de código de barras recomendados: CODE128)',
    plankTemp: 'Plantilla de etiqueta de placa pequeña',
    surplusTemp: 'Plantilla de etiqueta de material restante',
    enableSubTag: 'Habilitar etiqueta secundaria',
    enableSubTagTip: 'Puede configurarlo en Más ajustes > Configuración de etiqueta secundaria de panel pequeño > Configurar la fuente de datos efectiva para la generación de etiqueta secundaria. Tras activarlo, solo se genera la etiqueta secundaria si la fuente de datos configurada tiene valor en ella; de lo contrario, no se genera.',
    goSet: 'Ir a ajustes',
    mainTag: 'Etiqueta principal de panel pequeño',
    subTag: 'Etiqueta secundaria de panel pequeño',
    downloadSubTagTip: 'Las etiquetas exportadas incluyen una etiqueta secundaria. La línea de producción de etiquetado automático no puede generar etiquetas secundarias por el momento. ¿Desea continuar con la salida?',
    embeddedSubTagTip: 'La función de etiqueta secundaria no está soportada. Por favor, abra el diseño en la nube para usarlo.',
    subTagPerSaveTip: 'El permiso de etiqueta secundaria ha expirado. Por favor, cierre la etiqueta secundaria y guárdelo de nuevo.',
    subTagPerexportTip: 'El archivo de producción exportado contiene permisos de etiqueta secundaria pagados. Esta función ha expirado y necesita cerrarse y volver a salir.',
    tempNamePlaceHolder: 'Ingrese el nombre de la plantilla',
    editTip: 'Puede arrastrar el botón izquierdo al papel de etiqueta derecho para completar la edición de la plantilla de etiqueta según sus propias necesidades',
    oneCode: 'Código de barras',
    image: 'Imagen',
    arrow: 'Flecha',
    editPage: {
      digitLimitation: 'Límite de dígitos',
      title: 'Edición de plantilla de etiqueta',
      reset: 'Restaurar valor predeterminado',
      exit: 'Salir de la edición',
      tagInfo: 'Información de etiqueta',
      tagName: 'Nombre de etiqueta',
      tagSize: 'Tamaño de etiqueta',
      tagData: 'Datos de etiqueta',
      dragTip: 'Mantenga presionado el botón izquierdo del mouse y arrastre la etiqueta de datos',
      dataTip: 'Seleccione la información de datos en la barra de propiedades derecha',
      text: 'Texto',
      dataSource: 'Información de datos',
      graph: 'Gráficos',
      typograpyPic: 'Dibujo de diseño',
      barCode: 'Código de barras',
      QRCode: 'Código QR',
      plankMark: 'Marca del panel',
      holeSlotPic: 'Diagrama de orificios y ranuras',
      edgeBandPic: 'Diagrama de bandas de borde',
      visibleEdgePic: 'Borde visible',
      holeSlotPicZoom: 'Escala del diagrama de orificios y ranuras',
      rotateDeg: 'Ángulo de rotación',
      colorDeep: 'Profundidad de color',
      surplusMark: 'Identificación del material restante',
      surplusSizePic: 'Diagrama de tamaño del material restante',
      dataSize: 'Tamaño de los datos',
      extraList: 'Lista adicional',
      QRCodeFormat: 'Formato de código QR',
      formatQR: 'Formato QR',
      formatDM: 'Formato DM',
      locIndex: 'Número de serie del gabinete',
      plankFrontSign: 'Marca del panel',
      genNCSuffix: 'Generar sufijo NC',
      table: 'Tabla',
      inputPlaceholder: 'Haga doble clic para ingresar texto',
      attribute: 'Propiedades',
      fontFamily: 'Tipo de fuente',
      fontSize: 'Tamaño de fuente',
      fontWeight: 'Fuente negrita',
      flipOverProcessing: 'Procesamiento de volteo',
      showSideMachiningSequenceDiagramBorder: 'Mostrar diagrama de secuencia de procesamiento de lado',
      showSideMachiningSequenceNumber: 'Mostrar número de secuencia de procesamiento de lado',
      autoRow: 'Ajuste de texto',
      rowMargin: 'interlineado',
      autoFontSize: 'Ajustar automáticamente el tamaño de fuente para desbordamiento',
      statisticsDimension: 'Dimensiones estadísticas',
      noLimit: 'Ilimitado',
      sameOrderNo: 'Mismo orden',
      sameRoom: 'Misma habitación',
      sameWardrobe: 'Mismo gabinete',
      alignWay: 'Alineación',
      JustifyLeft: 'Alineado a la izquierda',
      JustifyRight: 'Alineado a la derecha',
      JustifyCenter: 'Alineado al centro',
      otherOpration: 'Otras operaciones',
      attributeReset: 'Restablecimiento de parámetros',
      barCodeSize: 'Tamaño del código de barras',
      installPic: 'Diagrama de instalación',
      plankCode2: 'Código de barras del panel (noMark)',
      frontCode: 'Código de barras frontal',
      backCode: 'Código de barras inverso',
      orderRemark: 'Comentarios del pedido',
      NCFileName: 'Nombre del archivo en blanco',
      NCFileNameTip: 'El nombre del archivo en blanco no debe contener caracteres chinos y no puede exceder los 10 dígitos de longitud',
      showOpenSide: 'Mostrar la dirección de apertura de la puerta',
      limitFixed: 'Limitar el número de puntos decimales',
      showFrontHS: 'Mostrar las ranuras frontales',
      showBackHS: 'Mostrar la ranura inversa',
      showPartEdge: 'Bandas de borde del panel de visualización',
      showPlankSize: 'Tamaño del panel de visualización',
      tempNamePlaceholder: 'Ingrese el nombre de la etiqueta',
      deleteAreaTip: 'Seleccione el bloque que desea eliminar',
      suitShunt: 'Bandas de borde del panel de visualización',
      suitShuntTip: 'Después de seleccionar, las piezas de ranuras que no tienen procesos posteriores después de la bifurcación no generarán códigos de barras',
      noHoleSlot: 'El código de barras también se muestra para ranuras sin orificios',
      rotate: 'Girar el código de barras',
      barcodeAtrribute: 'Propiedades del código de barras',
      imgSize: 'Tamaño de imagen',
      graphStyle: 'Estilo gráfico',
      noEdgeDisplay: 'Las bandas de borde son 0 y no se muestran',
      allEdgeNoDisplay: 'Las bandas de borde no se muestran',
      isShowDiffEdgeColor: 'Muestra cada borde color de banda',
      hideSameEdgeColorAsPlank: 'Ocultar color de borde cuando es el mismo que el color de la placa',
      hideSameEdgeColorAsPlankTip: 'La composición tipográfica en la nube integrada aún no es compatible',
      imgRotate: 'Rotación de imagen',
      circleD: 'Diámetro del marco circular',
      roomNo: 'Número de habitación',
      roomOrder: 'Número de gabinete (ordenado por habitación)',
      alphabetically: 'Ordenar por letras',
      numberOrder: 'Ordenar por números',
      specialMarkup: 'Símbolos de marcas especiales',
      smallPlateMarking: 'Marca de tablero pequeño',
      arrow: 'Flecha',
      triangle: 'Marca de esquina triangular',
      sixSideDrillPlankBase: 'Referencia de colocación y perforación de cinco o seis lados',
      boldSettingTip: 'PDF El cuerpo negro no es compatible',
      frontEdge: 'Mostrar el lado frontal del gabinete',
      visibleEdge: 'Mostrar el borde visible',
      lineCount: 'Número de palabras por línea'
      },
    autoSaveToHistory: '¡Se guarda automáticamente en el historial!',
    firstPrintTip: 'Cuando utilice la impresión directa por primera vez, agregue un nuevo papel de este tamaño con longitud y ancho intercambiados en la configuración de la impresora y luego use el nuevo papel para imprimir',
    tagDownloading: 'Las etiquetas se están descargando...',
    cutLaveEnd: 'Las etiquetas del material restante se generan detrás de cada tablero grande',
    deleteTemplate: 'Eliminar plantilla',
    copyTemplateRenderUrl: 'Copiar enlace de plantilla',
    noPermission: 'Las siguientes funciones no autorizadas se han desactivado en la plantilla importada',
    moreOperation: 'Más operaciones',
    importTemplate: 'Importar plantilla',
    importTemplateLink: 'Pegue la dirección del enlace de la plantilla de etiqueta en el cuadro de entrada a continuación para completar la importación de la plantilla',
    importTemplateLinkPlaceholder: 'Ingrese el enlace de la plantilla',
    noDeleteTemplate: 'La plantilla predeterminada no se puede eliminar',
    tip1: 'No hay ningún enlace de copia para la plantilla actual',
    tip2: 'El enlace de datos de la plantilla actual ha sido copiado.',
    tip3: 'No se pudo copiar el enlace de la plantilla, inténtelo nuevamente más tarde',
    tip4: 'No se puede reconocer el enlace de la plantilla de importación, descárguelo nuevamente e impórtelo.'
    },
  fileManagerPage: {
    folderClassifyByTextureColorThickSize: 'Clasificados en diferentes carpetas según el color, material, grosor y tamaño del tablero (etiquetar archivos juntos)',
    notOpeFolderPermission: 'Operación no autorizada de este directorio',
    notFindFolder: 'No se puede detectar este directorio en el cliente actual',
    productLineUniversal: 'Común a todas las líneas de producción',
    effectCondition: 'Esta configuración debe volver a escribirse antes de que pueda surtir efecto',
    addPath: 'Agregar ruta',
    downloadPositionChangeByType: 'La ubicación de descarga del archivo generado se ha cambiado a {type}',
    isDeleteFolder: '¿Está seguro de eliminar el ¿Ubicación de almacenamiento de archivos utilizada?',
    netWorkIsNotSafe: 'Su entorno de red parece no ser seguro y no podemos habilitar esta función. Puede enviarnos su opinión',
    NotSupportBrowse: 'Su navegador aún no admite esta función. Descargue la última versión <a href="https://www.microsoft.com/zh-cn/edge/download" target="_blank" >Edge</a> para usar el navegador',
    notSupportDisk: 'Los directorios a nivel del sistema no son opcionales, como 【桌面】【C盘】',
    useFolderDownload: 'Los archivos de producción se descargan en forma descomprimida',
    downloadPosition: 'Descargar ubicación del archivo',
    changeUseFolder: 'Cambiar',
    folderNameSetting: 'Configuración de carpetas',
    mainFolder: 'Carpeta de primer nivel',
    exportNameSetting: 'El archivo de procesamiento exportado se nombra según el número de pedido',
    fileMax: 'El nombre de archivo máximo es',
    char: 'caracteres',
    overTip: 'La parte sobrante no se mostrará (el paquete comprimido del mapa de etiquetas y el archivo json recibirán el nombre de la carpeta de primer nivel)',
    example: 'Ejemplo',
    engravingFolder: 'Carpeta de la máquina de grabado',
    electronicSawFolder: 'Carpeta de la sierra electrónica',
    labellingFolder: 'Carpeta de la máquina de etiquetado',
    sideHoleDrillFolder: 'Carpeta de la máquina de orificio lateral',
    fiveDrillFolder: 'Carpeta de diamantes de cinco caras',
    sixDrillFolder: 'Carpeta de diamantes de seis caras',
    PTPFolder: 'PTP carpeta',
    labellingTagFolder: 'Carpeta de imágenes de etiquetado',
    surplusFolder: 'Configuración del tablero de archivo de material restante',
    surplusBigPlankSetting: 'El archivo de borrado del tablero de material restante/imagen de etiqueta/archivo de etiquetado se colocan por separado',
    surplusBigPlankSettingTip: 'Después de abrir, el archivo NC del material restante, la imagen de etiqueta y el archivo de etiquetado se colocarán en una carpeta separada',
    folderMergeSetting: 'Configuración de combinación de carpetas',
    folderMerge: 'Combinación de carpetas',
    mergeName: 'Nombre de combinación',
    subMergeFolder: 'Combinación en subcarpetas según el color y el grosor del material',
    subFolderName: 'Nombre de subcarpeta',
    splitChar: 'Delimitador',
    splitTip: '(No admite entrada / : ? < > | . ” * y otros caracteres)',
    folderAutoAdd: 'El número de carpetas aumenta desde el valor inicial',
    resetTip: '(Restablece al valor inicial en cero todos los días)',
    emptyErrTip: 'La información no puede estar vacía',
    repeatErrTip: 'Nombre de archivo duplicado',
    mergeDataTip: 'El material de la placa, el color, el grosor, el largo y el ancho deben existir o el número de archivos aumenta automáticamente o el grosor del color del material de la placa',
    engravingFileSetting: 'Configuración del archivo de la máquina de grabado',
    engravingSplitZF: 'Coloque los archivos frontales y posteriores de la máquina de grabado en diferentes carpetas',
    engravingSplitZFTip: 'Aplicable a la máquina etiquetadora automática 123,',
    engravingSplitWorkstation: 'Máquina de grabado por posición de trabajo',
    engravingSplitWorkstationTip: 'Se admite la máquina de grabado y la máquina de grabado de corte',
    holeFileSetting: 'Configuración del archivo de perforación',
    holeFileSingle: 'Los archivos de perforación se colocan por separado en carpetas según diferentes pedidos'
    },
  moreSettings: {
    generalSetting: 'Configuración general',
    outSyncTip: 'Se genera una ventana emergente cuando los datos de la pieza original de la composición tipográfica en la nube no están sincronizados con el gabinete',
    secondarySwitchShow: 'El contenido secundario controlado por el interruptor en la configuración de la máquina de grabado aún se muestra después de que se apaga el interruptor',
    isFrameDoorTip: 'Se genera una ventana emergente cuando se procesan puertas de marco',
    exPaibanTip: 'Se genera una ventana emergente cuando se utiliza material remanente de forma especial/composición tipográfica anidada de forma especial',
    isDesMaterialNoCutTip: 'Se genera una ventana emergente cuando el material de la placa pequeña no está cortado y hay agujeros/formas especiales asignadas al grabado máquina',
    surpTagThresholdTextHalf1: 'Cuando el área del material remanente (material remanente no cortado) es menor que',
    surpTagThresholdTextHalf2: 'No genere etiquetas de material residual',
    innerShapeToolMatch: 'La máquina de grabado selecciona automáticamente la herramienta adecuada para procesar formas especiales internas',
    innerShapeToolMatchTip: '(La máquina de grabado procesa formas especiales internas con un diámetro más pequeño que la cuchilla de corte. Esta función se puede habilitar cuando ocurre un error de tamaño y no se puede procesar)',
    innerShapeToolMatchTip2: 'Nota: Después de habilitarla, se utilizará la fresa de ranura más pequeña. Configure razonablemente la "longitud de la herramienta" y la "profundidad de procesamiento máxima única" de la fresa de ranura más pequeña. Solo tiene efecto en el diseño de la nube',
    surNotLayout: 'La definición de una placa grande con material residual no alinea la placa especificada.',
    surNotLayoutTip: 'Después de abrir, 1. El material restante no se puede colocar en el plato grande. El nombre de la placa pequeña contiene el nombre a continuación. 2. Al componer, puede elegir si esta función es válida para esta composición',
    addPlank: 'Agregar un nombre de placa',
    addPlankTip: 'Agregar al menos un nombre de placa pequeña',
    thisInput: 'Ingrese aquí',
    surNotLayoutMat: 'El material restante no está dispuesto para especificar una placa pequeña',
    subTagSetting: 'Configuración de etiqueta secundaria de panel pequeño',
    subTagDataSource: 'Configurar la fuente de datos efectiva para la generación de etiqueta secundaria',
    subTagDataSourceTip: 'Tras activarlo, puede añadir fuentes de datos que controlan la generación de la etiqueta secundaria. Se genera cuando la etiqueta secundaria tiene esa fuente y la fuente tiene un valor.',
    addSubTagDataSource: 'Agregar fuente de datos',
    addSubTagDataSourceTip: 'No se permite agregar fuentes de datos duplicadas',
    addSubTagDataSourceTip1: 'Agregue al menos una fuente de datos',
    addSubTagDataSourceTip2: 'La fuente de datos no puede estar vacía, selecciónela',
    reuseMatchingPlankName: 'Reutilización coincidente por nombre de placa',
    reuseMatchingPlankNameTip1: 'Cuando esta función está desactivada, la reutilización de diseño coincide con paneles que tienen el mismo material, color, grosor, dimensiones, textura y propiedades de alto brillo',
    reuseMatchingPlankNameTip2: 'Al activar esta función, además de las condiciones de coincidencia anteriores, también se añade la coincidencia por nombre de placa'
    },
  lineManager: {
    add: 'Agregar una línea de producción',
    engraving: 'Equipo de corte',
    holeSlotEquip: 'Equipo de procesamiento de orificios',
    workSetting: 'Configuraciones de procesamiento',
    noUse: 'No habilitado',
    warningTip: '* Nota: Después de configurar las siguientes funciones, no las guarde en la página de acoplamiento del dispositivo cliente del gabinete para evitar el reinicio de parámetros.',
    engravingSetting: 'Configuración de la máquina cortadora',
    workWay: 'Método de procesamiento',
    cutedSpecial: 'Ranuras de orificios especiales procesadas:',
    noWork: 'Esta opción no es efectiva para la plantilla predeterminada de perforación de cinco/seis lados',
    onlyCut: 'Solo corte',
    onlyFrontHoleSlot: 'Solo procesa los orificios frontales y posteriores de la placa',
    onlyHoleSlot: 'Solo procesa los orificios frontales y posteriores de la placa',
    sideHoleSetting: 'Configuración de la máquina de orificios laterales',
    cutHoleSlot: 'Ranuras de orificios procesados',
    minSize: 'Tamaño del lado corto',
    maxSize: 'Tamaño del lado largo',
    minSize2: 'mm Todas las',
    minSize3: 'y piezas con formas especiales',
    onlyFrontHoleSlotTip: 'página de diseño en el tablero Solo tableros pequeños con ranuras para orificios en el frente',
    onlyFrontHoleSlotTip2: 'No incluye orificios laterales Ranuras laterales',
    holeAndSlot: 'Orificios y ranuras',
    empty: 'Vacío',
    singleHole: 'Orificio único',
    singleSlot: 'Ranura única',
    diameterRange: 'Rango de diámetro de orificio',
    hDeepRange: 'Rango de profundidad de orificio',
    widthRange: 'Rango de ancho de ranura',
    sDeepRange: 'Rango de profundidad de ranura',
    to: 'a',
    specialHS: 'Ranuras de orificios especiales y formas especiales',
    allowRoll: 'Permite que la máquina de corte duplique y procese ranuras de orificios especiales',
    engravingPath: 'Procesamiento de piezas de forma especial de la placa en la máquina de corte',
    curve_range: 'Todas las piezas de forma especial de la placa con el lado largo de la pieza de forma especial más grande que',
    curve_range2: 'all special shape parts of the board',
    curveArea: 'Área de forma especial',
    drillSetting: 'Engastes de diamantes de cinco o seis lados',
    engravingCuted: 'Las ranuras de los orificios procesadas en la máquina cortadora están en la broca de cinco/seis caras',
    engravingCutedSpecial: 'Las partes especiales procesadas en la máquina cortadora están en la broca de cinco/seis caras',
    genCuttingPath: 'Generar datos de corte',
    otherCuted: 'Las ranuras de los orificios procesadas por otros equipos están en la broca de cinco/seis caras',
    noGen: 'No generar',
    genCut: 'Generar y procesar',
    genNoCut: 'Generar pero no procesar',
    cutTip: 'Nota: Esta opción solo tiene efecto para limas de perforación personalizadas de cinco y seis caras',
    maxShortSize: 'Tamaño máximo del lado corto',
    maxLongSize: 'Tamaño máximo del lado largo',
    normalSlot: 'Ranura ordinaria',
    specialSlot: 'Ranura especial',
    combinSetting: 'Configuración de equipo combinado',
    allowShortSize: 'Permitir tamaño de lado corto',
    equipment1: 'Equipo uno',
    equipment2: 'Equipo dos',
    noSameTip: 'Nota: No se pueden seleccionar dos equipos iguales',
    workRange: 'El equipo uno puede procesar el rango de ranuras de orificios',
    rangeWarning: 'Nota: Solo se puede configurar el rango de procesamiento del equipo uno, el rango de procesamiento que no sea el equipo uno se procesará en el equipo dos, ¡opere con precaución!',
    deleteWarning: 'La eliminación de esta línea de producción no se puede restaurar (se eliminarán todas las configuraciones de esta línea de producción). ¿Está seguro de eliminar esta línea de producción?',
    top: 'Arriba',
    inputCheck: '{msg} El valor mínimo no puede ser mayor que el valor máximo',
    lockTip: '¡La línea de producción ha sido bloqueada y las operaciones están prohibidas!',
    reNameTip: 'El nombre de la línea de producción predeterminada no se puede modificar',
    permissonTip: 'La información de identidad ha caducado, vuelva a abrir esta página desde el gabinete.',
    permissonErr: 'Aún no tienes este permiso, ¡actualiza la versión de la cuenta!',
    permissionOneMacErr: 'El número de líneas de producción todo en uno que puedes utilizar actualmente es {idx}. Si necesita aumentarlo, comuníquese con el personal de ventas.',
    permissionSawErr: 'No tiene permiso para utilizar la máquina de corte y grabado. Comuníquese con ventas para comprar el paquete complementario de aserrado totalmente de aluminio antes de usarlo.',
    getAuthError: '¡No se pudieron obtener permisos del dispositivo!',
    sawAddNumber: 'El número de líneas de producción de sierras electrónicas actualmente disponibles para usted se ha agotado. Si necesita aumentar, ¡póngase en contacto con ventas!',
    newLine: 'Nueva línea de producción {idx}',
    deleteCheck: 'No se pueden eliminar todas',
    deving: 'En desarrollo',
    combinTip: 'Haga clic en la configuración del equipo combinado a continuación para configurar',
    noUseEquip: 'El equipo de procesamiento no está habilitado',
    equipmentSelectTip: 'Cuando se selecciona la máquina de corte para el equipo combinado, el equipo de corte no puede seleccionar la sierra electrónica',
    lineLoading: 'Se están cargando datos',
    strenchType: 'Tipo de ranura enderezadora',
    aioProcessTip: 'Ha habilitado el dispositivo "máquina todo en uno" y el método de procesamiento predeterminado es procesar los orificios frontal y posterior de la placa',
    aioProcessTip2: 'Ranuras de orificios especiales procesadas en el grabado pieza de la máquina después de habilitar la máquina todo en uno',
    aioProcessTip3: 'Nota: Esta función no es compatible con máquinas de grabado que habilitan el intercambio de ejes XY. Úselo con precaución',
    specialHoleTip: 'Nota: Cuando utilice la función anterior "Ranuras de orificios especiales procesadas", configure el "Método de perforación de orificios pasantes" y el "Método de perforación de ranuras" en una perforación única',
    specialHoleTip2: 'Nota: Cuando utilice la función "Ranuras de orificios especiales procesadas" anterior, configure el "Método de perforación de orificios pasantes" y el "Método de perforación de ranuras pasantes" de la máquina de grabado en una perforación de una sola vez',
    fiveSixNotTake: 'Esta opción no es efectiva para la plantilla predeterminada de perforación de cinco/seis lados',
    onlyFrontSide: 'Procese solo el frente lado.',
    onlyBackSide: 'Sólo se procesa el reverso',
    less: 'Menos de',
    equal: 'igual a',
    greater: 'mayor que',
    or: 'o',
    and: 'y',
    bothFrontBack: 'procesamiento frontal y posterior',
    shareDataErrTip: 'Estos datos son aplicados por {operatorPhone}, ip: {actionIp}',
    restoreParams: 'Restaurar parámetros',
    loadMore: 'Cargar más',
    currentCombinationEquipment: 'Equipo combinado actualmente seleccionado, el equipo de corte no permite cambiar a máquina cortadora de vidrio',
    selectEquipmentType: 'Seleccione el tipo de equipo',
    ruleRemark: 'Notas de regla',
    remarkPlaceholder: 'Esta es una nota informativa. Puede anotar qué procesos procesa esta regla para evitar olvidarlos. Después de completar, guarde la línea de producción para que entre en vigor',
    onlyNoSideHoleSlotSmallPlank: 'Solo tableros pequeños sin orificios/ranuras laterales'
    },
  cuttingDock: {
    title: 'Apertura y acoplamiento',
    autoStockCode: 'Código de carga y descarga automática',
    stationStart: 'Inicio de estación',
    stationStartCode1: 'Código de inicio de estación 1',
    stationStartCode1Placeholder: 'Ingrese el código de inicio de estación 1',
    stationStartCode2: 'Código de inicio de estación 2',
    stationStartCode2Placeholder: 'Ingrese el código de inicio de estación 2',
    stationEnd: 'Fin de estación',
    stationEndCode1: 'Código final de estación 1',
    stationEndCode1Placeholder: 'Ingrese el código final de estación 1',
    stationEndCode2: 'Código final de estación 2',
    stationEndCode2Placeholder: 'Ingrese el código final de estación 2',
    frontBackStart: 'Inicio frontal y posterior',
    frontBackEnd: 'Extremo frontal y posterior',
    frontStartCode: 'Código inicial frontal',
    frontStartCodePlaceholder: 'Ingrese el código inicial inicial',
    frontEndCode: 'Código final frontal',
    frontEndCodePlaceholder: 'Ingrese el código final frontal',
    backStartCode: 'Código inicial inverso',
    backStartCodePlaceholder: 'Ingrese el código inicial inverso',
    backEndCode: 'Código de fin inverso',
    backEndCodePlaceholder: 'Ingrese el código de fin inverso',
    plankStart: 'Giro de placa inicial',
    plankEnd: 'Giro de placa final',
    plankRollCode1: 'Código de giro de estación 1',
    plankRollCode1Placeholder: 'Ingrese código de giro de estación 1',
    plankRollCode2: 'Código de giro de estación 2',
    plankRollCode2Placeholder: 'Ingrese código de giro de estación 2',
    autoBaitingCode: 'Código de borrado automático',
    autoBaitingCode1: 'Código de borrado de la estación 1',
    autoBaitingCode1Placeholder: 'Ingrese el código de borrado para la estación 1',
    autoBaitingCode2: 'Código de borrado de la estación 2',
    autoBaitingCode2Placeholder: 'Ingrese el código de supresión de la estación 2',
    thickMarkPermission: 'Actualmente no tiene permiso de Marcar el grosor de la placa grande. Contacte a ventas para comprar antes de usar',
    thickMark: 'Marcar el grosor de la placa grande',
    preStartEquipment: 'Dispositivo de prearranque',
    firstKnifePreCode: 'El código de preinicio del primer cuchillo está avanzado.',
    secondKnifePreCode: 'Se avanza el código de preinicio de la segunda cuchilla y de las cuchillas posteriores.',
    rowInsert: 'Inserción de fila',
    pumpPause: 'Bomba de vacío en pausa',
    pumpPauseTip: 'Nota: Para equipos de una sola estación, la estación 1 y la estación 2 deben completarse con el mismo "código de carga automática" y "código de comentario frontal de procesamiento de doble cara".',
    pumpPause2Tip: 'Nota: Para equipos de una sola estación, tanto la estación 1 como la estación 2 deben completarse con el mismo "código de pausa de la bomba de vacío".',
    pumpPauseCode1: 'Código de pausa de la bomba de vacío de la estación 1',
    pumpPauseCode1Placeholder: 'Complete el código de pausa de la bomba de vacío para la estación 1',
    pumpPauseCode2: 'Código de pausa de la bomba de vacío de la estación 2',
    pumpPauseCode2Placeholder: 'Complete el código de pausa de la bomba de vacío para la estación 2',
    annotationCode1: 'Código de comentario frontal de procesamiento de doble cara de la estación 1',
    annotationCode1Tip: 'Equipo adecuado para diferentes instrucciones para la carga automática del anverso',
    annotationCode1Placeholder: 'Ingrese el código de comentario frontal para el procesamiento a doble cara en la estación 1',
    annotationCode2: 'Código de comentario frontal para el procesamiento a doble cara en la estación 2',
    annotationCode2Placeholder: 'Ingrese el código de comentario frontal para el procesamiento a doble cara en la estación 2',
    upSpeedTip: 'Complete la velocidad de aceleración del borde común',
    cutThickTip: 'Complete el espesor de corte del borde común',
    sizeErrTip: '¡Establezca el tamaño correcto del diagrama de diseño de exportación en la máquina etiquetadora!',
    offEdgeKnifeDiameter: 'Ingrese el diámetro de la herramienta de recorte',
    slowDownSpeedTip: 'Parámetros de entrada incorrectos para la desaceleración de la esquina de corte',
    permissionErr: 'Esta es actualmente una versión gratuita y no se puede guardar',
    labellingTempErr: 'Seleccione la plantilla de la máquina etiquetadora',
    autoRollInputTip: 'Active la rotación automática de etiquetas, se debe ingresar un valor válido',
    offlineTempFormat: 'El formato de archivo actual de la máquina etiquetadora está fuera de línea, confirme',
    autoStockCode1: 'Código de alimentación automática de la estación 1',
    autoStockCode1PlaceHolder: 'Ingrese la alimentación automática de la estación 1 código',
    autoStockCode2PlaceHolder: 'Ingrese el código de alimentación automática de la estación 2',
    autoStockCode2: 'Código de carga automática de la estación 2',
    pauseCode: 'Código de pausa',
    pauseCodePlaceHolder: 'Ingresar código de pausa',
    cuttingToolMaxDepthTip: 'Almacén de herramientas {errKey} La profundidad máxima de procesamiento individual en la herramienta no puede ser mayor que la longitud de la herramienta',
    cuttingParams: {
      title: 'Parámetros de corte',
      stationWidth: 'Ancho de la estación',
      stationWidthTip: 'Al usar paneles grandes de sobrante, la dirección del ancho solo puede disponer paneles pequeños dentro del rango de tamaño establecido',
      holeSlotMainSide: 'Superficie de concentración de orificios',
      holeMainSide: 'Superficie de concentración de orificios',
      slotMainSide: 'Superficie de concentración de ranuras',
      workPriority: '(Prioridad de función: Personalizar la superficie especial de procesamiento de orificios y ranuras > El lado donde se encuentra la ranura perforada sigue la ranura sin perforar en la placa pequeña > Las ranuras de orificios especiales configuradas en el orificio y la desviación de ranura tienen prioridad en el frente de la placa grande > Superficie de concentración de ranura > Superficie de concentración de orificios)',
      holeSlotSet: 'Configuración de procesamiento de ranuras de perforación y perforación',
      hingeRollWork: 'Coloque los orificios del enderezador y de la copa de bisagra en la parte posterior de la placa grande para su procesamiento',
      followWork: 'El lado donde se encuentra la ranura perforada sigue la ranura sin perforar en la placa pequeña',
      autoMatchSide: 'Asigne proporcionalmente las ranuras de orificios frontal y posterior',
      backHSRate: 'Proporción de ranura inversa',
      matchTip: 'El tablero de alto brillo, el esquema de composición tipográfica que activa formas especiales calculadas o la coincidencia de patrones no tendrán efecto.',
      specIalHoleAndSlotSurface: 'Personalización de la superficie de procesamiento de ranura de orificio especial',
      specialRuleTip: 'Seleccione una ranura de orificio especial',
      specialSlotsHoles: 'Tipo de ranura de orificio',
      holeType: 'Tipo de orificio',
      specialRules: 'Regla',
      normalHole: 'Orificio normal',
      normalSlot: 'Ranura regular',
      holeDiam: 'Diámetro del orificio',
      slotLongSide: 'Lado largo de la ranura',
      slotShortSide: 'Lado corto de la ranura',
      FixedmachSurface: 'Superficie de procesamiento fija',
      deleteRuleTip: 'Si se elimina esta regla',
      blankFront: 'Frente de placa grande',
      blankBack: 'Reverso de placa grande',
      addRules: 'Agregar regla',
      addRulesTip: 'Cuando la misma placa pequeña Si llega a varias reglas, la regla con el número de serie más alto entrará en vigor. Puede arrastrar cualquier fila para cambiar el orden de las reglas',
      highGlossSetting: 'Configuración del tablero resaltado',
      heighGlossFront: 'Al componer, el lado resaltado del tablero pequeño se organiza antes que el tablero grande',
      highGlossPlankNoRotate: 'La superficie de alto brillo no gira',
      highGlossAutoRoll: 'Solo los tableros grandes con ranuras invertidas se voltean automáticamente',
      highGlossAutoRollTip: "<span class='color-o-4'> (Después de habilitar, solo el tablero grande con la ranura invertida se volteará automáticamente y se convertirá en un solo panel durante la composición tipográfica. Úselo con los datos del nombre de archivo personalizado \"Alto brillo\"). Tablero de giro lateral\") </span>",
      customHighGlossReverse: 'Dé la vuelta a la superficie de alto brillo y coloque el tablero',
      sideSlotPut: 'Colóquelo junto a la ranura del tablero de borde',
      optimize: 'La función se está optimizando',
      sysDefault: 'Predeterminado del sistema',
      plankInSide: 'El interior del tablero grande',
      plankOutSide: 'El exterior del tablero grande',
      specialNotWork: 'Esta función no tiene efecto en paneles con formas especiales',
      commonSide: 'Corte de borde común',
      commonSetting: 'Configuración de borde común',
      plankThickRange: 'Utilice corte de borde común cuando el espesor de la placa sea menor o igual a',
      useCommonSide: 'Use Common Edge Cutting When',
      zeroTip: 'El espacio de composición tipográfica debe cambiarse manualmente a 0. Al procesar hasta el borde cortado, levante la cuchilla para saltar el borde. Una vez activada esta función, no se admitirá el procesamiento con cuchilla oblicua. ¡Tenga en cuenta!',
      useTip: 'Después de activar esta función, no se admitirá el procesamiento de herramientas de corte oblicuo, ¡tenga en cuenta!',
      commonSpeed: 'Aceleración de borde común',
      highSpeed: 'Velocidad de rectificado y fresado de alta velocidad',
      min: 'Minutos',
      notWorkTip: 'Cuando el procesamiento de la placa coincide con el corte de borde común, la aceleración de borde común no tendrá efecto',
      changeStartPoint: 'Cambio del punto de inicio de estación dual',
      changeStartPointTip: 'Después de habilitar el cambio del punto de inicio de la estación dual, es incompatible con la función de intercambio de ejes XY, utilícela con precaución',
      flatOffset: 'Desplazamiento del plano de la máquina',
      xRowChange: 'X Intercambio de datos de coordenadas del eje',
      bigplankPointChange: 'Intercambio de datos de coordenadas de la parte posterior de la placa grande',
      reverseXRowChange: 'X Intercambio de coordenadas',
      changebigplankPointTips: 'Después de habilitar esta función, es incompatible con el "XY intercambio de ejes, cambio de punto de inicio dúplex" función, úsela con precaución',
      reverseYRowChange: 'Y Intercambio de coordenadas',
      plankMirrorTip: 'Utilice esta función cuando refleje la placa procesada en la máquina de corte',
      notSameSize: 'Diferentes tamaños de la mesa de estación doble',
      maxSize1: 'Tamaño máximo de la estación uno',
      notSameSizeTip: 'Después de habilitar diferentes tamaños de la mesa de estación doble, es incompatible con la función de fusión de archivos de estación doble, úsela con precaución',
      maxSize2: 'Tamaño máximo de la estación dos',
      autoSelectTip: 'Cuando las dos estaciones de trabajo de Los equipos de doble estación son de diferentes tamaños, al utilizar esta función se seleccionará automáticamente la estación correspondiente para procesar la placa grande.',
      bigFlatLimit: 'La estación grande solo procesa placas grandes que no pueden ser procesadas por la estación pequeña:',
      surplusSetting: 'Configuración del material restante',
      surplusPosition: 'Colocación del material restante',
      cutHoleWay: 'Método de corte y punzonado',
      knifeFlat: 'Plano de referencia de configuración de la herramienta',
      flat: 'Superficie de la mesa',
      plankFlat: 'Superficie de la placa grande',
      freeHeightZ: 'Inactivo Z Altura',
      relativeHeight: 'Relativa a la altura de la superficie superior de la placa grande',
      cutDeepZ: 'Cantidad de corte Z Profundidad',
      cutDeepH: 'Método de perforación pasante',
      setDisableDoubleSidedThroughHole: 'La configuración no es efectiva. Voltee y perfore dos veces',
      addHolesToRulesDisableDoubleSided: 'Después de agregar los orificios pasantes correspondientes (orificios perforados de punta a punta) a las reglas inferiores, voltear y perforar dos veces no tendrá efecto',
      onceThrough: 'Una vez',
      rollThrough: 'Voltear y perforar dos veces',
      cutDeepS: 'Método de perforación de orificio pasante',
      plankCutDirection: 'Dirección de corte de placa pequeña',
      clockDirSwitch: 'Ranura de fresado personalizada/dirección de corte interna de forma especial',
      millHoleSlotDir: 'Dirección de ranura de fresado de orificio',
      millInternalCurveDir: 'Dirección de corte interna de forma especial',
      sDirection: 'En el sentido de las agujas del reloj',
      nDirection: 'En sentido antihorario',
      curveReplenish: 'Comando de interpolación de arco para cortar la placa de arco',
      curveReplenishTip: 'Esta función se puede utilizar cuando aparece un diente de sierra en el corte de la placa de arco',
      noGen: 'No generar G17/G18/G19 comando de superficie',
      arcInstruction: 'Prefijo del comando de interpolación de arco',
      example: 'Ejemplo',
      arcExample: 'G17G03 X100 Y100',
      curveCutTip: 'El corte de arco se representa mediante I, J',
      coverRate: 'Tasa de superposición de corte al fresar ranuras:',
      roughTip: 'Utilice esta función cuando quedan rebabas dentro de la ranura cuando la herramienta está fresando ranuras',
      clearCurve: 'Limpia automáticamente los filetes de las ranuras que no se han extraído durante el fresado de ranuras:',
      curveUseTip: 'Seleccione esta función cuando necesite limpiar los filetes al fresar ranuras. Tenga en cuenta que esta función no tiene efecto en los conectores',
      slotCutWay: 'Método de avance del fresado de ranuras',
      outToIn: 'Fresado de la ranura de afuera hacia adentro',
      inToOut: 'Fresado de la ranura de adentro hacia afuera',
      zShapProcess: 'Fresado de la ranura de arriba a abajo Z',
      zShapProcessTip: 'Sólo es eficaz para el fresado de ranuras de tracción delantera y trasera. La tasa de superposición de la trayectoria de la herramienta tiene por defecto el radio de la herramienta',
      zSlotCuttingOverlapRate: 'Z. La tasa de superposición del corte de ranuras de fresado de fuentes es',
      zSlotCuttingOverlapRateTip: '. La tasa de superposición actual puede hacer que la velocidad de procesamiento disminuya. Pruebe la máquina antes de procesarla.',
      slotWorkLimit: '(Solo efectivo cuando el número de pasadas de fresado de ranura es >1)',
      minKnifeChange: 'Reducción de cambio de herramienta en el procesamiento',
      preventBreakage: 'Prevención de rotura del separador de ranura de borde',
      preventBreakageTip: 'Esta configuración solo es válida para ranuras en la cara frontal durante el anidado, y puede usarse junto con la función "Personalización de la superficie de procesamiento de ranura de orificio especial"',
      preventBreakageTip1: 'Puede resolver la situación en la que la ranura está demasiado cerca del borde del panel y, al cortar, la barra separadora (la parte de conexión restante) en esa posición se rompe fácilmente por concentración de tensiones',
      preventBreakageDistance: 'Distancia al borde del panel',
      preventBreakageLength: 'Longitud de la sección del borde',
      preventBreakageSlot: 'ranuras',
      preventBreakageCutDeep: 'Profundidad del primer corte',
      workSpeedOp: 'Optimización de la velocidad de procesamiento',
      obliqueCut: 'Cuchilla inclinada durante el corte',
      obliqueCutTip: 'Cuando el espesor de la placa no está especificado, se aplica a todas las placas con espesor menor',
      obliqueThickLabel: 'Espesor efectivo personalizado para corte oblicuo',
      obliqueCutData: 'Distancia de la cuchilla inclinada',
      backOblique: 'Cuchilla inclinada para el corte posterior',
      obliqueSpeed: 'Velocidad de la cuchilla inclinada',
      obliqueSpeedTip: 'Velocidad de la cuchilla inclinada',
      arcSpeed: 'Velocidad de procesamiento de la curva',
      cuttingPreDistance: 'Distancia de avance del cortador',
      backKnife: 'Desaceleración de la retracción del corte',
      openKnifeSpeed: 'Velocidad de retracción del cortador',
      retractionCompensation: 'Compensación de distancia de retracción de corte',
      retractionCompensationTip: 'Valor máximo 20',
      cutCornerSlow: 'Desaceleración de esquina de corte',
      addRow: 'Se agregó',
      bettwenDistance: 'Distancia antes y después de la esquina',
      cuttingSpeed: 'Velocidad de corte',
      stepCutting: 'Corte en capas',
      splitSlot: 'Corte de ranura dos veces',
      splitPlank: 'La placa pequeña se corta dos veces',
      splitPlank2: 'La placa pequeña se corta dos veces',
      minSafeThick: 'El espesor es mayor que',
      splitPlankTip: '(esta función no tiene efecto para placas con formas especiales)',
      splitPlankTip2: '(No compatible: compensación de cierre de cuchilla)',
      cutPlankMethod: 'La placa pequeña se corta dos veces',
      cutPlankMethodTip: 'La placa se corta dos veces en los cuatro lados',
      cutPlankMethodTip2: 'La placa se corta dos veces en el último lado',
      specialShapCut: 'La placa con formas especiales se corta dos veces',
      specialShapCutTip: '(todas las placas con formas especiales se cortarán dos veces cuando esté habilitada)',
      bridgeRetention: 'Método de puente con puntos de retención',
      bridgeRetentionTip: '(Nota: 1. Esta función temporalmente no admite placas con formas especiales externas. 2. No admite corte oblicuo hacia abajo. 3. El tamaño mínimo de la pieza para generar puentes de conexión es 30mm.)',
      bridgeRetentionDesc: 'Ayuda a evitar la vibración o el desplazamiento de la placa cuando hay muchas zonas vacías internas y la trayectoria de corte carece de soporte.',
      bridgePunchArea: 'La parte perforada supera el área total',
      bridgeSize: 'Tamaño del puente',
      bridgeGenMethod: 'Método de generación',
      bridgeAddTip: 'Añadir hasta 10 datos',
      bridgeCount: 'Número de puentes',
      bridgePlankLength: 'Longitud de la placa (L)',
      maxWH: 'La longitud o el ancho es menor que',
      areaLimit: 'y el área es menor que',
      secondDeep: 'La segunda profundidad de corte',
      splitPlankThickSetting: 'Configuración de corte de la capa de corte',
      saveCustomSpeedTip: 'La velocidad de procesamiento no puede ser vacía',
      saveLayeredCuttingTip: 'La suma de tres cortes en capas para el corte en capas debe ser igual al espesor de la placa',
      saveLayeredRepeatTip: 'No se recomienda establecer diferentes datos en capas para el espesor del atributo de resaltado del mismo material durante el corte en capas. ¡Elimine los datos redundantes!',
      splitPlankThick: 'Corte en capas de diferentes espesores de placa',
      movePlankSetting: 'Configuración de placa antideslizante',
      newCutSequence: 'Nueva versión del algoritmo de corte',
      newCutSequenceText: 'De forma predeterminada, la succión de vacío es más fuerte en el centro de la placa grande y las placas pequeñas en esta área se cortan al final',
      positionTip: 'Haga clic en el área correspondiente para seleccionar',
      suctionPosition: 'Posición de succión de vacío fuerte',
      strongArea: 'Área de succión fuerte',
      minSuctionPlank: 'Placa de succión mínima',
      safeWidth: 'Ancho',
      safeHeight: 'Largo',
      safeTip: 'Si la placa no se puede succionar, se cortará primero',
      scattered_layout: 'Composición tipográfica dispersa de placa pequeña',
      lastCutPointEnable: 'Personalizar punto de corte de la última placa pequeña cortada en la placa grande',
      lastCutPointEnableTip: 'Cuando está activado, el punto de corte de la última placa pequeña cortada en cada placa grande se generará según la posición del punto configurado',
      lastCutPoint: 'Posición del punto de corte',
      lastCutPointTip: 'Cuando está activado, la última placa pequeña cortada en cada placa grande usará este punto de corte',
      leftTop: 'Superior izquierda',
      rightTop: 'Superior derecha',
      leftBottom: 'Inferior izquierda',
      rightBottom: 'Inferior derecha',
      specifyTheMaterial: 'Especificar material',
      shapeSecondCutenable: 'Corte secundario de placa de forma especial',
      addMaterial: 'Agregar material',
      plankMaterial: 'Material de placa',
      specifyTheMaterialTip: 'Después de habilitarla, la función de corte secundario solo será eficaz para paneles que cumplan con el material de la mesa',
      dispersePaibanTipOne: '. Después de habilitarlo, se colocará al menos un panel que cumpla con el tamaño mínimo de succión en cada tablero grande',
      dispersePaibanTipTwo: '2. Tenga en cuenta que la cantidad de paneles grandes puede aumentar después del uso',
      totalThickLimit: 'La suma de los tres cortes en capas debe ser igual al grosor del tablero',
      offsetFollowStep: 'El recorte también sigue al corte en capas',
      longPlankTip1: '1. Tras activar o desactivar esta función, los registros de diseño guardados en el historial requieren un nuevo diseño al descargar NC.',
      longPlankTip2: '2. Tras activar esta función, debe configurar el código de pausa de la bomba de vacío en [Apertura y acoplamiento - Pausa de bomba de vacío]; de lo contrario, no se puede resolver el problema de flexión al cortar placas largas.',
      longPlankTip3: '3. Las condiciones de filtro activadas abajo se validan secuencialmente por niveles; solo las piezas que cumplan las condiciones de filtro del nivel anterior pueden pasar a las condiciones de filtro del siguiente nivel para su evaluación.',
      secondCutting: 'Tableros regulares de objetos de corte secundario',
      normalPlank: 'Regular board',
      normalPlankTip: 'Tableros regulares: paneles que no sean puertas de gabinete, como particiones horizontales y verticales en el gabinete y paneles agregados directamente en la lista de corte',
      designatedTarget: 'Objetos designados',
      filterLevel1Label: 'Filtro nivel 1',
      filterLevel1Category: 'tipo de panel',
      filterLevel2Label: 'Filtro nivel 2',
      filterLevel2Category: 'límite de tamaño',
      filterLevel3Label: 'Filtro nivel 3',
      filterLevel3Category: 'otros',
      specifiedBoardForceEnable: 'Ignorar tamaño/otros filtros, forzar activación',
      curveMaterialFilterTip: '(Tras marcar "Panel irregular", debe ser irregular antes del filtro de material)',
      cuttingSettings: 'Configuración de corte',
      plankSizeLimitSuffix: ' paneles',
      specifiedBoard: 'Especifique el nombre del panel para cortar',
      specifiedBoardTip: 'Después de activarlo, el corte secundario tendrá efecto cuando el nombre del panel contenga el nombre del panel agregado a continuación.',
      addPlankName: 'Agregar un nombre de placa',
      plankNameEmpty: 'El nombre de la placa no puede estar vacío, ingrese',
      plankNameRequired: 'Agregue al menos un nombre de placa',
      plankLongLimit: 'Cuando el lado largo de la placa larga excede',
      plankShortLimit: 'El lado corto excede',
      cuttingSplit: 'Corte en dos veces',
      longExpand: 'Primer peso de corte: peso del lado largo',
      firstExpand: 'Primer peso de corte',
      longExpandTip: 'Peso del lado largo',
      longLimit: 'El lado largo excede',
      cuttingSplitTip: 'Condiciones de corte de tabla larga en dos',
      shortExpand: 'Aumenta el volumen en el lado corto.',
      expandTip: 'Las dimensiones del lado largo/corto aumentan cada una en X mm. Las longitudes de los lados largo y corto del tablero largo de forma especial son ambas la longitud del lado largo',
      pumpOffWay: 'Método de cierre al vacío',
      afterOnePlank: 'Después de cortar un solo tablero largo',
      afterAllPlank: 'Después de cortar todo el tablero grande',
      numberFixed: 'Número de decimales',
      bufferCode: 'Configuración del comando de búfer de corte',
      layoutGap: 'Configuración del espacio de composición tipográfica',
      layoutGapTip: 'Nota: Establecer el espacio de composición tipográfica en 0 puede causar superposición de tipografía.',
      wasteCutting: 'Corte automático de desechos',
      zkPointCustomize: 'Z Personalización del punto de referencia de rotación de mecanizado de orificio oblicuo de botón',
      sawSetting: 'Configuración de aserrado',
      cuttingLimit: 'Corte de desechos mayores que',
      waste: 'of waste',
      wasteSizeLimit: 'El tamaño mínimo no debe ser inferior a 100 mm',
      topLeft: 'Izquierda, arriba',
      topLeftD: 'Esquina superior izquierda',
      bottomLeft: 'Izquierda, inferior',
      bottomLeftD: 'Esquina inferior izquierda',
      topRight: 'Derecha, arriba',
      topRightD: 'Esquina superior derecha',
      bottomRight: 'Borde inferior derecho',
      bottomRightD: 'Esquina inferior derecha',
      firstTime: 'Primera vez',
      secondTime: 'Segunda vez',
      thirdTime: 'Tercera vez',
      startCutting: 'Inicio del corte',
      thickRange: 'Espesor ≥',
      longCut: 'Procesamiento de placas largas',
      edgeSetting: 'Ajustes de recorte',
      cuttingOrder: 'Secuencia de corte:',
      cuttingOrderTip: 'Este método tiene el riesgo de estribos, utilícelo con precaución',
      plankFirst: 'Corte las placas pequeñas primero',
      wasteFirst: 'Corte los restos primero',
      offTip: 'Cuando está cerrado, seguirá las configuraciones de recorte en los parámetros de corte',
      edgeCutDirection: 'Dirección de recorte',
      lGapTip: 'L La posición del espacio de la placa de material restante en forma de L se ajusta automáticamente en la dirección diagonal del cilindro de posicionamiento, excepto la placa de material restante de alto brillo. También es incompatible con la función de intercambio del eje xy',
      cylinderDir: 'Dirección del cilindro de posicionamiento',
      onlyLong: 'Solo se recortan los lados largos',
      backCutOrder: 'Secuencia de recorte inversa',
      backFirst: 'Inicialmente se recorta la parte posterior',
      backSecond: 'y la parte posterior se recorta después del procesamiento de la ranura.',
      frontReCut: 'Volver a recortar el lado frontal',
      frontReCutTip: 'hace que el borde del cilindro de posicionamiento sea más suave y evita marcas',
      useNewCut: 'Habilite la nueva versión de las reglas de recorte',
      newCutTip: 'Utilice esta función cuando se recortará un tamaño de recorte adicional en el lado frontal de una placa grande durante el procesamiento de doble cara',
      fixedTip: 'Nota: Puede haber superposición tipográfica cuando los dígitos reservados son 0 o 1',
      cuttingSlow: 'Amortiguamiento de la superficie de la placa ciega',
      holeSlow: 'Amortiguamiento de la superficie de la placa perforada',
      slotSlow: 'Ranurado/fresado/ranurado de la superficie del panel',
      slowCode: 'Uso del comando de almacenamiento',
      code: 'Comando',
      bufferOffset: 'Desplazamiento de la altura del almacenamiento de la superficie del panel',
      zkRotatePoint: 'Punto de referencia de rotación',
      zkRotateDir: 'Dirección de incremento del ángulo de rotación',
      restSizeLimit: 'El tamaño restante es menor que',
      useSaw: 'Utilice una hoja de sierra',
      unGenSawPath: 'No genere una trayectoria de corte longitudinal de la hoja de sierra',
      suitMachine: 'Adecuado para aluminio procesamiento de placa soldada',
      plankBack: 'Lado posterior del tablero grande',
      plankLeft: 'Lado izquierdo del tablero grande',
      plankRight: 'Lado derecho del tablero grande',
      plankFront: 'Lado frontal de la tabla grande',
      frontSide: 'Lado frontal',
      backSide: 'Lado posterior',
      rightSide: 'Lado derecho',
      leftSide: 'Lado izquierdo',
      singleMachineLimit: 'La parte frontal de la placa de procesamiento de un solo lado genera una ruta de recorte y recorta el borde primero',
      singleMachineLimitTip: 'La máquina todo en uno y el corte con hoja de sierra no tienen efecto. Esta función',
      setBatchPositionWaring: 'Consejo: Si necesita cancelar la modificación rápida del modo de punta de cuchilla inferior, desmarque el botón de modificación de punta de cuchilla inferior a la derecha',
      setBatchPosition: 'Modifique por lotes la punta de cuchilla inferior',
      setBatchPositionAs: 'Modifique la dirección de corte a:',
      activeBatchPosition: '{activePartCount} se han seleccionado placas pequeñas',
      specialFrontSide: 'Los orificios especiales configurados en el desvío de orificios tienen prioridad en el frente de la placa grande',
      rollCountTip: 'Después de habilitar el desvío de orificios, el número de Las copias se calculan en función de los orificios inversos reales procesados por la máquina de grabado',
      specialFrontSideTip: 'La línea de producción actual no admite el cambio de líneas de producción porque la función 【孔槽分流中设置的特殊孔槽优先排在大板正面】 o 【启用孔槽分流后按照实际在雕刻机加工的反面孔槽计算翻板次数】 está activada',
      doubleTrim: 'Recorte de doble panel',
      trim: 'Recortar bordes',
      trimTwoSide: 'Recortar dos bordes',
      trimFourSide: 'Recortar cuatro bordes',
      rightInmShow: 'Como se muestra en la imagen de la derecha',
      currentTrimDir: 'es la dirección de corte seleccionada actualmente',
      cylinderTip: 'es el cilindro de posicionamiento',
      onlyShort: 'recorta solo el borde corto',
      singleTrim: 'genera una ruta de corte para un solo panel',
      hierarchyCutTwice: 'ranurado y fresado corte en capas',
      knifeDia: 'Cuando el diámetro de la herramienta es menor o igual a',
      slotDeep: 'y la profundidad de la ranura es mayor o igual a',
      cutTwiceSlot: ', ranuras de corte en capas',
      twiceSlotDeep: 'La profundidad de corte de la segunda capa es',
      cutTwiceCondition: 'Condiciones de corte',
      zkPointCustomizeTip: 'Activar el intercambio del eje xy hará que la dirección de procesamiento sea opuesta al punto de referencia',
      zkPointCustomizeTip1: 'Esta función no tendrá efecto en equipos que activan el intercambio del eje xy',
      isCustom: 'Activar la personalización',
      useCutCon: 'Usar condiciones de aserrado',
      singleSetPlankSizeSpeed: 'Configure la velocidad de procesamiento del rango de tamaño de placa pequeña individualmente',
      singleSetPlankSizeSpeedTip: '(1. Cuando la placa pequeña que cumple con el tamaño establecido a continuación se procesará a la velocidad de procesamiento establecida 2. Cuando la placa pequeña cumple con varias reglas al mismo tiempo, la regla de velocidad mínima entrará en vigor 3. Esta función no tiene efecto en el corte con hoja de sierra)',
      addSpeedRules: 'Agregar regla',
      speedRules: 'Regla',
      shortSideSize: 'Tamaño del lado corto',
      lessThanEqual: 'Menor o igual a',
      and: 'y',
      longSideSize: 'Tamaño del lado largo',
      processingSpeed: 'Velocidad de procesamiento',
      trimLenCompensation: 'Compensación de longitud de recorte:',
      trimGenerateAPath: 'No se genera ninguna ruta cuando el valor de recorte es 0:',
      cuttingMethod: 'Método de corte',
      horizontalCutting: 'Corte horizontal',
      verticalCutting: 'Corte vertical',
      openKnifeDistance: 'Seleccione un panel remanente cortado'
      },
    labelingSettings: {
      title: 'Configuración de etiquetado',
      output: 'Archivo de etiquetado automático de salida',
      specification: 'Formato de archivo de etiquetado',
      codeFrontGenerate: 'El código de carga automática se genera antes que el código de etiquetado',
      templateOffline: '¡La plantilla utilizada está fuera de línea!',
      templateNotSupport: 'Esta plantilla no es compatible, ¡seleccione de nuevo!',
      rollLabelling: 'Configuración de giro de etiquetado',
      flipSetting: {
        title: 'Configuración de giro',
        engravingFlipProcess: 'Modo de giro de etiquetado de la máquina de grabado',
        flipTip: 'Habilite esta función cuando la máquina de grabado necesite girar'
        },
      rotateSetting: {
        title: 'Configuración de rotación de etiquetas',
        rotateTip: 'Active la condición de rotación según las necesidades, si se enciende al mismo tiempo, tendrá prioridad para seleccionar el valor de configuración',
        horizontal: 'Borde horizontal de la placa',
        vertical: 'Borde vertical de la placa',
        either: 'Borde horizontal o vertical de la placa'
        },
      countertopSetting: {
        title: 'Configuración de la mesa',
        startPoint: 'Punto de inicio de la estación de trabajo',
        upLeft: 'Esquina superior izquierda',
        upRight: 'Esquina superior derecha',
        downLeft: 'Esquina inferior izquierda',
        downRight: 'Esquina inferior derecha',
        baseExchange: 'Intercambio de datos de coordenadas',
        exchangeX: 'Intercambio del eje x',
        exchangeY: 'Intercambio del eje Y'
        },
      offset: 'Desplazamiento de coordenadas de etiquetado',
      offsetTip: 'Generalmente, las coordenadas de etiquetado están en el centro del tablero pequeño y es necesario ajustar algunos equipos',
      label_rotate_offset: 'Desplazamiento de coordenadas después de la rotación de la etiqueta',
      label_rotate_offset_tip: 'Cuando la posición de desplazamiento antes y después de la rotación de la etiqueta es muy diferente, se requiere ajuste',
      label_rotate_offset_err_tip: 'Después de activar el desplazamiento de coordenadas después de la rotación de la etiqueta, se requieren los desplazamientos de coordenadas de los ejes X y Y',
      imgSetting: {
        title: 'Configuración de imagen de etiquetado',
        suffix: 'Sufijo de imagen de etiquetado:',
        code: 'Método de codificación de imagen:',
        codeTip: 'png y jpeg modificarán el formato de codificación de imagen de composición simultáneamente, y la composición tipográfica en la nube incorporada aún no admite esta función',
        imgRatio: 'Resolución de imagen de etiquetado:',
        slowDown: 'Reducirá la eficiencia de exportar imágenes de etiquetas',
        color: 'Color verdadero',
        bit: 'Blanco y negro',
        resolution: 'Resolución de imagen de etiquetado',
        resolutionPlaceholder: 'Resolución',
        labelPool: 'Grupo de etiquetas de datos',
        showKey: 'Mostrar campos',
        dragTip: 'Las etiquetas en el grupo de etiquetas se pueden arrastrar y soltar',
        labelImgName: 'Nombre de la imagen de etiquetado',
        labelImgNameErrTip: 'El nombre de la imagen de etiqueta no puede estar vacío',
        labelTip1: 'Al personalizar, [Board Barcode] o [Label Sequence Number] deben usar uno de ellos, de lo contrario habrá problemas de sobrescritura de imágenes',
        labelTip3: '【Número de serie de etiqueta】 es el número de serie de la pequeña tabla desde arriba hasta abajo en la lista de corte, y la pequeña tabla añadida en la página de disposición no tiene este dato',
        labelTip2: '3. Esta función no tiene efecto en la plantilla del sistema de la máquina etiquetadora',
        delimiter: 'El separador',
        inputTip: 'no admite entrada /:? < > | . ” * Caracteres como',
        numStart: 'Valor inicial del número de serie de etiquetado',
        example: 'Nombre de imagen de etiquetado personalizado (ejemplo)',
        stockNumOffset: 'Dígitos de compensación del número de serie del tablero grande a',
        divideFolders: 'Las imágenes de etiquetas se dividen en diferentes carpetas según el tablero grande',
        foldersTip1: 'Nota: 1. Esta función no admite el uso con la función 【开料机文件合并】',
        foldersTip2: '2. Esta función aún no es efectiva para la composición tipográfica en la nube integrada',
        stickIntoFolders: 'El archivo de etiquetado se inserta en la carpeta de imágenes de etiquetado correspondiente al tablero grande',
        stickTip1: 'Nota: 1. Esta función debe usarse junto con la función 【下载NC顺带导出标签】',
        stickTip2: '2. La regla de generación de archivos en la plantilla de etiquetado utilizada debe seleccionar "Generar un solo archivo" para que esta función surta efecto;',
        stickTip3: '3. Esta función aún no es efectiva para la composición tipográfica en la nube integrada'
        },
      pdfSetting: {
        title: 'Configuración de etiquetado PDF',
        pdfLabelName: 'PDF nombre de archivo',
        example: 'Nombre de archivo PDF personalizado (ejemplo)',
        address: 'Dirección del proyecto',
        orderNo: 'Número de pedido',
        firstFolder: 'Carpeta de primer nivel',
        customerName: 'Nombre del cliente'
        },
      paibanImgSetting: {
        title: 'Configuración de diseño',
        tip: 'Habilita la exportación de dibujos de diseño personalizados. La plantilla fija a continuación no se puede exportar. Si necesita exportar, desactive la exportación de dibujos de diseño personalizados en más configuraciones en la página de diseño',
        reparation: 'El número de serie del dibujo de diseño se compensa automáticamente a',
        figure: 'dígitos',
        inputTip: 'Ingrese un número del 1 al 99',
        paibanImg: {
          export: 'Exportar dibujo de diseño',
          prefix: 'Prefijo del nombre del dibujo de diseño',
          size: 'Tamaño de diseño',
          format: 'Formato de diseño',
          directional: 'Dirección de diseño',
          vertical: 'Vertical',
          horizontal: 'Horizontal'
          }
        },
      autolabel: 'Configuración automática del orden de etiquetado',
      customTemp: 'Solo válido para plantillas personalizadas',
      cuttingLabelOder: 'Etiqueta según el orden de los materiales de apertura',
      labelToUp: 'Etiqueta de abajo hacia arriba según los resultados del diseño',
      labelToDown: 'Etiqueta de arriba hacia abajo según los resultados del diseño',
      labelDodge: 'Evitación automática de etiquetado',
      nolabelForsurplus: 'El material restante, los paneles grandes no generan archivos de etiquetado',
      settingValue: 'Seleccione el valor de configuración',
      enabelTip: 'Después de encenderlo, cuando el tablero pequeño cumpla con los siguientes valores de configuración, la etiqueta girará',
      fixedHori: 'Seleccione el borde horizontal de la etiqueta para que sea paralelo al borde fijo del tablero pequeño',
      fixedHoriTip: 'Solo efectivo para tableros pequeños sin textura. Después de encenderlo, al etiquetar, la etiqueta girará hacia el borde horizontal de la etiqueta para quedar paralela al borde fijo del tablero pequeño',
      tagHori: 'Borde horizontal de la etiqueta',
      effectiveTarget: 'Objeto efectivo',
      allPlank: 'Todos los tableros pequeños',
      notcarePlank: 'Solo tableros pequeños sin textura'
      },
    drillSettings: {
      title: 'Configuración de perforación',
      enable: 'Habilitar paquete de perforación',
      toolTable: {
        use: 'Habilitar',
        number2: 'Número de broca de fila de estación 2',
        number: 'Número de broca de fila',
        diameter: 'Diámetro de broca',
        xOffset: 'X Desplazamiento',
        yOffset: 'Y Desplazamiento',
        moveZF: 'Z Velocidad de movimiento rápido del eje',
        feedRate: 'Z Velocidad de movimiento rápido del eje',
        moveF: 'XY Velocidad de movimiento rápido del eje',
        benchmarkDrill: 'Taladro de referencia',
        addKnife: 'Agregar herramienta',
        deleteKnife: 'Eliminar herramienta'
        },
      prefix: 'Prefijo de perforación en fila',
      suffix: 'Sufijo de perforación en fila',
      startCode: 'Código de inicio de perforación en fila',
      endCode: 'Código de fin de perforación en fila',
      combineKnife: 'Corte combinado de perforación en fila',
      combineTable: {
        prefix: 'Prefijo de número de perforación en fila',
        suffix: 'Sufijo de número de perforación en fila',
        mainHole: 'Agujero principal',
        extraHole: 'Agujero esclavo',
        notes: 'Comentario de combinación',
        firstUseNotes: 'Habilitar anotaciones por primera vez',
        addExtraHole: 'Agregar agujeros esclavos',
        deleteExtraHole: 'Eliminar agujeros esclavos',
        example: 'Ejemplo'
        },
      tagPool: {
        drillRowNumber: 'Número de broca de fila'
        },
      processSetting: {
        title: 'Configuraciones de procesamiento',
        mode: 'Modo de procesamiento de perforación en hileras',
        processTip: 'La selección de este método no tendrá efecto. La función de corte combinado de perforación en hileras no tendrá efecto',
        recentHole: 'Taladre orificios cerca (cambio rápido de herramienta)',
        groupHole: 'Taladre orificios por categoría (completa un tipo de orificio antes de cambiar las herramientas)',
        drill_benchmark: 'Referencia de corte combinado',
        drill_benchmark_Tip: '(Nota: Después de seleccionar este método, la función de corte combinado de perforación en hileras no tendrá efecto)',
        mainHole: 'Utilice el orificio principal',
        secondaryHole: 'Desde el orificio (agujero trasero)'
        },
      changeBenchDrillTip: 'Ingrese el número de perforación en hilera antes de hacer esta selección'
      },
    NCExportSettings: {
      jumpSkipTip2: 'Según el color, el grosor y el material de la placa grande, se clasifican en diferentes carpetas (etiquetando archivos juntos) y los archivos de corte de placas grandes del mismo tamaño se colocan en la misma carpeta',
      title: 'NC Configuración de exportación',
      tab1: 'Configuración del nombre de archivo de la máquina de corte',
      tab2: 'Los nombres de los archivos de la máquina de corte se fusionan',
      tab3: 'Comentarios en los archivos de la máquina de corte',
      tab4: 'El tipo',
      tab5: 'en el archivo de apertura es la carpeta de apertura',
      tab6: 'Configuración de instrucciones de procesamiento',
      tab7: 'Configuración de formato de archivo',
      fileNameSettings: {
        twoStationAutoSort: 'Clasificación automática de estación doble',
        reparation: 'Compensación de dígitos del número de serie de placa grande a',
        figure: 'dígitos',
        labelerBegin: 'Inicio de la máquina de etiquetas',
        machineCenter: 'Inicio del centro de mecanizado',
        front: 'Anverso:',
        back: 'Atrás:',
        customizeName: 'Nombre de archivo personalizado (formato):',
        example: 'Nombre de archivo personalizado (ejemplo):',
        emptyTip: 'Los identificadores de archivo frontal y posterior no pueden estar vacíos al mismo tiempo tiempo.',
        labelPool: 'Grupo de etiquetas de datos',
        dragTip: 'Puede arrastrar o hacer clic para copiar las etiquetas en el conjunto de etiquetas en el cuadro de entrada'
        },
      fileMerge: {
        engravingMerge: 'Fusión de archivos de máquina cortadora',
        zfMerge: 'Fusión frontal y posterior',
        singleMerge: 'Fusión de estación única',
        doubleMerge: 'Fusión de estación doble',
        fEndCode: 'Código de fin inverso',
        zBeginCode: 'Código inicial frontal',
        displayfbInfo: 'El nombre del archivo muestra información frontal y posterior',
        fBeginCode: 'Código inicial inverso',
        zEndCode: 'Código final frontal'
        },
      marginalNotes: {
        addPlankInfo: 'Agregue información de placa grande actual al comienzo del archivo de corte:',
        plankInfo: 'Información de placa grande:',
        addStationCodeFirst: 'Agregue la estación de trabajo código al comienzo del archivo de apertura del material:',
        addStationCodeSecond: 'Agregue el código de estación antes de cambiar la herramienta en el archivo de corte:'
        },
      fileType: {
        zAddtion: 'Z Suplemento de coordenadas:',
        addSemicolon: 'Agregue un punto y coma al final de cada línea NC:',
        semicolonTip: 'Después de verificar, el archivo de procesamiento del mango de la bocina también tendrá efecto',
        fileName: 'Nombre de archivo',
        defaultName: 'Nombre de archivo predeterminado',
        dedicatedName: 'Nombre de archivo especial del equipo Xinghui',
        xhNotes: 'Xinghui E2-9 Comentario',
        format: 'Salida formato de archivo de la máquina de grabado',
        example: 'Ejemplo de archivo: archivo NC',
        stillGenerate: 'Cuando no se procesa el reverso, se seguirá generando el archivo NC del reverso que contiene el código final del reverso',
        generateTip: 'Esta función no admite el uso con la función de fusión de archivos',
        fileNameErrTip: 'El nombre del archivo no puede contener ninguno de los siguientes caracteres: / : * ? "'
        },
      categorize: 'Según el color, material y grosor del tablero grande, se clasifica en diferentes carpetas (etiquetando archivos juntos):',
      simplifyG: 'Procesamiento G abreviatura del comando',
      ZToW: 'El código se cambia del eje Z al eje W',
      knives: 'Herramienta de perforación de filas',
      lineBreakSetting: 'Configuración de formato de salto de línea',
      codeFormatSetting: 'Configuración de formato de codificación de archivo',
      utf8bom: 'UTF-8 con BOM',
      oneCodeSetting: 'Configuración de código de barras de placa',
      simplifyOneCode: 'Generar código de barras de etiqueta de formato simple',
      codeLocation: 'Configuración de posición de código',
      generateLocation: 'El código de fin de estación se genera antes que el código de fin inverso',
      emergencySetting: 'Configuraciones de emergencia',
      show: 'Mostrar configuración de emergencia',
      emergencyCode: 'Código de emergencia',
      params: 'Parámetros',
      emergencyTip: 'Algunas funciones específicas se pueden implementar temporalmente con la cooperación del personal de posventa',
      holeSetting: 'Configuración del archivo de perforación',
      holeFileCategorize: 'Los archivos de perforación se colocan por separado en carpetas según diferentes pedidos',
      holeTip: 'La composición tipográfica en la nube para clientes con gabinete integrado no tiene efecto',
      specialCodeErr: '¡No se admiten caracteres especiales!',
      copySuccess: '¡Copia exitosa!',
      copyErr: 'La copia falló, intenta arrastrar la etiqueta.',
      lengthLimit: '¡Solo admite la entrada de 15 dígitos!',
      plankInfo: 'Información del tablero',
      otherInfo: 'Otra información',
      uniqueBarCode: 'Código de barras de placa único',
      uniqueBarCodeForPack: 'Código de barras de placa único (solo para embalaje)',
      machineOrder: 'Generar número de serie de procesamiento a partir del nombre del archivo de corte',
      folderSetting: 'Colocar archivos de corte para placas grandes del mismo tamaño en la misma carpeta',
      labelImageINCFolder: 'Colocar imágenes de etiquetado y archivos de etiquetado en la carpeta NC',
      custom: 'Personalización',
      folderSettingTip: 'Nota: La composición tipográfica en línea actualmente no admite esta función',
      settingMoveTip: 'La función original "{func}" se ha migrado a la ¡Página "{module}"!',
      fileManagerFunction: 'Los archivos de perforación se colocan por separado en carpetas según el orden de los diferentes archivos',
      gotoSetting: 'Ir a configuración',
      singleFileTitle: 'Configuración de procesamiento de archivos individuales',
      slectSingleProcess: 'Seleccionar proceso de salida individual',
      slectSingleProcessTip: 'Aún hay procesos de procesamiento secundario de pago; elimínelos y guarde de nuevo',
      setSingleRegularSize: 'Configurar tamaño de agujeros y ranuras normales para salida individual',
      holeRange: 'Rango efectivo del agujero',
      slotRange: 'Rango efectivo de la ranura',
      holeRangeTip: 'El rango efectivo del agujero no puede estar vacío, ¡complételo!',
      slotRangeTip: 'El rango efectivo de la ranura no puede estar vacío, ¡complételo!',
      yhzc: 'Ranura recta en la sección curvada en arco',
      xbgy: 'Esquina Haitang biselada y asa biselada',
      nbyx: 'Forma irregular interna',
      secondaryProcessingMerge: 'Fusión de archivos de procesamiento secundario',
      secondaryProcessingMergeName: 'Nombre del archivo fusionado',
      secondaryProcessingMergeTip: 'Al activarlo, si el tablero exportado tiene varios procesos secundarios, se fusionarán en un mismo archivo de procesamiento',
      singleFileSetting: 'Generar archivos individuales para procesar esquinas biseladas y manijas de borde biselado',
      straightArcSlot: 'Generar archivos individuales para procesar ranuras rectas de piezas dobladas por arco'
      },
    aioMachineSetting: {
      openFunction: 'Las siguientes funciones deben activarse para el acoplamiento',
      openCarving: 'Activar la función de intercambio de ejes de la máquina de grabado',
      xyReverseFunction: 'XY',
      carvingStartSet: 'El punto de inicio de la estación de la máquina de grabado se establece en',
      rightTop: 'Esquina superior derecha',
      carvingEdgeSet: 'El valor de recorte frontal de la máquina de grabado se ajusta a',
      finalEdgeSame: ', que es el mismo que el valor de recorte total',
      beginCode: 'Código de inicio del programa',
      endCode: 'Código de finalización del programa',
      drillHole: 'Taladrado',
      pullTrough: 'Ranurado',
      showDataTemp: 'Mostrar muestra de datos',
      dataTemp: 'Muestra de datos',
      title: 'Configuración de la máquina todo en uno',
      outputFile: 'Salida de archivos de procesamiento de la máquina todo en uno',
      outputFileTips: 'Algunas marcas de máquinas todo en uno son incompatibles con intercambio XY, fusión de archivos y sin perforar agujeros con formas especiales. Úselo con precaución',
      fileType: 'Formato de archivo',
      select: 'Seleccione',
      diameter: 'Diámetro de la herramienta de recorte',
      jidongTip: 'Cuando utilice la máquina todo en uno Jidong, establezca el punto de inicio de la estación de la máquina de grabado en la esquina superior derecha y habilite la función A',
      skill: 'Función',
      clampHandLength: 'Longitud de la abrazadera (L)',
      clampHandWidth: 'Ancho de la pinza (W)',
      clampHandMargin1: 'Distancia de la pinza 1 borde (H1)',
      clampHandMargin2: 'Borde de distancia de la abrazadera 2 (H2)',
      duchClampHand: 'Posición de la abrazadera para evitar la ranura del orificio',
      clampHandDirection: 'Dirección de la abrazadera',
      left: 'Lado izquierdo',
      right: 'Lado derecho',
      top: 'Lado superior',
      bottom: 'Lado inferior'
      },
    oneDragTwo: {
      title: 'Máquina de grabado uno a dos',
      outputMachineFile: 'Salida de archivos de procesamiento de la máquina de grabado uno a dos',
      outputMachineFileTips: 'Habilitar la máquina de grabado uno a dos es incompatible con la función de fusión de archivos de la máquina de corte, utilícela con precaución',
      fileType: 'Formato de archivo',
      select: 'Seleccione',
      machineStart: 'Punto de inicio de la estación de trabajo',
      positionClose: 'Cuando esté cerrada, seguirá el inicio de la estación configuración del punto en los parámetros de corte',
      engravingPlus: 'Máquina de grabado rápido'
      },
    sawEngraving: {
      title: 'Máquina de aserrado y grabado',
      preLayNav: 'Configuración de la máquina de aserrado y grabado',
      preLayKnifeInput: 'Diámetro de la cuchilla de corte transversal de la hoja de sierra',
      enableSaw: 'Habilitar la máquina de aserrado y grabado',
      sawAioTip: 'No tiene permiso para la salida de datos de la placa de soldadura AIO; póngase en contacto con ventas para activar la función.',
      cutSet: 'Configuración de corte de la placa de soldadura',
      weldingPlank: 'Placa de soldadura',
      doorFrame: 'Marco de puerta',
      doorFrameTip1: 'Uso de la hoja de sierra',
      doorFrameTip2: '2.Uso de la hoja de sierra 3.Uso de la hoja de sierra',
      sawUsing: 'Uso de la hoja de sierra',
      trim: 'Recortar bordes',
      cutBlank: 'Corte en blanco',
      backTrimOblique: 'Recorte de bordes traseros',
      holeSlotOblique: 'Recorte de bordes traseros',
      plankThicknessUnit: 'Apilamiento de grosor de tablero',
      sawUseCond: 'Condiciones de uso de la hoja de sierra',
      exportPartData: 'Salida de archivos de datos de placas pequeñas (prohibición, mpr, xml, etc.)',
      sawAioTip2: 'Adecuado para sierras todo en uno sin copia',
      hasUsing: 'Úselo solo cuando haya un camino disponible',
      onlyUse: 'Use',
      cutMethod: 'Método de corte',
      oneKnifePull: 'Atraviese la tabla grande con un cuchillo',
      onlyOneKnifePull: 'Tire directamente con un cuchillo',
      enableSawThick: 'Habilite la composición tipográfica del espesor de la hoja de sierra',
      edgedDir: 'Bordes sellados de las tablas grandes que ya no se cortan',
      sameWidthPart: 'Coloque solo tablas pequeñas del mismo ancho en cada tabla grande',
      emptyPath: 'No genere una ruta vacía al cortar',
      sawUsePlank: 'Utilice solo el procesamiento con hoja de sierra para tableros soldados',
      paibanGap: 'Espacio de disposición de la placa soldada',
      minSurplusWidthDiff: 'Diferencia mínima de ancho restante del material restante',
      minSurplusWidthDiffTip: 'Solo cuando la diferencia de ancho entre el tablero pequeño y el material restante es menor que este valor, el tablero pequeño se colocará sobre el material restante',
      sawReplaceEnable: 'La dirección de corte de la sierra recta se reemplaza por la sierra',
      minSawLength: 'La dirección de corte de la sierra recta se reemplaza por la sierra',
      keepDistance: 'Distancia para mantener entre tableros adyacentes más anchos para el corte de la sierra recta',
      keepDistanceTip: 'Nota: Deje suficiente espacio para evitar cortar entre tableros adyacentes',
      sortByLength: 'Disponga en orden de acuerdo con la longitud de los paneles',
      sortByLengthTip: 'La dirección de corte es de abajo hacia arriba, y los tableros se organizan primero por ancho y luego por largo',
      plankAtTop: 'Los tableros pequeños se en la parte superior',
      plankAtBottom: 'Las tablas pequeñas están en la parte inferior',
      useSawTipOne: 'Después de habilitarla, solo las placas pequeñas con propiedades de placa soldada en el gabinete se procesarán con hojas de sierra, y las placas no soldadas se cortarán con un cuchillo recto',
      useSawTipTwo: 'Cuando se habilita y se usa la "secuencia de diseño de placa grande personalizada", las placas soldadas no usarán placas grandes estándar para el diseño, solo se usarán placas grandes especiales para el diseño',
      useSaiTipThree: 'Después de habilitar esta función, el plan de diseño debe usar corte y diseño con sierra',
      surplusStoreAndLabeling: 'Los materiales restantes después del corte se pueden almacenar e imprimir con etiquetas',
      surplusMinLength: 'El mínimo longitud disponible de los materiales restantes',
      surplusMinSize: 'El tamaño mínimo disponible de los materiales restantes',
      crossCutOnlyMinSurplusSize: 'Solo se generará una trayectoria de corte transversal si el material restante cumple con el tamaño mínimo utilizable',
      surplusStoreAndLabelingTip: '1. Se generará un área azul de material restante en la parte superior o inferior de la placa grande, que se puede guardar e imprimir etiquetas normalmente',
      surplusStoreAndLabelingTip2: '2. La función de "corte automático de material remanente" no será efectiva para placas soldadas)',
      surplusStoreAndLabelingTip3: '(Después de habilitarlo',
      backCutSurplus: 'El material restante se intercepta desde el reverso',
      cutSurplusTip: 'Después de habilitarlo, configure la secuencia de recorte inverso en "Recorte después del orificio inverso procesamiento"',
      top: 'Borde superior',
      bottom: 'Borde inferior',
      left: 'Izquierda',
      right: 'Derecha',
      dockTip: 'El procesamiento de placas de soldadura a tope requiere el mismo sellado de cuatro lados y recorte total de la placa rectangular, y operación manual en composición tipográfica de una sola fila',
      sawToLayoutTip: 'Después de habilitar esta función, solo se reservará un espacio de corte igual al espesor de la hoja de sierra entre las placas pequeñas durante la composición tipográfica',
      sawToLayoutTip2: 'La composición tipográfica de aserrado actualmente no admite la cuchilla de corte especificada',
      tempPaiabanTip: 'Después de habilitar el corte con hoja de sierra, no se admite agregar directamente paneles de formas especiales en la composición tipográfica. Si necesita agregarlo, vaya a la lista de cortes para agregarlo y componerlo.',
      generateCutSurplusPath: 'Genere una ruta de corte transversal que corte primero el material restante',
      curSurplusPathTip: 'Después de habilitarlo, configure la secuencia de recorte inverso en "Recorte después del orificio inverso procesamiento"'
      },
    robotArmDocking: {
      title: 'Acoplamiento del brazo robótico',
      enable: 'Habilite el acoplamiento del brazo robótico',
      enableTip: 'Después de encender, al generar el archivo de producción, se generará el archivo de acoplamiento del brazo robótico'
      },
    laserCuttingMachine: {
      title: 'Máquina láser todo en uno',
      enable: 'Habilite la máquina láser todo en uno',
      backSafeHeight: 'Cuando la parte posterior está inactiva Z Altura (H)',
      laserDistance: 'La distancia entre la cuchilla láser frontal/posterior y la superficie de la placa al cortar',
      coordinateAxis: 'Eje de coordenadas',
      xAxis: 'X',
      yAxis: 'Y',
      zAxis: 'Z',
      cuttingSettings: 'Configuraciones de corte',
      backKnifeStore: 'Almacén de herramientas inversas',
      noSupportOriginalMaterialKnife: 'actualmente no admite la función "selección de cuchilla de corte original"',
      laserKnifeTip: 'Corte: se usa para procesar formas especiales internas no perforadas',
      laserKnifeTip2: 'Cuchilla láser: procesa ranuras perforadas, formas especiales internas y corte de contorno externo',
      laserKnifeTip3: 'Nota: De forma predeterminada, el eje inverso Z usa las coordenadas relativas correspondientes a la distancia de la mesa',
      laserKnifeTip4: 'No puede ser menos de 1 herramienta',
      laserKnifeTip5: 'Las cuchillas de corte no se pueden eliminar',
      laserKnifeTip6: 'Se detecta que no se ha verificado ninguna herramienta para cortar, verifique al menos una herramienta',
      laserKnifeTip7: 'La cuchilla láser no puede procesar formas especiales que no se hayan cortado en el interior, y el elemento "corte" se ha desmarcado automáticamente',
      laserKnifeTip8: 'Verifique la herramienta con la opción "corte" en la biblioteca de herramientas; de lo contrario, no podrá procesar formas especiales que no se hayan cortado en el interior',
      laserKnifeTip9: 'El diámetro de la herramienta láser del cargador de herramientas de corte y la máquina láser todo en uno no son consistentes, verifique',
      laserKnifeTip10: 'El diámetro de la herramienta de corte del almacén de herramientas de corte no coincide con el diámetro de la herramienta de corte de la máquina láser todo en uno, verifique',
      laserKnifeTip11: 'Los parámetros de acoplamiento del equipo han sido modificados, reorganícelos',
      noLaserPermission: 'No tiene permiso para usar la máquina láser todo en uno, comuníquese con ventas para comprar el permiso de la máquina láser todo en uno antes de usarla',
      laserOpenCode: 'Código de encendido del láser',
      laserCloseCode: 'Código de apagado del láser',
      laserToolSettings: 'Configuración de la cuchilla láser frontal/inversa'
      },
    firstSave: 'Se detecta que el usuario está utilizando la composición tipográfica en la nube por primera vez. Después de guardar la configuración, preste atención a si la dirección de recorte en el archivo es razonable para evitar pérdidas innecesarias',
    knives: {
      xOffset1: 'X Compensación de coordenadas',
      yOffset1: 'Y Compensación de coordenadas',
      zOffset1: 'Z Compensación de coordenadas',
      insert: 'Insertar fila',
      delete: 'Eliminar fila',
      tip: '(Nota: después de completar la modificación de la información del almacén de herramientas o el ajuste de la configuración, los usuarios en la producción del diseño del gabinete deben reiniciar el cliente del gabinete para aplicar la última cambios!)',
      number: 'Número',
      name: 'Nombre',
      diameter: 'Diámetro de herramienta Φ',
      sawDiameter: 'Espesor de la hoja de sierra Φ',
      cutting: 'Corte',
      use: 'Propósito',
      moveZF: 'Z Velocidad de movimiento rápido del eje',
      axis_offset: 'Desplazamiento del eje',
      arc_radius: 'Radio del arco',
      cutZF: 'Z Velocidad de movimiento rápido del eje',
      moveF: 'XY Velocidad de movimiento rápido del eje',
      cutF: 'XY Velocidad de procesamiento del eje',
      startCode: 'Código de inicio de cambio de herramienta',
      stopCode: 'Código de fin de cambio de herramienta',
      startCode2: 'Código de inicio de cambio de herramienta de estación 2',
      stopCode2: 'Código de fin de cambio de herramienta de estación 2',
      knifeLength: 'Longitud de herramienta',
      maximum_single_depth: 'Profundidad de procesamiento máxima única',
      specialShapeKnifeTip: 'Solamente efectivo para formas especiales internas',
      preStartCode: 'Código de inicio previo',
      punchHoles: 'Taladrado',
      pullSlots: 'Ranurado',
      millHoles: 'Fresado de orificios',
      millSlots: 'Fresado de ranuras',
      sawBlade: 'Hoja de sierra',
      doubleSaw: 'Habilita diferentes códigos de inicio de cambio de herramienta para estaciones duales',
      singleStation: 'Estación única',
      doubleStation: 'Estación doble',
      sawBladeTip: 'Esta función no tiene efecto en máquinas de grabado de uno a dos y máquinas todo en uno',
      serialNum: 'Número',
      sawWidth: 'Ancho de herramienta',
      sawType: 'Tipo de hoja de sierra',
      cutDirection: 'Dirección de corte',
      moveSpeed: 'Velocidad de ralentí',
      cutSpeed: 'Velocidad de procesamiento',
      endCode: 'Código de fin de cambio de herramienta',
      sawDownCode: 'Código de corte',
      sawUpCode: 'Código de retroceso',
      abscissa: 'Prefijo de coordenadas de abscisa',
      ordinate: 'Prefijo de coordenadas verticales',
      sawHor: 'Hoja de sierra para corte transversal',
      sawVer: 'Hoja de sierra para corte vertical',
      towardsZero: 'Corte hacia la coordenada del punto 0',
      awayFromZero: 'Corte alejándose de la coordenada del punto 0',
      diameterDesc: 'Diámetro de herramienta Φ',
      xOffset: 'Desplazamiento de las coordenadas horizontales',
      yOffset: 'Desplazamiento de las coordenadas longitudinales',
      zOffset: 'Desplazamiento de las coordenadas de elevación',
      offsetX: 'Desplazamiento X',
      offsetY: 'Compensación Y',
      offsetZ: 'Compensación Z',
      offsetNo: 'Número de compensación',
      knifeWidth: 'Ancho de herramienta',
      drill: 'Corte',
      cut: 'Procesamiento',
      speed: 'Velocidad',
      type: 'Tipo',
      millHoleSlot: 'Fresado de orificio/ranura',
      rapidFeedSpeed: 'Avance rápido',
      typeOption1: 'Broca',
      typeOption2: 'Fresa',
      typeOption3: 'cortador de forma',
      typeTip: 'Después de configurar el tipo de herramienta, la ranura del orificio coincidirá con el tipo de herramienta correspondiente para el procesamiento'
      },
    other: {
      title: 'Otros',
      tip: '(Nota: el equipo de estación única debe completar el mismo código de carga automática para la estación 1 y la estación 2)'
      }
    },
  sideHoleMachine: {
    moreSetting: 'Más configuraciones',
    sideStartCode: 'Generar código de cambio de cara para el procesamiento frontal',
    useArcCode: 'Comando de interpolación de arco para cortar el arco',
    coordSwitch: 'Intercambio de datos de coordenadas',
    updownCoordSwitch: 'Intercambio de datos de coordenadas de elevación y descenso',
    xCoordSwitch: 'Intercambio de datos de coordenadas transversales',
    yCoordSwitch: 'Intercambio de datos de coordenadas longitudinales',
    knifes: {
      number: 'Número',
      diameter: 'Ancho de herramienta',
      type: 'Tipo',
      moveSpeed: 'Avance rápido',
      doSpeed: 'Velocidad de procesamiento',
      startCode: 'Código de inicio de cambio de herramienta',
      endCode: 'Código de fin de cambio de herramienta'
      },
    ymSetting: 'Conexión Yimu',
    flanking: 'Procesamiento lateral',
    frontProcess: 'Procesamiento frontal',
    oldSetting: 'Configuración de versión antigua',
    equipParamsSetting: 'Configuración de parámetros del equipo',
    holeSetting: 'Configuración de orificios',
    raminoSetting: 'Configuración de conexión lamino',
    mortiseTenonSetting: 'Configuración de conexión de mortaja y espiga',
    straight: 'Estilo recto',
    eccentric: 'Estilo excéntrico',
    pbSize: 'Tamaño de placa rota superior e inferior',
    slotOverlapRate: 'Tasa de superposición de ranuras de fresado',
    breakingBoardDirection: 'Dirección de rotura de placa hacia arriba y hacia abajo',
    coordinateValue: 'Valor de coordenadas',
    codeFormat: 'Formato de codificación de archivo',
    suffixSetting: 'Configuración de sufijo de archivo',
    insertRow: 'Insertar fila',
    deleteRow: 'Eliminar fila',
    equipmentParams: {
      equipPauseCode: 'Código de pausa del equipo',
      wiggleCode: 'Código de giro',
      equipStartCode: 'Código de inicio del equipo',
      flipPauseCode: 'Código de pausa de giro',
      equipEndCode: 'Código de fin del equipo',
      equipStartCodePlaceholder: 'Ingrese el código de inicio de equipo',
      retractingCode: 'Código de comando de cierre de herramienta',
      retractingCodePlaceholder: 'Ingrese el código de comando de retracción de la herramienta',
      flipPauseCodePlaceholder: 'Ingrese el código de pausa de vuelco',
      equipEndCodeTip: 'Ingrese el código de fin del equipo',
      sideChangeSetting: 'Configuración de cambio lateral',
      workTip: 'De forma predeterminada, el procesamiento comienza desde la izquierda ① en el sentido contrario a las agujas del reloj',
      frontTurnCode: 'Código de inicio superior',
      frontTurnEndCode: 'Código de fin superior',
      frontTurnCodePlaceholder: 'Ingrese el código de inicio superior',
      frontTurnEndCodePlaceholder: 'Ingrese el código de inicio izquierdo',
      leftTurnCode: 'Código de inicio izquierdo',
      leftTurnEndCode: 'Código de fin izquierdo',
      leftTurnCodePlaceholder: 'Ingrese el código de inicio izquierdo',
      leftTurnEndCodePlaceholder: 'Ingrese el código de fin izquierdo',
      downTurnCode: 'Código inicial a continuación',
      downTurnEndCode: 'Código final a continuación',
      downTurnCodePlaceholder: 'Ingrese el código inicial a continuación',
      downTurnEndCodePlaceholder: 'Ingrese el código final a continuación',
      rightTurnCode: 'Código inicial derecho',
      rightTurnEndCode: 'Código final derecho',
      rightTurnCodePlaceholder: 'Ingrese el código inicial derecho',
      rightTurnEndCodePlaceholder: 'Ingrese el código final derecho',
      topFlipCode: 'Código invertido - superior',
      downFlipCode: 'Código invertido - inferior',
      leftFlipCode: 'Código invertido - izquierda',
      rightFlipCode: 'Código invertido - derecho',
      cylinderOutCode: 'Código de extracción del cilindro',
      cylinderbackCode: 'Código de retracción del cilindro',
      cylinderbackDirective: 'Comando de retracción del cilindro',
      moveDirective: 'Comando de movimiento',
      moveAxisCode: 'Eje de movimiento',
      pushAxisCode: 'Eje de empuje del cilindro',
      swingAxisCode: 'Eje de giro',
      moveCode: 'Código de movimiento',
      punchCode: 'Código de procesamiento',
      free: 'Movimiento inactivo',
      punchPart: 'Pieza de procesamiento',
      cutFaceCode: 'Código de plano de procesamiento',
      horVerCutFace: 'Plano longitudinal horizontal',
      horCutFace: 'Plano de elevación horizontal',
      verCutFace: 'Plano de elevación longitudinal',
      specifySmallBoardMaterialNoCut: 'Especifique el material de placa pequeña y no lo deje en blanco',
      specifySmallBoardMaterialNoCutTip: 'Los paneles con las palabras clave correspondientes en el material de la placa solo generarán archivos de ranuras para perforación de cinco o seis lados y no dejarán en blanco',
      addMaterialKeyword: 'Agregar palabras clave de material',
      keyword: 'Palabras clave'
      },
    tagPool: 'Grupo de etiquetas de datos',
    dragTip: 'Las etiquetas en el grupo de etiquetas se pueden arrastrar y soltar',
    knives: 'Herramienta de procesamiento:',
    directives: 'Instrucciones de procesamiento:',
    slot: 'Procesamiento de ranura recta',
    cirWork: 'Procesamiento de arco',
    cirInter: 'Interpolación de arco',
    cirOption1: 'Sentido horario: G03 Sentido antihorario: G02',
    cirOption2: 'Sentido horario: G02 Sentido antihorario: G03',
    coordinate: {
      xPointSymbol: 'Coordenada horizontal:',
      yPointSymbol: 'Coordenada longitudinal:',
      zPointSymbol: 'Coordenada de elevación:',
      upright: 'Valor positivo',
      negative: 'Valores negativos'
      },
    encodeFormat: {
      format: 'Formato de codificación de archivo:',
      wrap: 'Configuración de formato de salto de línea:',
      formatOption1: 'UTF-8 formato',
      formatOption2: 'ANSI formato'
      },
    suffix: 'Configuración de sufijo de archivo:',
    enableFP: 'Habilitar procesamiento frontal',
    slotSetting: 'Configuración de ranurado',
    slotMillSetting: 'Ranurado/fresado y configuración de ranuras de fresado',
    millSlot: 'Admite fresado y ranuras de fresado',
    millingSlotOverlapRate: 'Tasa de superposición de ranuras de fresado',
    millingHoleSlotOverlapRate: 'Fresado y tasa de superposición de ranuras de fresado',
    takeUpDirective: 'Comando de cierre de herramienta',
    workSeparately: 'El la ranura lateral delantera/trasera se procesa en dos secciones',
    secondSlotLong: 'La longitud de la segunda ranura',
    enableOld: 'Habilita la configuración anterior de la máquina perforadora lateral',
    default: 'Configuración predeterminada',
    customizable1: 'Personalizada una',
    customizable2: 'Personalizada dos',
    customizable3: 'Personalizada tres',
    customizable4: 'Personalizada cuatro',
    knifeSetting: 'Configuraciones de herramientas',
    soltTip: '(incluyendo fresado de agujeros/ranuras)',
    specialSetting: 'Configuraciones especiales',
    ramino: 'Lamino',
    sun: 'Mortaja y espiga',
    please: 'Estén atentos',
    designatedKnives: 'Especificar herramienta',
    designated: 'Especificar',
    workOrder: 'Comando de procesamiento',
    other: 'Otros',
    nameSetting: 'Configuración de nombre de sufijo',
    repeatErr: 'Número duplicado, restablecer'
    },
  electronicSaw: {
    importMaterial: 'Importar lista de materias primas',
    formSetting: 'Configuración de forma de sierra electrónica',
    fileFormat: 'Formato de archivo de lista de corte de salida:',
    isSmallFile: 'Exportar archivo de imagen de placa pequeña:',
    fileGroupRule: 'El archivo de sierra electrónica se divide en diferentes tablas según el color, el material y el espesor de la placa:',
    roomsByCategory: 'El archivo de sierra electrónica se divide en diferentes tablas según la habitación:',
    delimiter: 'Separador:',
    fileName: 'Nombre del archivo de la lista de corte de material:',
    fineNameTip: '¡El nombre del archivo de la lista de corte de material no puede estar vacío!',
    fileNamePlaceholder: 'Lista de materiales personalizada',
    outputFileEncoding: 'Formato de codificación de lista de salida:',
    utf8: 'UTF-8 con BOM',
    cellTab: 'Generar pestaña de celda:',
    texture: 'Representación de textura:',
    special: 'Representación con forma especial:',
    notSpecial: 'Sin forma especial',
    genSimpleLabelBarcode: 'Generar código de barras de etiqueta de formato simple',
    uniqueBarCode: 'Código de barras de placa único',
    uniqueBarCodeTip: 'La función de generar código de barras de etiqueta de formato simple no tiene efecto después de activarla',
    roboticArmDocking: 'Acoplamiento del brazo robótico',
    customeForm: 'Formulario personalizado',
    tagPool: 'Grupo de etiquetas de datos',
    tagPoolTips: 'Puede arrastrar o hacer clic para copiar la etiqueta en el grupo de etiquetas',
    displayHead: 'No mostrar el encabezado',
    addTableHead: 'Agregar encabezado',
    deleteTableHead: 'Eliminar encabezado',
    generateExample: 'Generar muestra de formulario de salida',
    importExample: 'Importar muestra de formulario',
    importExampleTip: 'Muestra de formulario importada, solo como referencia para sierras electrónicas personalizadas',
    importExampleErrTip: 'La lista de materiales no ha sido importada aún, importe la lista de materiales',
    outputExample: 'Muestra de formulario de salida',
    outputExampleTip: 'Muestra de salida de formulario personalizado',
    outputExampleErrTip: 'La muestra de formulario de salida aún no se ha generado, genere la muestra de formulario de salida',
    defaultTableHead: 'Encabezado predeterminado',
    deleteHeadErrTip: '¡No hay ningún encabezado que pueda eliminarse!',
    genNonString: 'Generar tipo de datos en formato sin texto',
    genNonStringTip: 'Si la sierra electrónica no puede reconocer los datos de la tabla generada, puede intentar habilitarlos.',
    revertWidth: 'Intercambiar el largo y el ancho de los paneles con rayas horizontales'
    },
  lockModal: {
    passwordInput: 'Por favor ingrese la contraseña',
    lockPassword: 'Contraseña de bloqueo',
    lockPasswordInput: 'Ingrese la contraseña de desbloqueo',
    passwordInputPlaceholder: 'Ingrese la contraseña de cuatro dígitos',
    editPassword: 'Cambiar contraseña',
    confirmPassword: 'Confirmar contraseña',
    setLockPwd: 'Establezca la contraseña de desbloqueo',
    pwdFormatErr: 'Formato de contraseña incorrecto',
    sendMessageTo: 'El código de verificación por SMS se enviará a',
    captchaPlaceholder: 'Ingrese el código de verificación',
    sendCaptcha: 'Enviar código de verificación',
    sendSeccess: 'SMS enviado exitosamente',
    sendFail: 'SMS enviado fallido, inténtelo nuevamente más tarde',
    updateSeccess: 'Contraseña establecida exitosamente',
    editSuccess: 'Contraseña modificada exitosamente',
    lockSeccess: 'Desbloqueado exitosamente',
    lock: 'Desbloquear',
    lockSeccessTip: 'Bloqueado exitosamente',
    inputErrLimit: 'El número actual de errores ha alcanzado el límite, ¡restablezca la contraseña de desbloqueo!'
    },
  dock56Drill: {
    equipType: 'Tipo de equipo',
    equipment: 'Equipo',
    fiveDock: 'Taladro de cinco lados',
    sixDock: 'Taladro de seis lados',
    fileType: 'Tipo de archivo generado',
    templateOffline: '¡La plantilla utilizada está fuera de línea!',
    showExample: 'Mostrar muestra de datos',
    conNoticeTip: 'Notas de acoplamiento:',
    conNoticeTip1: '1. La máquina de grabado con "XY intercambio de ejes habilitado" necesita activar la función "adaptación e intercambio automático del equipo de procesamiento de orificios" en la máquina de grabado',
    conNoticeTip2: '2. Para mostrar o procesar la parte con forma especial del panel en el taladro de cinco y seis lados, los datos de la pieza con forma especial deben configurarse en la plantilla',
    conNoticeTip3: '3. Después de usar el taladro de cinco y seis lados o cambiar la plantilla por primera vez, por favor <span style="color:#f00"> realice una producción de prueba del gabinete </span> y luego continúe con la producción regular después de la confirmación',
    conNoticeTip4: '4. Durante la producción de prueba, verifique cuidadosamente si el tamaño, la profundidad, la superficie y la posición de las ranuras frontal y posterior son correctos, <span style="color:#f00" > para evitar el problema de duplicación del gabinete </span>',
    example: 'Muestra de datos',
    commonSetting: 'Configuración de parámetros generales',
    throughHoleSetting: 'Los orificios pasantes se abren en ambos lados',
    throughSlotSetting: 'Las ranuras pasantes se abren en ambos lados',
    nonHolesNotFiles: 'Si la placa rectangular no tiene agujeros, el archivo no se generará:',
    frontFileIdentifier: 'Identificación frontal del archivo:',
    oppositeFileIdentifier: 'Identificación inversa del archivo:',
    oppositeFileIdentifierTips: 'El método de generación es: código de placa original de 13 bits + carácter de identificación',
    arcDescription: 'Método de descripción del arco',
    linePoints: 'Descripción de formación de segmento de línea',
    arcCommand: 'Descripción del comando de arco',
    slotWidthSplit: 'Desarme una ranura ancha en múltiples ranuras estrechas para su procesamiento:',
    slotSplitWidth: 'Ancho de ranura única después del desmontaje:',
    mm: 'Nota: El objeto de desmontaje es una ranura rectangular ordinaria',
    isNotMergeSlot: 'Se extraen ranuras adyacentes de igual ancho y profundidad:',
    slotPunchTip: 'Esta función solo es efectiva para las ranuras del panel posterior y las ranuras del fondo del cajón usando plantillas personalizadas',
    sizeRange: 'Las dimensiones adyacentes son menores o iguales a',
    enableWorningTip: 'Esta función y la dirección de colocación del borde frontal no se pueden activar al mismo tiempo',
    longDirection: 'Dirección de colocación del lado largo de los paneles',
    horizontal: 'Horizontal',
    vertical: 'Longitudinal',
    slotDirection: 'Ranura de perforación de cinco/seis lados o dirección de colocación de forma especial',
    default: 'Predeterminado del sistema',
    frontLeft: 'Frontal e izquierda',
    frontRight: 'Frontal y derecha',
    backLeft: 'Atrás e izquierda',
    backRight: 'Atrás y derecha',
    frontDirection: 'Dirección de colocación de las bandas del borde frontal',
    enableTip: 'Nota: Solo efectivo para composición tipográfica en la nube',
    fixedOn: 'Fijado delante de:',
    front: 'Front',
    back: 'El siguiente valor de coordenadas',
    left: 'Izquierda',
    right: 'Derecha',
    coordinateValue: 'retiene el número de dígitos:',
    decimalPlaces: 'dígitos',
    slotLengthCompensation: 'Compensación de longitud de ranura',
    curveholesLengthCompensation: 'Limpieza de esquina interna con forma especial',
    slotCompensationEqualZero: 'Compensación de borde de ranura con una distancia de 0',
    slotCompensationNotEqualZero: 'Compensación de borde de ranura con una distancia distinta de 0',
    slotCompensationTip: 'Utilice esta función cuando procese un pequeño filete que no se ha cortado limpiamente o la longitud no es suficiente',
    curveholesCompensationEqualZero: 'Compensación de borde interno de forma especial con una distancia de 0',
    curveholesCompensationTip: 'Entrada recomendada: valor del radio de la herramienta interna de fresado con forma especial',
    curveholesCompensationTip2: 'Utilice esta función cuando la forma especial interna procesada por el borde rectangular del contorno de la placa tenga pequeños filetes sin cortar',
    specialParameter: 'Configuración de parámetros especiales',
    output5FDrillSlotKnifeCode: 'XML2 Número de herramienta de fresado',
    output5FDrillShapeKnifeCode: 'XML2 Número de herramienta de fresado',
    plankTexture: 'XML2Textura de placa',
    offset: 'XML2 Compensación de herramienta de fresado',
    mprConHoleDir: 'Perforación de cinco/seis lados MPR Orificio lateral de lima Z Plano de referencia de coordenadas',
    plankTop: 'Superficie superior del panel',
    plankBottom: 'Superficie inferior del panel',
    codeInfo: 'El archivo de formato prohibido contiene Code información:',
    bomFile: 'Archivo de formato bom de salida:',
    plankHeight: 'Descripción de la altura del panel:',
    plankNum: 'Descripción del número de placa:',
    backZpoint: 'Ranura inversa Z coordenadas:',
    plankThick: 'Espesor de la placa',
    slotDeep: 'Profundidad de ranura',
    outputMprFile: 'Tipo de archivo',
    oldMPR: 'Versión anterior MPR',
    newMPR: 'Nueva versión MPR',
    mprFileZside: 'Perforación de cinco/seis lados MPR Orificio lateral de lima Z Plano de referencia de coordenadas',
    fileTypeOffline: 'El tipo de archivo de diamante de cinco y seis lados seleccionado actualmente ha estado fuera de línea, ¡confírmelo!',
    permissionErr: 'La información de identidad se ha perdido. ¡Vuelva a abrir esta página desde el gabinete!',
    banFileSetting: 'configuración de archivo de formato prohibido',
    banFileCodeInfo: 'El archivo de formato prohibido contiene Code información:',
    huahuaLine: 'Línea automática Huahua',
    huahuaLineTip: '(No compatible con el estándar de ubicación de la etiqueta)',
    huahuaPartFlag: {
      longSide: 'El lado largo es más pequeño que',
      shortSide: 'o el lado corto es más pequeño que',
      partFlag: 'Generar identificación de tablero pequeño para las partes del tablero',
      tip: '(Es necesario agregar datos de "identificación de placa-marca de placa pequeña" para mostrar en la etiqueta, y los datos correspondientes se agregarán automáticamente al archivo de línea automática de Huahua)'
      },
    plankPutWay: 'Método de colocación del panel',
    plankPutWayTip: 'Si la línea de producción actual está habilitada, no se admite la configuración del método de colocación de la tabla',
    autoHandle: 'Evitación automática de las manos de sujeción',
    manualHandle: 'Configuración manual de evitación',
    fixedFront: 'Banda de borde frontal fija',
    plankNamePlacement: 'Colocación por nombre de panel',
    plankNamePlacementTip1: '1. Tras la configuración, si el nombre del panel contiene el campo definido, el borde correspondiente se fijará en el lado indicado del equipo según la configuración',
    plankNamePlacementTip2: '2. La prioridad de esta configuración es mayor que la del método de colocación del panel de arriba',
    plankNamePlacementTip3: '3. Esta función solo aplica al diseño en la nube; si la línea de producción actual tiene habilitada la línea automática Huahua, no se admite configurar por separado la colocación del panel',
    addRow: 'Añadir fila',
    plankNameTip: 'Por favor, introduzca el nombre del panel',
    plankSide: 'Borde del panel',
    deviceSide: 'Fijado en el equipo',
    weldingPlatePlacementEnable: 'Fijación de la placa de soldadura fija',
    onlyBluen: 'Solo efectivo para composición tipográfica de nubes',
    fixedEdge: 'Banda de borde frontal fija',
    fixedEdgeRule: 'Regla: Determinar la ubicación de la placa',
    fixedEdgeRuleItem1: 'Lado largo cerca de la abrazadera',
    fixedEdgeRuleItem2: 'Banda de borde frontal fija',
    fixedEdgeRuleItem3: 'Banda de borde frontal fija',
    fixedEdgeRuleItem4: 'Orden de prioridad',
    satisfiedCondition: 'Orden de prioridad',
    handDirection: 'Dirección de las manos de sujeción',
    handleMachineTip: 'Al girar, las ranuras y las formas especiales evitan automáticamente el lado donde se encuentra la abrazadera, lo que facilita el procesamiento del panel',
    handleWidth: 'Ancho de la abrazadera',
    handleLength: 'Longitud de la abrazadera',
    handleMaxWidth: 'Ancho máximo que el equipo puede procesar',
    usefulRange: 'Rango efectivo',
    plankLongSide: 'Lado largo del tablero',
    usefulRangeTip: 'Cuando el lado largo del tablero está habilitado y el lado largo del tablero está dentro del rango efectivo, se priorizarán las posiciones de colocación de ranuras y formas especiales',
    moveTip: 'La función de marcado de documentos frontal y posterior se ha migrado a',
    millingOuter: 'Fresado de formas especiales exteriores',
    millingInner: 'Fresado de formas especiales interiores',
    drilling: 'Mecanizado de agujeros',
    slotting: 'Mecanizado de ranuras',
    knivesTip1: '1. Después de configurar la fresa de forma especial, la trayectoria de corte compensará su radio de corte',
    knivesTip2: '2. El corte de forma especial actualmente no admite la máquina de grabado intercambiable del eje xy',
    internalCutting: 'El corte interno de forma especial y la apertura y cierre de la cuchilla están en el interior de la placa',
    externalCutting: 'El corte externo de forma especial y el corte externo de forma especial están en el exterior de la placa',
    externalCuttingDirection: 'Cuando se realiza el corte externo de forma especial, el todo el borde que contiene la forma especial se cortará simultáneamente',
    allExternalCutting: 'Todas las formas externas con formas especiales',
    onlyArcExternalCutting: 'Solo la forma especial del arco exterior'
    },
  doorWallCabinet: {
    tempErrTip: 'Se detectó que no ha agregado la plantilla utilizada por la máquina integrada de puerta, pared y gabinete, por lo que no se puede exportar el archivo de procesamiento. Nota: después de agregarla, debe volver a realizar la composición.',
    title: 'Máquina integrada de puerta, pared y gabinete',
    guifang: 'Escuadrado',
    processingTechnology: 'Tecnología de procesamiento',
    longPlateSecondarySquaring: 'Escuadrado secundario de placa larga',
    slotOnDoorPlate: 'Ranura en la placa de puerta',
    setting: 'Configuración de la máquina integrada de puerta, pared y gabinete'
    },
  PTP: {
    title: 'PTP',
    outputFileFormat: 'Formato de archivo de salida',
    outputDefaultFileFormat: 'Archivo de formato predeterminado de salida',
    outputMPRFormat: 'Archivo de formato de salida MPR',
    fileFormatSettings: 'Configuración de formato de archivo',
    wrapSettings: 'Configuración de formato de salto de línea:',
    enCodeSettings: 'Configuración de formato de codificación de archivo:',
    utf8bom: 'UTF-8 con BOM',
    partCoordinate: 'Coordenadas de placa pequeña',
    xPointSymbol: 'Coordenada horizontal:',
    yPointSymbol: 'Coordenada longitudinal:',
    zPointSymbol: 'Coordenada de elevación:',
    upRight: 'Valor positivo',
    negative: 'Valores negativos',
    plankMirroring: 'Espejo de placa',
    plankMirrorSetting: 'Configuración de espejo de placa:',
    xAxis: 'X Espejo del eje',
    yAxis: 'YReflejo del eje',
    mirrorTip: '(use esta función al reflejar la placa)',
    knifeTable: {
      type: 'Tipo',
      diameter: 'Diámetro Φ',
      offsetX: 'Desplazamiento X',
      offsetY: 'Compensación Y',
      offsetZ: 'Compensación Z',
      offsetNo: 'Número de compensación',
      drillVelocity: 'Corte [F]mm/min',
      cutVelocity: 'Procesamiento [F]mm/min',
      rotationSeep: 'Velocidad de rotación [S]r/min',
      insertRow: 'Insertar fila',
      deleteRow: 'Eliminar fila'
      },
    labelPool: 'Grupo de etiquetas de datos',
    dragTip: 'Puede arrastrar o hacer clic para copiar las etiquetas en el conjunto de etiquetas en el cuadro de entrada',
    procedure: 'Programa',
    beginCode: 'Código inicio programa:',
    endCode: 'Código fin programa:',
    zzdKnifeBeginCode: 'Código inicio cambio herramienta husillo:',
    spindleCutter: 'Herramienta husillo',
    zzdKnifeEndCode: 'Código fin cambio herramienta husillo:',
    verticalDrill: 'Perforación vertical',
    czzBeginCode: 'Código inicio perforación vertical:',
    czzEndCode: 'Código fin perforación vertical:',
    czzKnifeBeginCode: 'Código inicio cambio herramienta perforación vertical:',
    czzKnifeEndCode: 'Código fin cambio herramienta perforación vertical:',
    sidetrack: 'Código inicio perforación lateral',
    czBeginCode: 'Código inicio perforación lateral:',
    czEndCode: 'Código fin perforación lateral:',
    czKnifeBeginCode: 'Código inicio cambio herramienta perforación lateral:',
    czKnifeEndCode: 'Código fin cambio herramienta perforación lateral:',
    pauseCode: 'Código de pausa:',
    zSafeHeight: 'Distancia de seguridad',
    spindleKnife: 'Herramienta de husillo y perforación vertical Z altura de seguridad del eje',
    sideDrillZ: 'Perforación lateral Z altura de seguridad del eje',
    sideDrillXY: 'Perforación lateral X/Y distancia de seguridad del eje',
    auxiliaryFunction: 'Función auxiliar',
    xhDedicatedInfo: 'Generar información específica del equipo Xinghui',
    xhCheckBox: 'Datos:',
    outputSettings: 'Configuraciones de salida:',
    partExegesis: 'Generar comentarios de tamaño de placa pequeña en el archivo',
    knifeNo: 'Herramienta número',
    specailKnifeNo: 'Número de herramienta de forma especial:',
    slotKnifeNo: 'Número de herramienta de ranurado:',
    fileNamePlaceholder: 'Lista de materiales personalizada',
    slotDrill: 'Cuchilla enderezadora'
    },
  glassEquip: {
    title: 'Máquina cortadora de vidrio',
    fileType: 'Tipo de archivo de procesamiento:',
    sizeReparation: 'Compensación del tamaño de la placa:',
    cutPreSpace: 'Espaciado de reserva de corte de la placa:',
    divideIntoFolders: 'Clasificado en diferentes carpetas según el color, material y espesor del vidrio:'
    },
  translate: {
    search: 'Ingrese chino o traducción oficial para encontrar la entrada',
    en: 'Inglés',
    es: 'Español',
    ar: 'Árabe',
    kz: 'Kazajo',
    vi: 'Vietnamita',
    th: 'Tailandés',
    id: 'Indonesio',
    ug: 'Uigur',
    customTranslate: 'Haga clic para agregar una traducción personalizada',
    customText: 'Traducción personalizada',
    text: 'Chino',
    targetLang: 'Traducción oficial',
    zh_hant: 'Chino tradicional'
    },
  preLayoutSetting: {
    title: 'Ajustes preestablecidos',
    titleTip: 'Puede preestablecer los parámetros de composición primero, componer primero y luego seleccionar la línea de producción',
    settingTip: 'Los parámetros configurado en la línea de producción debe ser consistente con los siguientes parámetros de composición previa para generar el archivo de producción, lo cual solo es efectivo para la máquina de corte',
    emptyKnife: 'La herramienta no está completa',
    noModify: 'La configuración no ha sido modificada, no es necesario guardar',
    reSet: 'Restaurar',
    gayPosition: 'El cuadrado gris puede cambiar la posición de colocación del material restante',
    surplusPosition: 'es la posición de colocación del material restante actual',
    click: 'Haga clic en',
    grayStart: 'El cuadrado gris puede cambiar la posición inicial punto de la estación de trabajo',
    currentStart: 'Para el punto de inicio de la estación actual',
    holeSlotSetting: 'Configuración de procesamiento de ranuras de perforación y perforación',
    knifeDiameter: 'Diámetro de la cuchilla de corte',
    currentVersion: 'Versión actual',
    on: 'Encendido',
    off: 'Apagado',
    firstShort: 'Primer corte - sobrecarga del lado corto',
    firstLong: 'Primer corte - sobrecarga del lado largo',
    cuttingSplitLong: 'La placa larga se corta en dos veces - el lado largo excede',
    cuttingSplitShort: 'La placa larga se corta en dos veces - el lado corto excede',
    plankThick: 'Espesor de la placa convencional ≥',
    singleDoorThick: 'Espesor de la placa de puerta ≥ ',
    normalPlank: 'Placa convencional',
    confilictTip: 'Hay elementos de conflicto de configuración: {confilictTotal}',
    selectLine: 'Seleccionar línea de producción',
    selectLinePlaceholder: 'Seleccione la línea de producción',
    lineConfilictTip: 'Hay un conflicto entre la línea de producción seleccionada y {line}',
    preWay: 'Plan de diseño previo',
    paibanErrTip: 'Cuando se cambia el 【长、短边放量】 del procesamiento de placas largas, puede causar que el diseño falle',
    paibanTip: 'Hay una cuchilla de corte designada para el material de placa grande en este diseño, y debe ser re-diseño',
    reLayout: 'Re-diseño con la línea de producción actual',
    fetchErr: 'No se pudo obtener la configuración de diseño previo',
    resetSuccess: 'Restauración exitosa',
    resetConfirm: '¿Está seguro de que desea restaurar a la versión histórica?',
    prolineName: 'Nombre de la línea de producción',
    layoutGap: 'Espacio de composición tipográfica',
    generalThickness: 'Objeto de corte secundario - espesor de placa normal',
    cutGeneralPlank: 'Objeto de corte secundario - placa normal',
    cutSingleDoor: 'Objeto de corte secundario - panel de puerta',
    secondary_cutting_board_list: 'Especifique el nombre de la placa para cortar la lista de nombres del panel',
    changeProline: 'Cambiar línea de producción',
    backTip: 'Regrese a la composición tipográfica global para seleccionar la línea de producción',
    preLayout: 'Composición tipográfica según el esquema de composición tipográfica previa',
    preWayEmpty: 'Esquema de precomposición (vacío)',
    specialConfilictTip: 'El proceso de fresado en arco afecta los resultados de la composición tipográfica y es necesario volver a componerlo'
    },
  lunbo: {
    tips: 'Consejos de operación',
    introduction: 'Introducción a la función',
    qtDownloadText: 'Recordatorio: si el archivo descargado está incompleto, vaya a la página web de composición tipográfica en la nube para descargarlo.'
    },
  sendModal: {
    paibanImgType: 'Tipo de archivo de diseño'
    },
  authenticationModal: {
    title: 'Escanee el código para verificar la autorización',
    tip: '¡No cierre el cuadro emergente antes de que la autorización sea exitosa!',
    countdownTip: 'Caduca después de {countdown}',
    refreshTip: 'Actualizar el código QR',
    qrcodeTip: 'Utilice WeChat para escanear el código QR y completar la operación',
    qrcodeTip2: 'Si el código QR escaneado no se guarda, debe estar autorizado para modificar los permisos del sistema en la configuración general del gabinete - configuración de autorización de usuario.',
    waiting: 'Esperando escaneo',
    scanning: 'Código escaneado, esperando confirmación',
    success: 'Verificación exitosa',
    error: 'Verificación fallida',
    expired: 'El código QR ha caducado',
    tip2: 'Para la seguridad de los datos de su cuenta, la información del operador actual debe ser verificada',
    tip3: 'Los gabinetes de producción de prueba deben ser {fontStyleStart} gabinetes asimétricos para evitar problemas de duplicación de gabinetes {fontStyleEnd}'
    },
  printTag: {
    dualLanguageTip: 'No tiene permiso para generar Etiquetas bilingües en chino e inglés. Actualmente, sólo puedes obtener una vista previa de ellos. Si desea utilizarlos oficialmente, comuníquese con ventas para activarlos ~',
    generateDualLanguageTagTip: 'Generar etiquetas bilingües en chino e inglés',
    dualLanguageTip2: 'Esta función es una función paga. Comuníquese con ventas para activarlo ~',
    effectiveDataSource: 'Fuente de datos efectiva',
    partName: 'Nombre del panel'
    },
  userAccessToken: {
    createTime: 'Hora de creación',
    lastUsedTime: 'Hora de último uso',
    expireTime: 'Hora de caducidad',
    status: 'Estado',
    tokenNamePlaceholder: 'Introduzca el nombre del token',
    expireTimeSelectPlaceholder: 'Seleccione la hora de caducidad',
    securityBannerTip: 'No comparta su token de acceso personal con otras personas ni lo exponga en el navegador u otro código de cliente. Para proteger su cuenta, cualquier token filtrado públicamente puede deshabilitarse automáticamente.',
    expired: 'Caducado',
    valid: 'Válido',
    remove: 'Eliminar',
    previewOnceWarning: 'Este token solo se muestra una vez. Guarde este secreto en un lugar seguro y accesible. No lo comparta con otras personas ni lo exponga en el navegador u otro código de cliente.',
    token: 'Token',
    deleteConfirm: '¿Seguro que desea eliminar este token?',
    userAccessToken: 'Token de acceso de usuario',
    dayUnit: 'd',
    custom: 'Personalizado',
    previewModalTitle: 'Nuevo token de acceso personal',
    addModalTitle: 'Agregar nuevo token de acceso personal'
    },
  bujianStore: {
    inputPlaceholder: 'Ingrese el código de la tabla para buscar tableros pequeños de repuestos',
    noData: 'No hay datos',
    loadingErr: 'Carga de paneles de repuestos fallida',
    bujianStore: 'Biblioteca de papeles impresos',
    awaitStore: 'Biblioteca de materiales impresos',
    noDrag: 'No se puede colocar, por favor, verifique las propiedades de material, color y espesor del panel',
    outOfCanvas: 'No se puede colocar, por favor, verifique las propiedades de material, color y espesor del panel'
    },
  alginTexture: {
    tip: 'Esta operación borrará la información de alineación de textura de la pieza. ¿Confirma que desea continuar?',
    tip2: 'Esta operación afectará la distancia entre las piezas, causando problemas en el procesamiento. ¿Confirma que desea continuar?',
    group: 'Grupo de textura',
    groupTemp: 'Grupo de textura uno',
    textureAlignmentPlank: 'No se puede mover el panel de alineación de textura'
    },
  customizeFolder: {
    customizeFolder: 'Personalización de carpeta',
    customizeFolderTip: 'Nota: Después de activar la personalización de la carpeta, las reglas de división de carpetas establecidas anteriormente ya no tendrán efecto',
    processingFilesTitle: 'Procesamiento de datos de archivo',
    dragToFolderTip: 'Puede arrastrarse a la carpeta izquierda como subcarpeta o archivo',
    folderNameEmpty: 'El nombre de la carpeta no puede estar vacío',
    folderNameExists: 'Existe una carpeta con el mismo nombre',
    fileNotFound: 'No se pudo obtener el archivo correcto',
    fileCannotBeClassified: 'Este tipo de archivo no puede colocarse en ningún carpeta de clasificación',
    cannotAddAtThisPosition: 'No se puede agregar en esta posición',
    fileAlreadyExists: '【{name}】ya existe en esta carpeta',
    confirmDeleteFolder: '¿Está seguro de querer eliminar esta carpeta?',
    confirmDeleteItem: '¿Está seguro de querer eliminar 【{name}】?',
    confirmDeleteFolderWithChildren: 'Hay otras carpetas/archivos bajo esta carpeta, ¿está seguro de querer eliminarlos?',
    deleteFile: 'Eliminar archivo',
    addSubFolder: 'Agregar subcarpeta',
    editFolder: 'Editar carpeta',
    deleteFolder: 'Eliminar carpeta',
    rootCannotDelete: 'El directorio raíz no se puede eliminar',
    newFolder: 'Carpeta nueva',
    fileUsedCanDrag: 'Usado - Puede ser arrastrado repetidamente',
    fileDraggable: 'Arrastrable',
    addFileToFolder: 'Agregar 【{fileName}】 a {folderName}',
    addFolderTitle: 'Agregar carpeta',
    editFolderTitle: 'Editar carpeta',
    folderNameLabel: 'Nombre de la carpeta',
    folderNamePlaceholder: 'Por favor, introduzca el nombre de la carpeta',
    sequenceStartLabel: 'Valor inicial de secuencia incremental',
    classifyMethodLabel: 'Método de clasificación',
    nameLengthLimitLabel: 'Límite de longitud de caracteres',
    tagInsertTip: 'Haga clic en la etiqueta para insertar en el nombre de la carpeta',
    classifyTagInsertTip: 'Haga clic en la etiqueta para insertar en el nombre de la carpeta, los archivos se clasificarán según la etiqueta especificada',
    engraving_front: 'Archivo frontal de la máquina de grabado',
    engraving_opposite: 'Archivo posterior de la máquina de grabado',
    engraving_merge: 'Archivo de fusión de la máquina de grabado',
    engraving_mill: 'Molienda de canaletas de cuerno secundaria',
    engraving_haitang: 'Archivo de ángulo Haitang bevelado procesado secundario',
    engraving_arc_slot: 'Molienda de slot circular inferior procesado secundario',
    engraving_line_slot: 'Xử lý thứ cấp đường công cụ tùy chỉnh',
    engraving_straight_arc_slot: 'Xử lý thứ cấp phần uốn cong hình cung slot thẳng',
    engraving_frame_door: 'Archivo de puerta de huesos procesado secundario',
    engraving_inner_shape: 'Xử lý thứ cấp parte interior de forma',
    engraving_hole: 'Xử lý thứ cấp lỗ thường',
    engraving_slot: 'Xử lý thứ cấp lỗ thường',
    engraving_single_file_merge: 'Xử lý thứ cấp archivo de fusión',
    electronic_saw: 'Archivo de sierra eléctrica procesado secundario',
    glass: 'Archivo de máquina de corte de vidrio procesado secundario',
    glass_machine: 'Máquina de corte de vidrio procesado secundario',
    side_machine: 'Archivo de máquina de perforación lateral procesado secundario',
    side_machine_xml3: 'Archivo de máquina de perforación lateral XML3 procesado secundario',
    side_machine_txt: 'Archivo de máquina de perforación lateral TXT procesado secundario',
    side_machine_nc: 'Archivo de máquina de perforación lateral NC procesado secundario',
    dock56F: 'Archivo de perforación cinco/seis lados procesado secundario',
    ptp: 'Archivo PTP procesado secundario',
    aio: 'Archivo de máquina all-in-one procesado secundario',
    aio_anc: 'Archivo ANC frontal de la máquina all-in-one procesado secundario',
    labeling_1: 'Archivo de máquina de etiquetado 1 procesado secundario',
    labeling_2: 'Archivo de máquina de etiquetado 2 procesado secundario',
    labeling_3: 'Archivo de máquina de etiquetado 3 procesado secundario',
    robotic_arm: 'Archivo de brazo robot procesado secundario',
    label_image: 'Archivo de imagen de etiqueta procesado secundario',
    label_pdf: 'Archivo PDF de etiqueta procesado secundario',
    paiban_image: 'Archivo de imagen de tiposetting procesado secundario',
    paiban_pdf: 'Archivo PDF de tiposetting procesado secundario',
    engraving: 'Máquina de grabado procesado secundario',
    electronic: 'Sierra eléctrica procesada secundaria',
    side_hole: 'Máquina de perforación lateral procesada secundaria',
    drilling: 'Perforación cinco/seis lados procesada secundaria',
    labeling: 'Máquina de etiquetado procesada secundaria',
    robotic: 'Brazo robot procesado secundario',
    label: 'Etiqueta',
    warningTip: 'Por favor, tenga en cuenta: Los corchetes 【{}】 y su contenido deben mantenerse intactos, no se debe eliminar/agregar manualmente!',
    fileClassifyError: 'Este archivo no puede clasificarse según {classifyNames}',
    folderClassifyByTextureColorThickSize: 'Clasificar en diferentes carpetas según color, material, grosor y tamaño de la placa (archivos de etiqueta juntos)',
    unnamed: 'Sin nombre',
    specialText: 'Especial',
    surplusText: 'Material excedente',
    normalText: 'Normal',
    plankText1: 'Tablero',
    resetTemplate: 'Restablecer plantilla',
    resetTemplateConfirm: '¿Está seguro de querer restablecer la plantilla?',
    clearTemplate: 'Vaciar plantilla',
    clearTemplateConfirm: '¿Está seguro de querer vaciar la plantilla?',
    legendFixedFolder: 'Carpeta fija',
    legendClassifyFolder: 'Carpeta clasificada',
    legendFixedTag: 'Datos fijos',
    legendNormalTag: 'Datos dinámicos',
    legendClassifyTag: 'Datos dinámicos clasificados',
    door_wall_aio: 'Máquina integrada de puerta, pared y gabinete',
    noPermission: 'No tienes permiso para usar carpetas personalizadas. Comunícate con ventas para comprar esta función antes de usarla.',
    enableCustomFolder: 'Habilitar carpetas personalizadas',
    exporttagTip: 'Al exportar etiqueta PDF e imagen simultáneamente, se envía PDF por defecto'
    },
  paibanTask: {
    pausedTip: 'Máquina integrada de puerta, pared y gabinete',
    deleteTip: '¿Está seguro de querer eliminar la tarea «{taskBatch}»? No se puede recuperar después de la eliminación.',
    continueTip: 'Continuar con la tarea',
    completed: 'Completado',
    failed: 'Tarea fallida',
    paused: 'Pausado',
    pending: 'Pendiente',
    running: 'En ejecución',
    extraTip: 'La tarea de disposición solo muestra los datos de la semana pasada. Por favor, guarde la tarea en el historial después de completarla!',
    taskStatus: 'Estado de la tarea',
    createTaskTip: 'Crear tarea de disposición, entrar a disposición',
    taskBatchTitle: 'Lote de tareas',
    relatedOrderNosTitle: 'Números de pedido relacionados',
    progressTitle: 'Progreso de disposición',
    boardCountTitle: 'Uso de tablero estimado',
    optimizedAreaTitle: 'Área optimizada estimada',
    productionLineTitle: 'Línea de producción',
    operationTitle: 'Acciones',
    optimizeRateTitle: 'Estimación de tasa de optimización',
    optimizeRateTip: 'La tasa de optimización de materiales sobrantes cortados automáticamente no se calcula.',
    optimizeRateTip2: 'La tasa de optimización específica se basa en la página de disposición',
    boardCountTip: 'El uso específico de tableros se basa en la página de disposición',
    optimizedAreaTip: 'Área optimizada específica se basa en la página de disposición',
    paibanSettingTip: 'Las configuraciones de la línea de producción para la tarea actual han sido modificadas. Los resultados de la disposición actual pueden conflictuar con los archivos de exportación de producción reales. Se recomienda volver a organizar la producción.',
    dataException: 'Excepción de datos, por favor actualice la página y vuelva a intentarlo'
    },
  paibanSetting: {
    advancedSetting: 'Configuración avanzada',
    advancedFeature: 'Características avanzadas',
    surplusCutSpeedUp: 'Aceleración automática de corte de sobras',
    surplusCutSpeedUpTip4: 'La funcionalidad está en desarrollo, por favor espere',
    surplusCutSpeedUpTip: 'El espacio de disposición de sobras se establece automáticamente en 0',
    surplusCutSpeedUpTip2: 'El corte de sobras omite automáticamente rutas ya cortadas y de refilado para mejorar la eficiencia',
    surplusCutSpeedUpTip3: 'Esta función solo funciona para máquinas de grabado y máquinas de grabado de una vuelta (no use con corte de borde común o aceleración de borde común)',
    surplusCutSpeedUpTip5: 'Solo efectivo para máquinas de grabado y máquinas de grabado de una vuelta',
    featureDisplay: 'Visualización de funciones',
    featureDisplayTip: 'Esta página solo controla si se muestran las entradas de funciones; no modifica el estado de activación ni la configuración de parámetros de la propia función'
    },
  alignedPlan: {
    deepSearch: 'Búsqueda profunda',
    deepSearchTip: 'Función exclusiva: aumente la profundidad de cálculo reorganizando para obtener mejores resultados',
    deepSearchTip2: 'Tras actualizar Deep Search, reorganice para aumentar la profundidad de cálculo. Ahora disponible en prueba',
    deepSearchTip3: 'Deep Search ofrece un esquema que ahorra más tableros',
    deepSearchTip4: 'Actualmente no tiene permiso de nesting Deep Search. Contacte a ventas para comprar.',
    deepSearchTip5: 'Tras actualizar Deep Search, disfrute de potencia de servidor dedicada para mejor calidad. Vista previa disponible ahora'
    }
  }